module.exports = {
	', "rejected" - отклонено, "trash" - невалидный)': {
		'ru': ', "rejected" - отклонено, "trash" - невалидный)',
		'uk': ', "rejected" - відхилено, "trash" - невалідний)',
		'en': ', "approved", "rejected")',
		'de': ', "rejected" - abgelehnt, "trash" - Müll',
		'vi': ', "rejected" - bị từ chối, "trash" - không hợp lệ)',
		'th': ', "ปฏิเสธ" - ปฏิเสธ "ถังขยะ" - ไม่ถูกต้อง)'
	},
	'№': {
		'ru': '№',
		'uk': '№',
		'en': '#',
		'de': '#',
		'vi': '#',
		'th': '#'
	},
	'("pending" - ожидает обработки, "approved" - подтверждено, "rejected" - отклонено, "trash" - невалидный)': {
		'ru': '("pending" - ожидает обработки, "approved" - подтверждено, "rejected" - отклонено, "trash" - невалидный)',
		'uk': '("pending" - очікоє обработку, "approved" - підтвержено, "rejected" - відхилено, "trash" - невалідний)',
		'en': '("pending" - processing, "trash" - invalid, "approved", "rejected")',
		'de': '("pending" - im Wartezustand, "approved"- bestätigt, "rejected" - abgelehnt , "trash" - Müll',
		'vi': '("pending" - đang chờ xử lý, "approved" - xác nhận, "rejected" - bị từ chối, "trash" - không hợp lệ)',
		'th': 'การค้างอยู่ การรอดำเนินการ อนุมัติแล้ว ยืนยันแล้ว ปฏิเสธแล้ว ปฏิเสธแล้ว ขยะ-ใช้ไม่ได้'
	},
	'(в том числе для поддоменов)': {
		'ru': '(в том числе для поддоменов)',
		'uk': '(в тому числі для піддоменів)',
		'en': '(including subdomains)',
		'de': '(einschließlich Subdomains)',
		'vi': '(bao gồm cả tên các miền phụ)',
		'th': 'รวมถึงเวบไซต์ย่อย'
	},
	'1) Работали ли вы с другими партнерскими сетями?': {
		'ru': '1) Работали ли вы с другими партнерскими сетями?',
		'uk': '1) Чи ви працювали з іншипи партнерськими мережами?',
		'en': '1) Have you worked with other affiliate networks?',
		'de': '1) Haben Sie mit anderen Affiliate-Netzwerken gearbeitet?',
		'vi': '1) Bạn có từng làm việc với các mạng đối tác khác chưa?',
		'th': '1) คุณทำงานร่วมกับเครือข่ายหรือพันธมิตรธุรกิจอื่นๆหรือไม่?'
	},
	'2) Какие источники трафика планируете использовать в своей работе?': {
		'ru': '2) Какие источники трафика планируете использовать в своей работе?',
		'uk': '2) Які джерела трафіка використовуєте в своїй роботі?',
		'en': '2) What traffic sources are you planning to use?',
		'de': '2) Welche Traffic-Quellen möchten Sie verwenden?',
		'vi': '2) Bạn dự định sử dụng những nguồn lưu lượng truy cập nào trong công việc của bạn?',
		'th': '2) คุณวางแผนว่าจะใช้ผู้เข้าชมจากไหนเพื่อการทำงานของคุณ?'
	},
	CR: { 'ru': 'CR', 'uk': 'CR', en: 'CR', de: 'CR', vi: 'CR', th: 'CR' },
	'Current month': {
		'ru': 'Текущий месяц',
		'uk': 'Поточний місяць',
		'en': 'Current month',
		'de': 'Aktueller Monat',
		'vi': 'Tháng này',
		'th': 'เดือนปัจจุบัน'
	},
	'Email-рассылка': {
		'ru': 'Email-рассылка',
		'uk': 'Email-розсилка',
		'en': 'Email-marketing',
		'de': 'E-Mail-Marketing',
		'vi': 'Phân phối email',
		'th': 'ส่งลิ้งค์ทางอีเมล์'
	},
	EPC: { 'uk': 'EPC', 'ru': 'EPC', en: 'EPC', de: 'EPC', vi: 'EPC', th: 'EPC' },
	eur_s: { 'uk': 'Евро', 'ru': 'Евро', en: 'Euro', de: 'Euro', vi: 'Euro', th: 'เงินยูโร' },
	'id потока': {
		'ru': 'id потока',
		'uk': 'id потоку',
		'en': 'Campaign id',
		'de': 'Kampagne-ID',
		'vi': 'id luồng',
		'th': 'การเรียกดูภาพที่ระบุชื่อผู้ใช้งาน'
	},
	'IP адрес пользователя': {
		'ru': 'IP адрес пользователя',
		'uk': 'IP адреса користувача',
		'en': 'user\'s IP',
		'de': 'IP Benutzer',
		'vi': 'Địa chỉ IP của người dùng',
		'th': 'ที่อยู่IPของผู้ใช้'
	},
	'Last month': {
		'ru': 'Прошлый месяц',
		'uk': 'Минулий місяць',
		'en': 'Last month',
		'de': 'Voriger Monat',
		'vi': 'Tháng trước',
		'th': 'เดือนที่แล้ว'
	},
	'Total leads': {
		'ru': 'Всего лидов',
		'uk': 'Всього лідів',
		'en': 'Total leads',
		'de': 'Total leads',
		'vi': 'Total leads',
		'th': 'Total leads'
	},
	'Rejected leads': {
		'ru': 'Отмена',
		'uk': 'Відміна',
		'en': 'Rejected leads',
		'de': 'Rejected leads',
		'vi': 'Rejected leads',
		'th': 'Rejected leads'
	},
	'Hold leads': {
		'ru': 'Холд',
		'uk': 'Холд',
		'en': 'Hold leads',
		'de': 'Hold leads',
		'vi': 'Hold leads',
		'th': 'Hold leads'
	},
	'Approved leads': {
		'ru': 'Апрув',
		'uk': 'Апрув',
		'en': 'Approved leads',
		'de': 'Approved leads',
		'vi': 'Approved leads',
		'th': 'Approved leads'
	},
	'Trash leads': {
		'ru': 'Треш',
		'uk': 'Треш',
		'en': 'Trash leads',
		'de': 'Trash leads',
		'vi': 'Trash leads',
		'th': 'Trash leads'
	},
	'Last week': {
		'ru': 'Прошлая неделя',
		'uk': 'Минулий тиждень',
		'en': 'Last week',
		'de': 'Letzte Woche',
		'vi': 'Tuần trước',
		'th': 'สัปดาห์ที่แล้ว'
	},
	'payout creation': {
		'ru': 'создание выплаты',
		'uk': 'створення виплати',
		'en': 'payout creation',
		'de': 'erstellte Zahlung',
		'vi': 'tạo thanh toán',
		'th': 'การสร้างการจ่ายเงิน'
	},
	'payout paid': {
		'ru': 'оплата выплаты',
		'uk': 'оплата пейаута',
		'en': 'payout paid',
		'de': 'ausbezahlt',
		'vi': 'thanh toán',
		'th': 'การชำระการจ่ายเงิน'
	},
	'payout rejection': {
		'ru': 'отклонение выплаты',
		'uk': 'відхилення виплати',
		'en': 'payout rejection',
		'de': 'abgelehnten Zahlung',
		'vi': 'từ chối thanh toán',
		'th': 'การปฏิเสธการจ่ายเงิน'
	},
	'recommended': {
		'ru': 'Рекомендуем',
		'uk': 'Рекомендуємо',
		'en': 'Recommended',
		'de': 'Empfohlen',
		'vi': 'Được đề xuất',
		'th': 'แนะนำ'
	},
	rub_s: {
		'ru': 'Рубли',
		'uk': 'Рублі',
		'en': 'Rubles',
		'de': 'Rubel',
		'vi': 'Rúp',
		'th': 'เงินรูเบิลรัสเซีย'
	},
	'This week': {
		'ru': 'Текущая неделя',
		'uk': 'Поточний тиждень',
		'en': 'This week',
		'de': 'Diese Woche',
		'vi': 'Tuần này',
		'th': 'สัปดาห์นี้'
	},
	'This year': {
		'ru': 'Текущий год',
		'uk': 'Поточний рік',
		'en': 'This year',
		'de': 'Dieses Jahr',
		'vi': 'Năm nay',
		'th': 'ปีนี้'
	},
	Today: {
		'ru': 'Сегодня',
		'uk': 'Сьогодні',
		'en': 'Today',
		'de': 'Heute',
		'vi': 'Hôm nay',
		'th': 'วันนี้'
	},
	'Today and yesterday': {
		'ru': 'Сегодня и вчера',
		'uk': 'Сьогодні і вчора',
		'en': 'Today and yesterday',
		'de': 'Heute und gestern',
		'vi': 'Hôm nay và hôm qua',
		'th': 'วันนี้และเมื่อวานนี้'
	},
	'top': {
		'ru': 'Топ',
		'uk': 'Топ',
		'en': 'Top',
		'de': 'Top',
		'vi': 'Hàng đầu',
		'th': 'ด้านบน'
	},
	'Заработано за CPL лид': {
		'ru': 'Заработано за CPL лид',
		'uk': 'Зароблено за CPL лід',
		'en': 'Earned per CPL lead',
		'de': 'Earned per CPL lead',
		'vi': 'Earned per CPL lead',
		'th': 'Earned per CPL lead'
	},
	'Начислен бонус за CPL лид': {
		'ru': 'Начислен бонус за CPL лид',
		'uk': 'Нарахований бонус за CPL лід',
		'en': 'Bonus for CPL lead',
		'de': 'Bonus for CPL lead',
		'vi': 'Bonus for CPL lead',
		'th': 'Bonus for CPL lead'
	},
	'Отклонен бонус за CPL лид': {
		'ru': 'Отклонен бонус за CPL лид',
		'uk': 'Відхилено бонус за CPL лід',
		'en': 'Withdrawn bonus for CPL lead',
		'de': 'Withdrawn bonus for CPL lead',
		'vi': 'Withdrawn bonus for CPL lead',
		'th': 'Withdrawn bonus for CPL lead'
	},
	'Отклонено за CPL лид': {
		'ru': 'Отклонено за CPL лид',
		'uk': 'Відхилено за CPL лід',
		'en': 'Withdrawn for CPL lead',
		'de': 'Withdrawn for CPL lead',
		'vi': 'Withdrawn for CPL lead',
		'th': 'Withdrawn for CPL lead'
	},
	'URL потока': {
		'ru': 'URL потока',
		'uk': 'URL потока',
		'en': 'URL of campaign',
		'de': 'die URL des kampagen',
		'vi': 'URL luồng',
		'th': 'การไหลเวียนข้อมูลในเครือข่ายของURL'
	},
	usd_s: {
		'ru': 'Доллары',
		'uk': 'Доллари',
		'en': 'US Dollars',
		'de': 'US-Dollars',
		'vi': 'Đô la',
		'th': 'เงินดอลล่า'
	},
	'UTM метки вместо SID': {
		'ru': 'UTM метки вместо SID',
		'uk': 'UTM мітки замість SID',
		'en': 'UTM marks instead of SID',
		'de': 'UTM-Metriken statt SID',
		'vi': 'Dấu UTM thay vì SID',
		'th': 'เครื่องหมาย UTM แทน SID'
	},
	Yesterday: {
		'ru': 'Вчера',
		'uk': 'Вчора',
		'en': 'Yesterday',
		'de': 'Gestern',
		'vi': 'Hôm qua',
		'th': 'เมื่อวานนี้'
	},
	'Авторский': {
		'ru': 'Авторский',
		'uk': 'Авторський',
		'en': 'Exclusive',
		'de': 'Exklusiv',
		'vi': 'Bản quyền',
		'th': 'ของผู้เขียน'
	},
	'Авто': {
		'ru': 'Авто',
		'uk': 'Авто',
		'en': 'Auto',
		'de': 'Auto',
		'vi': 'Auto',
		'th': 'Auto'
	},
	'Автоначисление': {
		'ru': 'Автоначисление',
		'uk': 'Автонарахування',
		'en': 'Auto payout',
		'de': 'Automatische Auszahlung',
		'vi': 'thanh toán tự động',
		'th': 'การจ่ายเงินอัตโนมัติ'
	},
	'Автосписание': {
		'ru': 'Автосписание',
		'uk': 'Автосписання',
		'en': 'Auto write-off',
		'de': 'Automatische Abschreibung',
		'vi': 'Tự động xóa sổ',
		'th': 'การตัดบัญชีอัตโนมัติ'
	},
	'баланс': {
		'ru': 'баланс',
		'uk': 'баланс',
		'en': 'balance',
		'de': 'Saldo',
		'vi': 'Số dư',
		'th': 'ยอดคงเหลือ'
	},
	'Баланс': {
		'ru': 'Баланс',
		'uk': 'Баланс',
		'en': 'Balance',
		'de': 'Saldo',
		'vi': 'Số dư',
		'th': 'เงินที่เหลือ'
	},
	'Баннерная реклама': {
		'ru': 'Баннерная реклама',
		'uk': 'Банерна реклама',
		'en': 'Banner advertising',
		'de': 'Bannerwerbung',
		'vi': 'Quảng cáo bảng hiệu',
		'th': 'แบนเนอร์โฆษณา'
	},
	'Блог': { 'ru': 'Блог', 'uk': 'Блог', en: 'Blog', de: 'Blog', vi: 'Blog', th: 'บล็อก' },
	'Брокеры': {
		'ru': 'Брокеры',
		'uk': 'Брокери',
		'en': 'Brokers',
		'de': 'Brokers',
		'vi': 'Công ty chứng khoán',
		'th': 'โบรกเกอร์'
	},
	'Бонусные': {
		'ru': 'Бонусные',
		'uk': 'Бонусні',
		'en': 'Bonus',
		'de': 'Bonus',
		'vi': 'tiền thưởng',
		'th': 'โบนัส'
	},
	'будут заменены на соответствующие значения.': {
		'ru': ' будут заменены на соответствующие значения.',
		'uk': ' будуть заменені на відповідні значення.',
		'en': ' will be replaced with corresponding values.',
		'de': 'werden durch entsprechende Werte ersetzt.',
		'vi': 'sẽ được thay thế thành các giá trị tương ứng.',
		'th': 'จะถูกแทนที่โดยความหมยที่สอดคล้อง'
	},
	'В момент перехода макросы': {
		'ru': 'В момент перехода макросы',
		'uk': 'В момент перехода макроси',
		'en': 'At the moment of postback, macroses',
		'de': 'Zum Zeitpunkt des Übergangs, Macroses',
		'vi': 'Tại thời điểm chuyển đổi macro',
		'th': 'ในเวลาของการแปลงภาพ กลุ่มคำสั่งที่ทำงานโดยอัตโนมัติ'
	},
	'В обработке': {
		'ru': 'В обработке',
		'uk': 'В обробці',
		'en': 'Pending',
		'de': 'Im Wartezustand',
		'vi': 'Đang xử lý',
		'th': 'กำลังดำเนินการ'
	},
	'В случае, если в url был передан sid и соответствующая ему метка (например': {
		'ru': 'В случае, если в url был передан sid и соответствующая ему метка (например',
		'uk': 'У випадку, якщо в url був передан sid и відповідна йому мітка (наприклад',
		'en': 'In the event that the sid and the corresponding label were passed to the url (for example',
		'de': 'Für den Fall, wenn Sid und das entsprechende Label an die URL übergeben wurden (zum Beispiel',
		'vi': 'Trong trường hợp nếu url và dấu tương ứng được chuyển đến sid (ví dụ:',
		'th': 'ในเหตุการณ์ที่ตัวระบุความปลอดภัยและป้ายกำกับที่สอดคล้องกันถูกส่งผ่านไปยังURLดังตัวอย่างเช่น'
	},
	'В такой ситуации срабатывать будет постбэк, указанные в потоке.': {
		'ru': 'В такой ситуации срабатывать будет постбэк, указанные в потоке.',
		'uk': 'В такій ситуації спрацьовувати буде постбек, вказаний в потоці.',
		'en': 'In this situation, the postback, specified in the campaign, will fire.',
		'de': 'In dieser Situation wird das im kampagen angegebene Postback ausgelöst.',
		'vi': 'Trong trường hợp này posrback được xác định trong luồng sẽ hoạt động.',
		'th': 'ในสถานการณ์นี้ การย้อนกลับไปที่ระบุในการเรียกดูภาพจะหายไป'
	},
	'Валюта': {
		'ru': 'Валюта',
		'uk': 'Валюта',
		'en': 'Currency',
		'de': 'Währung',
		'vi': 'Tiền tệ',
		'th': 'สกุลเงิน'
	},
	'Валюта выплаты': {
		'ru': 'Валюта выплаты',
		'uk': 'Валюта виплати',
		'en': 'Payout currency',
		'de': 'Währung der Auszahlung',
		'vi': 'Tiền tệ thanh toán',
		'th': 'สกุลเงินที่ให้ชำระคืน'
	},
	'ГЕО потока': {
		'ru': 'ГЕО потока',
		'uk': 'ГЕО потока',
		'en': 'Campaign geo',
		'de': 'GEO-Kampagnen',
		'vi': 'Các chiến dịch GEO',
		'th': 'แคมเปญ GEO'
	},
	'Причина отмены': {
		'ru': 'Причина отмены',
		'uk': 'Причина відміни',
		'en': 'Cancellation reason',
		'de': 'Stornierungsgrund',
		'vi': 'Lý do hủy',
		'th': 'เหตุผลในการยกเลิก'
	},
	'валюта выплаты': {
		'ru': 'валюта выплаты',
		'uk': 'валюта виплати',
		'en': 'payout currency',
		'de': 'Währung der Auszahlung',
		'vi': 'tiền tệ thanh toán',
		'th': 'สกุลเงินที่ให้ชำระคืน'
	},
	'выкуп': {
		'ru': 'выкуп',
		'uk': 'викуп',
		'en': 'redeem',
		'de': 'Rückkauf',
		'vi': 'mua lại',
		'th': 'ค่าไถ่'
	},
	'Валюты баланса': {
		'ru': 'Валюты баланса',
		'uk': 'Валюти баланса',
		'en': 'Balance currencies',
		'de': 'Währung Balance',
		'vi': 'Đơn vị tiền tệ số dư',
		'th': 'สกุลเงินคงเหลือ'
	},
	'Ваш': {
		'ru': 'Ваш',
		'uk': 'Ваш',
		'en': 'Your',
		'de': 'Ihre',
		'vi': 'Của bạn',
		'th': 'ของคุณ'
	},
	'Ваш аккаунт заблокирован': {
		'ru': 'Ваш аккаунт заблокирован',
		'uk': 'Ваш аккаунт заблоковано',
		'en': 'Your account is banned',
		'de': 'Ihr Konto wurde gesperrt',
		'vi': 'Tài khoản của bạn đã bị tạm ngưng',
		'th': 'บัญชีคุณถูกระงับ'
	},
	'Аккаунты Facebook': {
		'ru': 'Аккаунты Facebook',
		'uk': 'Аккаунти Facebook',
		'en': 'Facebook accounts',
		'de': 'Facebook accounts',
		'vi': 'Facebook accounts',
		'th': 'Facebook accounts'
	},
	'БМ Аккаунты': {
		'ru': 'БМ Аккаунты',
		'uk': 'БМ Аккаунти',
		'en': 'BM accounts',
		'de': 'BM accounts',
		'vi': 'BM accounts',
		'th': 'BM accounts'
	},
	'Бизнес Менеджер аккаунты от партнеров': {
		'ru': 'Бизнес Менеджер аккаунты от партнеров',
		'uk': 'Бізнес Менеджер аккаунти від партнерів',
		'en': 'Business Manager accounts from partners',
		'de': 'Business Manager accounts from partners',
		'vi': 'Business Manager accounts from partners',
		'th': 'Business Manager accounts from partners'
	},
	'Пользуйся качественными проверенными аккаунтами': {
		'ru': 'Пользуйся качественными проверенными аккаунтами',
		'uk': 'Користуйся якісними перевіреними аккаунтами',
		'en': 'Use qualitative verified accounts',
		'de': 'Use qualitative verified accounts',
		'vi': 'Use qualitative verified accounts',
		'th': 'Use qualitative verified accounts'
	},
	'Веб-сайты': {
		'ru': 'Веб-сайты',
		'uk': 'Веб-сайти',
		'en': 'Websites',
		'de': 'Websites',
		'vi': 'Các trang web',
		'th': 'เว็บไซต์'
	},
	'Для того, чтобы получить доступы к купленному аккаунту свяжитесь пожалуйста с менеджером': {
		'ru': 'Для того, чтобы получить доступы к купленному аккаунту свяжитесь пожалуйста с менеджером',
		'uk': 'Для того, щоб отримати доступи до купленого аккаунта звяжіться з менеджером',
		'en': 'In order to get access to the purchased account, please contact the manager',
		'de': 'In order to get access to the purchased account, please contact the manager',
		'vi': 'In order to get access to the purchased account, please contact the manager',
		'th': 'In order to get access to the purchased account, please contact the manager'
	},
	'Связаться с менеджером': {
		'ru': 'Связаться с менеджером',
		'uk': 'Звяжіться с менеджером',
		'en': 'Contact the manager',
		'de': 'Contact the manager',
		'vi': 'Contact the manager',
		'th': 'Contact the manager'
	},
	'Покупка Бизнес Менеджер аккаунта': {
		'ru': 'Покупка Бизнес Менеджер аккаунта',
		'uk': 'Покупка Бізнес Менеджер аккаунта',
		'en': 'Purchase Business Manager Account',
		'de': 'Purchase Business Manager Account',
		'vi': 'Purchase Business Manager Account',
		'th': 'Purchase Business Manager Account'
	},
	'Спасибо!': {
		'ru': 'Спасибо!',
		'uk': 'Дякую!',
		'en': 'Thank you!',
		'de': 'Thank you!',
		'vi': 'Thank you!',
		'th': 'Thank you!'
	},
	'Аккаунт': {
		'ru': 'Аккаунт',
		'uk': 'Аккаунт',
		'en': 'Account',
		'de': 'Account',
		'vi': 'Account',
		'th': 'Account'
	},
	'Купить': {
		'ru': 'Купить',
		'uk': 'Купіть',
		'en': 'Order',
		'de': 'Order',
		'vi': 'Order',
		'th': 'Order'
	},
	'Стоимость': {
		'ru': 'Стоимость',
		'uk': 'Вартість',
		'en': 'Price',
		'de': 'Price',
		'vi': 'Price',
		'th': 'Price'
	},
	'аккаунт': {
		'ru': 'аккаунт',
		'uk': 'аккаунт',
		'en': 'account',
		'de': 'account',
		'vi': 'account',
		'th': 'account'
	},
	'Доступно': {
		'ru': 'Доступно',
		'uk': 'Доступно',
		'en': 'Available',
		'de': 'Available',
		'vi': 'Available',
		'th': 'Available'
	},
	'С вашего баланса будет списано': {
		'ru': 'С вашего баланса будет списано',
		'uk': 'З вашого баланса буде списано',
		'en': 'Your balance will be debited',
		'de': 'Your balance will be debited',
		'vi': 'Your balance will be debited',
		'th': 'Your balance will be debited'
	},
	'Веб-сайт': {
		'ru': 'Веб-сайт',
		'uk': 'Веб-сайт',
		'en': 'Website',
		'de': 'Website',
		'vi': 'Các trang web',
		'th': 'เว็บไซต์'
	},
	'Перейти': {
		'ru': 'Перейти',
		'uk': 'Перейти',
		'en': 'Go to',
		'de': 'Go to',
		'vi': 'Go to',
		'th': 'Go to'
	},
	'Вебмастеру': {
		'ru': 'Вебмастеру',
		'uk': 'Вебмайстру',
		'en': 'For webmasters',
		'de': 'Für Webmaster',
		'vi': 'Cho Webmaster',
		'th': 'เว็บมาสเตอร์'
	},
	'Внимание!': {
		'ru': 'Внимание!',
		'uk': 'Увага!',
		'en': 'Attention!',
		'de': 'Achtung!',
		'vi': 'Xin chú ý!',
		'th': 'โปรดทราบ!'
	},
	'Введите ссылку на лендинг': {
		'ru': 'Введите ссылку на лендинг',
		'uk': 'Введість лінк на лендінг',
		'en': 'Enter link to landing',
		'de': 'Enter link to landing',
		'vi': 'Enter link to landing',
		'th': 'Enter link to landing'
	},
	'любой URL или его часть': {
		'ru': 'любой URL или его часть',
		'uk': 'будь-який URL або його частина',
		'en': 'any URL of its part',
		'de': 'any URL of its part',
		'vi': 'any URL of its part',
		'th': 'any URL of its part'
	},
	'Предупреждение': {
		'ru': 'Предупреждение',
		'uk': 'Попередження',
		'en': 'Attention',
		'de': 'Achtung',
		'vi': 'Xin chú ý',
		'th': 'โปรดทราบ'
	},
	'Сохранить в html': {
		'ru': 'Сохранить в html',
		'uk': 'Зберегти в html',
		'en': 'Download as html',
		'de': 'Download as html',
		'vi': 'Download as html',
		'th': 'Download as html'
	},
	'Сохранить в php': {
		'ru': 'Сохранить в php',
		'uk': 'Зберегти в php',
		'en': 'Download as php',
		'de': 'Download as php',
		'vi': 'Download as php',
		'th': 'Download as php'
	},
	'Для работы потока по API необходимо качать архив в php': {
		'ru': 'Для работы потока по API необходимо качать архив в php',
		'uk': 'Для работи потоку по API необхідно качати архів в php',
		'en': 'For the flow to work via API, you need to download the archive in php',
		'de': 'For the flow to work via API, you need to download the archive in php',
		'vi': 'For the flow to work via API, you need to download the archive in php',
		'th': 'For the flow to work via API, you need to download the archive in php'
	},
	'Нужно сохранить поток': {
		'ru': 'Обратите внимание, что вы скачиваете лендинг без преднастроенного API. Чтобы API было автоматически настроено, сначала сохраните поток и зайдите в его редактирование.',
		'uk': 'Зверніть увагу, що ви скачуєте лендінг без передналаштованого API. Щоб API було автоматично налаштовано, спочатку збережіть потік і зайдіть в його редагування.',
		'en': 'Please note that you are downloading a promo without a pre-configured API. If you want to have automatically configured API, first save the сampaign and then open it in edit mode.',
		'de': 'Bitte beachten Sie, dass Sie eine Promo ohne vorkonfigurierte API herunterladen. Damit die API automatisch konfiguriert wird, speichern Sie zuerst die Kampagne und bearbeiten Sie ihn.',
		'vi': 'Xin lưu ý rằng bạn đang tải xuống quảng cáo mà không có API được định cấu hình trước. Để API được định cấu hình tự động, trước tiên hãy lưu luồng và chỉnh sửa nó.',
		'th': 'โปรดทราบว่าคุณกำลังดาวน์โหลดโปรโมชันโดยไม่มี API ที่กำหนดไว้ล่วงหน้า เพื่อให้กำหนดค่า API โดยอัตโนมัติให้บันทึกสตรีมก่อนแล้วไปแก้ไข'
	},
	'Выберите гео для лендинга:': {
		'ru': 'Выберите гео для лендинга:',
		'uk': 'Виберіть гео для лендінгу:',
		'en': 'Select a geo for your landing page:',
		'de': 'Wählen Sie ein Geo für Ihre Zielseite aus:',
		'vi': 'Chọn địa lý cho trang đích của bạn:',
		'th': 'เลือกภูมิศาสตร์สำหรับหน้า Landing Page ของคุณ:'
	},
	'Выберите тип лида': {
		'ru': 'Выберите тип лида',
		'uk': 'Виберіть тип ліда',
		'en': 'Select lead type',
		'de': 'Select lead type',
		'vi': 'Select lead type',
		'th': 'Select lead type'
	},
	'Выберите страну для лендинга': {
		'ru': 'Выберите страну для лендинга',
		'uk': 'Виберіть країну для лендінгу',
		'en': 'Select country for your landing',
		'de': 'Wählen Sie das Land für Ihre Landung aus',
		'vi': 'Chọn quốc gia cho điểm hạ cánh của bạn',
		'th': 'เลือกประเทศสำหรับการลงจอดของคุณ'
	},
	'(можно оставить поле пустым, но тогда потребуется отредактировать ссылки для перехода на лендинг вручную)': {
		'ru': '(можно оставить поле пустым, но тогда потребуется отредактировать ссылки для перехода на лендинг вручную)',
		'uk': '(можно залишити поле пустим, але тоді треба відредагувати посилання для переходу на лендінг вручну)',
		'en': '(you can leave the field blank, but then you will need to edit the links to landing manually)',
		'de': '(Sie können das Feld leer lassen, müssen dann aber die Links zur Landung manuell bearbeiten)',
		'vi': '(bạn có thể để trống trường, nhưng sau đó bạn sẽ cần chỉnh sửa các liên kết đến đích theo cách thủ công)',
		'th': '(คุณสามารถเว้นช่องว่างไว้ได้ แต่คุณจะต้องแก้ไขลิงก์ไปยังการเชื่อมโยงไปถึงด้วยตนเอง)'
	},
	'воскресенье': {
		'ru': 'воскресенье',
		'uk': 'неділя',
		'en': 'sunday',
		'de': 'Sonntag',
		'vi': 'chủ nhật',
		'th': 'วันอาทิตย์'
	},
	'Время': {
		'ru': 'Время',
		'uk': 'Час',
		'en': 'Time',
		'de': 'Zeit',
		'vi': 'Thời gian',
		'th': 'เวลา'
	},
	'Время ответа обратной связи от мгновенного до': {
		'ru': 'Время ответа обратной связи от мгновенного до 3-х суток (если письмо отправлено в выходные дни).',
		'uk': 'Час відповіді зворотного зв\'язку — від миттєвого до 3-х діб (якщо лист надіслано у вихідні дні).',
		'en': 'The response time is from instantaneous to 3 days (if the ticket is sent on weekends).',
		'de': 'Die Ant­wort­zeit ist ab sofort bis 3 Tage',
		'vi': 'Thời gian phản hồi là từ phản hồi ngay lập tức cho đến 3 ngày (nếu thư được gửi vào cuối tuần).',
		'th': 'ระยะเวลาการตอบคือตอบกลับทันทีจนถึงไม่เกิน3วัน(ถ้าจดหมายถูกส่งมาช่วงเสาร์ - อาทิตย์)'
	},
	'время отправки postback запроса (unix timestamp)': {
		'ru': 'время отправки postback запроса (unix timestamp)',
		'uk': 'час відправки postback запиту (unix timestamp)',
		'en': 'timestamp of postback request ()unix timestamp)',
		'de': 'Zeit der Postback-Anfrage (unix timestamp)',
		'vi': 'thời gian gửi yêu cầu postback (unix timestamp)',
		'th': 'เวลาของการส่งคำร้องการโพสต์ย้อนกลับ(เวลามาตรฐาน)'
	},
	'Все новости': {
		'ru': 'Все новости',
		'uk': 'Всі новини',
		'en': 'All news',
		'de': 'Alle Nachrichten',
		'vi': 'Tất cả tin tức',
		'th': 'ข่าวสารทั้งหมด'
	},
	'Все офферы': {
		'ru': 'Все офферы',
		'uk': 'Всі оффери',
		'en': 'All offers',
		'de': 'Alle Angebote',
		'vi': 'Tất cả các offer',
		'th': 'ข้อเสนอทั้งหมด'
	},
	'Все системы': {
		'ru': 'Все системы',
		'uk': 'Всі системи',
		'en': 'All systems',
		'de': 'Alle Systeme',
		'vi': 'Tất cả các hệ thống',
		'th': 'ระบบทั้งหมด'
	},
	'Всего': {
		'ru': 'Всего',
		'uk': 'Всього',
		'en': 'Total',
		'de': 'Gesamt',
		'vi': 'Tất cả',
		'th': 'ทั้งหมด'
	},
	'вторник': {
		'ru': 'вторник',
		'uk': 'вівторок',
		'en': 'tuesday',
		'de': 'Dienstag',
		'vi': 'thứ ba',
		'th': 'วันอังคาร'
	},
	'Второй параметр': {
		'ru': 'Второй параметр',
		'uk': 'Другий параметр',
		'en': 'Second setting',
		'de': 'Zweite Parameter',
		'vi': 'Tham số thứ hai',
		'th': 'ค่าตัวแปรอันดับที่สอง'
	},
	'Вы': { 'ru': 'Вы', 'uk': 'Ви', en: 'You', de: 'Sie', vi: 'Bạn', th: 'คุณ' },
	'Вы пытаетесь добавить ответ от веба. Уверены?': {
		'ru': 'Вы пытаетесь добавить ответ от веба. Уверены?',
		'uk': 'Ви намагаєтесь додати відповідь від веба. Впевнені?',
		'en': 'You are trying to add a response from the affiliate. Sure?',
		'de': 'Sie versuchen eine Antwort von dem Affiliate hinzuzufügen. Sind Sie sicher?',
		'vi': 'Bạn đang thêm phản hồi từ web. Bạn có chắc chắn không?',
		'th': 'คุณกำลังพยายามเพิ่มการตอบกลับจากเว็บ คุณแน่ใจหรือไม่'
	},
	'Вы пытаетесь добавить тикет от веба. Уверены?': {
		'ru': 'Вы пытаетесь добавить тикет от веба. Уверены?',
		'uk': 'Ви намагаєтесь додати тікет від веба. Впевнені?',
		'en': 'You are trying to add a ticket from the affiliate. Sure?',
		'de': 'Sie versuchen ein Ticket von dem Affiliate hinzuzufügen. Sind Sie sicher?',
		'vi': 'Bạn đang thêm một ticket từ web. Bạn có chắc chắn không?',
		'th': 'คุณกำลังพยายามเพิ่มหมายเลขที่สร้างขึ้นโดยผู้ให้บริการเครือข่ายสำหรับลูกค้าจากเวบ คุณแน่ใจหรือไม่'
	},
	'Вы точно хотите удалить?': {
		'ru': 'Вы точно хотите удалить?',
		'uk': 'Ви точно хочети видалити?',
		'en': 'Are you sure you want to delete this item?',
		'de': 'Wollen Sie dieses Element wirklich löschen?',
		'vi': 'Bạn có chắc chắn muốn xóa không?',
		'th': 'แน่ใจหรือว่าต้องการลบ?'
	},
	'Вы точно хотите архивировать?': {
		'ru': 'Вы точно хотите архивировать?',
		'uk': 'Ви точно хочете архівувати?',
		'en': 'Are you sure you want to archive this item?',
		'de': 'Are you sure you want to archive this item?',
		'vi': 'Are you sure you want to archive this item?',
		'th': 'Are you sure you want to archive this item?'
	},
	'Склонировано с': {
		'ru': 'Склонировано с',
		'uk': 'Склоновано з',
		'en': 'Cloned from',
		'de': 'Geklont von',
		'vi': 'Nhân bản từ',
		'th': 'โคลนจาก'
	},
	'Выберите валюту выплаты': {
		'ru': 'Выберите валюту выплаты',
		'uk': 'Виберіть валюту виплати',
		'en': 'Select a payout currency',
		'de': 'Wählen Sie eine Auszahlungswährung',
		'vi': 'chọn loại tiền thanh toán',
		'th': 'เลือกสกุลเงินที่ใช้ชำระเงิน'
	},
	'Выберите лендинг': {
		'ru': 'Выберите лендинг',
		'uk': 'Виберить лендінг',
		'en': 'Select a landing page',
		'de': 'Wählen Sie "Landing Page" aus',
		'vi': 'Chọn landing',
		'th': 'เลือกบริษัทที่เป็นเวบไซต์สำหรับขายของ'
	},
	'Выберите метки': {
		'ru': 'Выберите метки',
		'uk': 'Виберить мітки',
		'en': 'Select a mark',
		'de': 'Wählen Sie eine Markierung',
		'vi': 'Chọn một dấu',
		'th': 'เลือกเครื่องหมาย'
	},
	'Выберите площадку': {
		'ru': 'Выберите площадку',
		'uk': 'Виберить площадку',
		'en': 'Select a source',
		'de': 'Wählen Sie einen Platz aus',
		'vi': 'Chọn trang web',
		'th': 'เลือกที่ตั้งหรือเวบไซต์'
	},
	'Выберите, пожалуйста, лендинг': {
		'ru': 'Выберите, пожалуйста, лендинг',
		'uk': 'Виберить лендінг',
		'en': 'Please, select a landing',
		'de': 'Wählen Sie bitte Landing aus',
		'vi': 'Làm ơn chọn Landing',
		'th': 'โปรดเลือกโฆษณาบนหน้าเว็บ'
	},
	'Выберите, пожалуйста, транзитную страницу': {
		'ru': 'Выберите, пожалуйста, транзитную страницу',
		'uk': 'Виберить транзитну сторінку',
		'en': 'Please, select a transit page',
		'de': 'Wählen Sie bitte "Transit Page" aus',
		'vi': 'Làm ơn chọn transit',
		'th': 'กรุณาเลือกหน้ารอเปลี่ยนไปยังหน้าอื่น'
	},
	'Выберите поток': {
		'ru': 'Выберите поток',
		'uk': 'Виберить потік',
		'en': 'Select a campaign',
		'de': 'Wählen Sie eine Kampagen aus',
		'vi': 'Chọn luồng',
		'th': 'เลือกการไหลของข้อมูลในเครือข่าย'
	},
	'Выберите программу': {
		'ru': 'Выберите программу',
		'uk': 'Виберіть програму',
		'en': 'Select an offer',
		'de': 'Wählen Sie ein Angebot aus',
		'vi': 'Chọn chương trình',
		'th': 'เลือกโปรแกรม'
	},
	'Выберите систему': {
		'ru': 'Выберите систему',
		'uk': 'Виберіть систему',
		'en': 'Select system',
		'de': 'Wählen Sie das System aus',
		'vi': 'Hãy chọn hệ thống',
		'th': 'เลือกระบบ'
	},
	'Выберите сплит-сессию': {
		'ru': 'Выберите сплит-сессию',
		'uk': 'Виберіть спліт-сесію',
		'en': 'Select a split session',
		'de': 'Wählen Sie "Split-Session" aus',
		'vi': 'Chọn một phiên tách',
		'th': 'เลือกการแยกประชุม'
	},
	'Выберите статус': {
		'ru': 'Выберите статус',
		'uk': 'Виберить статус',
		'en': 'Select a status',
		'de': 'Wählen Sie einen Status aus',
		'vi': 'Chọn trạng thái',
		'th': 'เลือกสถานะ'
	},
	'Выберите страну': {
		'ru': 'Выберите страну',
		'uk': 'Виберить країну',
		'en': 'Select a country',
		'de': 'Wählen Sie ein Land aus ',
		'vi': 'Chọn nước',
		'th': 'เลือกประเทศ'
	},
	'Выберите тип траффика': {
		'ru': 'Выберите тип траффика',
		'uk': 'Виберить тип трафіку',
		'en': 'Select traffic type',
		'de': 'Wählen Sie den Traffic-Typ aus',
		'vi': 'Chọn loại lưu lương',
		'th': 'เลือกประเภทการเข้ามาเยี่ยมชมเวบไซต์หรือจำนวนคนเข้าเวบ'
	},
	'Выберите тип потока': {
		'ru': 'Выберите тип потока',
		'uk': 'Виберить тип потоку',
		'en': 'Select campaign type',
		'de': 'Wählen Sie den Campaign-Typ aus',
		'vi': 'Chọn loại chiến dịch',
		'th': 'เลือกประเภทการไหล'
	},
	'Дата смены статуса': {
		'ru': 'Дата смены статуса',
		'uk': 'Дата зміни статусу',
		'en': 'Status change date',
		'de': 'Datum der Statusänderung',
		'vi': 'Ngày thay đổi trạng thái',
		'th': 'วันที่เปลี่ยนสถานะ'
	},
	'Выберите дату смены статуса': {
		'ru': 'Выберите дату смены статуса',
		'uk': 'Виберить дату зміни статусу',
		'en': 'Select the date of the status change',
		'de': 'Wählen Sie das Datum der Statusänderung',
		'vi': 'Chọn ngày thay đổi trạng thái',
		'th': 'เลือกวันที่เปลี่ยนสถานะ'
	},
	'Выберите транзитную страницу': {
		'ru': 'Выберите транзитную страницу',
		'uk': 'Виберить транзитку сторінку',
		'en': 'Select a transit page',
		'de': 'Wählen Sie "Transit Page" aus',
		'vi': 'Chọn trang transit',
		'th': 'เลือกหน้ารอเปลี่ยนไปยังหน้าอื่น'
	},
	'Выпл.': {
		'ru': 'Выпл.',
		'uk': 'Випл.',
		'en': 'Payout',
		'de': 'Aus.',
		'vi': 'Thanh toán',
		'th': 'ค่างวด'
	},
	'Выплаты': {
		'ru': 'Выплаты',
		'uk': 'Виплати',
		'en': 'Payouts',
		'de': 'Auszahlungen',
		'vi': 'Thanh toán',
		'th': 'ค่างวด'
	},
	'Гео': {
		'ru': 'Гео',
		'uk': 'Гео',
		'en': 'Location',
		'de': 'Geografie',
		'vi': 'Geo',
		'th': 'โลเคชั่น'
	},
	'Гео/ip': {
		'ru': 'Гео/ip',
		'uk': 'Гео/ip',
		'en': 'Geo/ip',
		'de': 'Geo/IP',
		'vi': 'Geo/ip',
		'th': 'Geo/ip'
	},
	'География': {
		'ru': 'География',
		'uk': 'Географія',
		'en': 'Geography',
		'de': 'Geografie',
		'vi': 'Địa lý',
		'th': 'ภูมิศาสตร์'
	},
	'Глобальный постбэк': {
		'ru': 'Глобальный постбэк',
		'uk': 'Глобальний постбек',
		'en': 'Global postback',
		'de': 'Global postback',
		'vi': 'Postback toàn cầu',
		'th': 'การส่งกลับการบันทึกข้อมูลตำแหน่งโลก'
	},
	'Глобальный постбэк будет срабатывать для всех ваших потоков.': {
		'ru': 'Глобальный постбэк будет срабатывать для всех ваших потоков.',
		'uk': 'Глобальний постбек буде спрацьовувати для всіх ваших потоків.',
		'en': 'Global postback will fire for all your campaigns',
		'de': 'Global Postback wird für alle Ihre Kampagnen ausgelöst',
		'vi': 'Postback toàn cầu sẽ làm việc cho tất cả các luồng của bạn.',
		'th': 'การย้อนกลับไปสู่ตำแหน่งโลกจะได้ผลดีกับการทำงานย่อยที่มีการแบ่งปันทรัพยากรต่างๆ'
	},
	'Глобальный постбэк лог': {
		'ru': 'Глобальный постбэк лог',
		'uk': 'Глобальний постбек лог',
		'en': 'Global postback log',
		'de': 'Global postback log',
		'vi': 'Đăng nhập postback toàn cầu',
		'th': 'การเข้าสู่ระบบการย้อนกลับไปที่ตำแหน่งโลก'
	},
	'Переотправка постбека': {
		'ru': 'Переотправка постбека',
		'uk': 'Перевідправка',
		'en': 'Postback forwarding',
		'de': 'Postback-Weiterleitung',
		'vi': 'Chuyển tiếp gửi lại',
		'th': 'การส่งต่อ Postback'
	},
	'Переотправить по обновленным постбек урлам': {
		'ru': 'Переотправить по обновленным постбек урлам',
		'uk': 'Перевідправити по обновленим постбек урлам',
		'en': 'Forward to updated postback urls',
		'de': 'Weiterleiten an aktualisierte Postback-URLs',
		'vi': 'Chuyển tiếp tới các url postback cập nhật',
		'th': 'ส่งต่อไปยัง URL หลังการอัปเดตที่อัปเดต'
	},
	'Переотправить постбеки': {
		'ru': 'Переотправить постбеки',
		'uk': 'Перевідправити постбеки',
		'en': 'Resend postbacks',
		'de': 'Postbacks erneut senden',
		'vi': 'Gửi lại bài đăng',
		'th': 'ส่ง postbacks อีกครั้ง'
	},
	'Осталось отправить': {
		'ru': 'Осталось отправить',
		'uk': 'Залишилось відправити',
		'en': 'Left to send',
		'de': 'Zum Senden übrig',
		'vi': 'Còn lại để gửi',
		'th': 'เหลือที่จะส่ง'
	},
	'постбеков отправится': {
		'ru': 'постбеков отправится',
		'uk': 'постбеків відправится',
		'en': 'postbacks will go',
		'de': 'postbacks werden gehen',
		'vi': 'postback sẽ đi',
		'th': 'postbacks จะไป'
	},
	'Город': {
		'ru': 'Город',
		'uk': 'Місто',
		'en': 'City',
		'de': 'Stadt',
		'vi': 'Thành phố',
		'th': 'เมือง'
	},
	'Да, вопрос решен': {
		'ru': 'Да, вопрос решен',
		'uk': 'Так, питання вирішено',
		'en': 'Yes, solved',
		'de': 'Ja, gelöst',
		'vi': 'Vâng, vấn đề đã được giải quyết',
		'th': 'ใช่ ประเด็นที่เป็นปัญหาได้รับการแก้ไขแล้ว'
	},
	'Данные': {
		'ru': 'Данные',
		'uk': 'Дані',
		'en': 'Data',
		'de': 'Daten',
		'vi': 'Dữ liệu',
		'th': 'ข้อมูล'
	},
	'Данные конфиденциальны и не разглашаются сторонним лицам': {
		'ru': 'Данные конфиденциальны и не разглашаются сторонним лицам',
		'uk': 'Дані конфіденційні та не розголошуються стороннім особам',
		'en': 'Data is confidential and not disclosed to third parties',
		'de': 'Persönliche Daten werden vertraulich behandelt und nicht an Dritte weitergegeben.',
		'vi': 'Dữ liệu được bảo mật và không được tiết lộ cho bên thứ ba',
		'th': 'ข้อมูลเป็นความลับและไม่ถูกเปิดเผยต่อบุคคลที่สาม'
	},
	'Дата': { 'ru': 'Дата', 'uk': 'Дата', en: 'Date', de: 'Datum', vi: 'Ngày', th: 'วันที่' },
	'Дата создания': {
		'ru': 'Дата создания',
		'uk': 'Дата створення',
		'en': 'Creation date',
		'de': 'Erstelldatum',
		'vi': 'ngày tạo',
		'th': 'วันที่สร้าง'
	},
	'Дата закрытия': {
		'ru': 'Дата закрытия',
		'uk': 'Дата закриття',
		'en': 'Closing date',
		'de': 'Einsendeschluss',
		'vi': 'ngày đóng cửa',
		'th': 'วันที่ปิด'
	},
	'Дата обновления': {
		'ru': 'Дата обновления',
		'uk': 'Дата оновлення',
		'en': 'Updated at',
		'de': 'Aktualisiert am',
		'vi': 'Cập nhật tại',
		'th': 'อัปเดตเมื่อวันที่'
	},
	'Дата изменения статуса': {
		'ru': 'Дата изменения статуса',
		'uk': 'Дата зміни статуса',
		'en': 'Status changed at',
		'de': 'Datum der Statusänderung ',
		'vi': 'Ngày thay đổi trạng thái',
		'th': 'วันที่ที่เปลียนแปลงสถานภาพ'
	},
	'Дата первого звонка': {
		'ru': 'Дата первого звонка',
		'uk': 'Дата першого звінка',
		'en': 'First called at',
		'de': 'Datum des ersten Anrufs',
		'vi': 'Ngày cuộc gọi đầu tiên',
		'th': 'วันที่โทรครั้งแรก'
	},
	'ID сплит сессии': {
		'ru': 'ID сплит сессии',
		'uk': 'ID спліт сессії',
		'en': 'Split session ID',
		'de': 'Split session ID',
		'vi': 'Split session ID',
		'th': 'Split session ID'
	},
	'Дашборд': {
		'ru': 'Дашборд',
		'uk': 'Дашборд',
		'en': 'Dashboard',
		'de': 'Dashboard',
		'vi': 'Bảng điều khiển',
		'th': 'แดชบอร์ด'
	},
	'Действия': {
		'ru': 'Действия',
		'uk': 'Дії',
		'en': 'Actions',
		'de': 'Aktionen',
		'vi': 'Hoạt động',
		'th': 'การกระทำ'
	},
	'День недели': {
		'ru': 'День недели',
		'uk': 'День тиждня',
		'en': 'Day of week',
		'de': 'Wochentag',
		'vi': 'Ngày trong tuần',
		'th': 'วันของสัปดาห์'
	},
	'Детали конверсии': {
		'ru': 'Детали конверсии',
		'uk': 'Деталі конверсії',
		'en': 'Conversion details',
		'de': 'Umwandlungsdetails',
		'vi': 'Chi tiết chuyển đổi',
		'th': 'รายละเอียดการแปลงสภาพ'
	},
	'Детали прозвона': {
		'ru': 'Детали прозвона',
		'uk': 'Детали прозвону',
		'en': 'Call details',
		'de': 'Anrufdetails',
		'vi': 'Chi tiết cuộc gọi',
		'th': 'รายละเอียดของเสียงเรียกเข้า'
	},
	'Для передачи параметров в запрос Вы можете использовать макросы, указанные ниже.': {
		'ru': 'Для передачи параметров в запрос Вы можете использовать макросы, указанные ниже.',
		'uk': 'Для надсилання параметрів у запит Ви можете використовувати макроси, наведені нижче.',
		'en': 'To send parameterized requests, use macros listed below.',
		'de': 'Um Parameter an die Anwendung zu senden, können Sie Makros verwenden, sind unter beschrieben.',
		'vi': 'Để gửi các tham số cho yêu cầu, bạn có thể sử dụng các macro được liệt kê dưới đây.',
		'th': 'ในการส่งพารามิเตอร์ตัวแปรเสริมไปยังคำถาม คุณสามารถใช้คำสั่งย่อที่สามารถขยายความได้เมื่อจำเป็นตามรายชื่อด้านล่าง'
	},
	'Для получения доступа к офферу просим ответить вас на пару вопросов непосредственно в этом тикете:': {
		'ru': 'Для получения доступа к офферу просим ответить вас на пару вопросов непосредственно в этом тикете:',
		'uk': 'Для отримання доступу до офферу просимо відповісти на кілька запитань безпосередньо в цьому тикеті:',
		'en': 'To access the offer, please answer the following questions in this ticket:',
		'de': 'Um Zugang zum Angebot zu erlangen, beantworten Sie bitte ein paar Fragen in diesem Ticket:',
		'vi': 'Để nhận được quyền truy cập vào offer, xin vui lòng trả lời vài câu hỏi trực tiếp trong ticket này:',
		'th': 'เพื่อที่จะเข้าถึงข้อเสนอโปรดตอบ2-3คำถามที่เกี่ยวข้องในรายการคำถามนี้'
	},
	'Для прикрепления домена, вам необходимо добавить в панель регистратора: A-запись на IP-адрес': {
		'ru': 'Для прикрепления домена, вам необходимо добавить в панель регистратора: A-запись на IP-адрес',
		'uk': 'Для прикріплення домену, необхідно додати в панель реєстратора: A-запис на IP-адресу',
		'en': 'To park a domain, you must add the following in your registrar\'s panel: A-record to the IP',
		'de': 'Um Domain zu parken, müssen Sie in Ihrem Registrar-Panel hinzuzufügen: A-Record auf die IP-Adresse',
		'vi': 'Để đính kèm một tên miền, bạn cần thêm vào bảng ghi: A-record tới địa chỉ IP',
		'th': 'การที่จะแนบชื่อเวบไซต์หรือชื่อบล้อค คุณจำเป็นต้องเพิ่มแผงการบันทึกเข้าไปยังIP'
	},
	'Для прикрепления домена, вам необходимо добавить в панель регистратора: CNAME на': {
		'ru': 'Для прикрепления домена, вам необходимо добавить в панель регистратора: CNAME на',
		'uk': 'Для прикріплення домену, вам необхідно додати до панелі реєстратора: CNAME на',
		'en': 'To park a domain, you must add the following in your registrar\'s panel: CNAME to',
		'de': 'Um domain zu parken, fügen Sie im Panel des Registrars: CHAME',
		'vi': 'Để đính kèm một tên miền, bạn cần thêm vào bảng ghi: CNAME theo',
		'th': 'เพื่อที่จะแนบชื่อเวบไซต์หรือชื่อบล้อคลงไปคุณจำเป็นต้องเพิ่มที่แผงบันทึกว่าCNAMEลงไป'
	},
	'Для экономии вашего времени': {
		'ru': 'Для экономии вашего времени, прежде чем отправлять письмо в обратную связь, рекомендуем поискать ответ на ваш вопрос в разделе',
		'uk': 'Для економії вашого часу, перш ніж надсилати листа у зворотний зв\'язок, рекомендуємо пошукати відповідь на ваше запитання у розділі',
		'en': 'To save your time, before sending the ticket to the support, we recommend that you search for the answer to your question in the section',
		'de': 'Um Ihre Zeit zu sparen, bevor Sie einen Ticket senden, lesen Sie bitte die Liste der am häufigsten gestellten Fragen (FAQ) durch.',
		'vi': 'Để tiết kiệm thời gian của bạn, trước khi gửi thư đến thông tin phản hồi, chúng tôi khuyên bạn tìm kiếm câu trả lời cho câu hỏi của bạn trong phần',
		'th': 'เพื่อประหยัดเวลาของคุณ ก่อนส่งอีเมลในส่วนตอบรับของระบบ เราแนะนำให้คุณหาคำตอบของคำถามของคุณในส่วนนี้ก่อน'
	},
	'дней': { 'ru': 'дней', 'uk': 'днів', en: 'days', de: 'Tage', vi: 'ngày', th: 'วัน' },
	'Добавить валюту': {
		'ru': 'Добавить валюту',
		'uk': 'Додати валюту',
		'en': 'Add a currency',
		'de': 'Währung hinzufügen',
		'vi': 'Thêm đơn vị tiền tệ',
		'th': 'เพิ่มสกุลเงิน'
	},
	'Ваш подарок отсутствует. Выберите другой': {
		'ru': 'Ваш подарок отсутствует. Выберите другой',
		'uk': 'Ваш подарунок відсутній. Виберіть інший',
		'en': 'Your gift is missing. Choose another',
		'de': 'Dein Geschenk fehlt. Wähle einen anderen',
		'vi': 'Món quà của bạn bị thiếu Chọn cái khác',
		'th': 'ของขวัญของคุณหายไป เลือกอื่น'
	},
	'Для подарка нужно еще': {
		'ru': 'Для подарка нужно еще',
		'uk': 'Для подарунку потрібно ще',
		'en': 'For the gift you need more',
		'de': 'Für das Geschenk braucht man mehr',
		'vi': 'Đối với món quà bạn cần nhiều hơn',
		'th': 'สำหรับของขวัญที่คุณต้องการมากขึ้น'
	},
	'Поздравляем! Вы можете получить свой подарок!': {
		'ru': 'Поздравляем! Вы можете получить свой подарок!',
		'uk': 'Вітаємо! Ви можете отримати подарунок!',
		'en': 'Congratulations! You can get your gift!',
		'de': 'Herzlichen Glückwunsch! Sie können Ihr Geschenk bekommen!',
		'vi': 'Xin chúc mừng! Bạn có thể nhận được món quà của bạn!',
		'th': 'ขอแสดงความยินดี! คุณสามารถรับของขวัญของคุณ!'
	},
	'Перейти в магазин': {
		'ru': 'Перейти в магазин',
		'uk': 'Перейти в магазин',
		'en': 'Go to the store',
		'de': 'Gehe in den Laden',
		'vi': 'Đi đến cửa hàng',
		'th': 'ไปที่ร้าน'
	},
	'Завтра сгорит': {
		'ru': 'Завтра сгорит',
		'uk': 'Завтра згорить',
		'en': 'Burns tomorrow',
		'de': 'Burns tomorrow',
		'vi': 'Burns tomorrow',
		'th': 'Burns tomorrow'
	},
	'Получить': {
		'ru': 'Получить',
		'uk': 'Отримати',
		'en': 'Get',
		'de': 'Empfange',
		'vi': 'Nhận',
		'th': 'ได้รับ'
	},
	'Да': {
		'ru': 'Да',
		'uk': 'Так',
		'en': 'Yes',
		'de': 'Ja',
		'vi': 'Vâng',
		'th': 'ใช่'
	},
	'Нет': {
		'ru': 'Нет',
		'uk': 'Ні',
		'en': 'No',
		'de': 'Nein',
		'vi': 'không',
		'th': 'ไม่'
	},
	'Вы уверены что хотите заказать подарок': {
		'ru': 'Вы уверены что хотите заказать подарок',
		'uk': 'Ви впевнені, що хочете замовити подарунок',
		'en': 'Are you sure you want to order a gift?',
		'de': 'Möchten Sie wirklich ein Geschenk bestellen?',
		'vi': 'Bạn có chắc chắn muốn đặt một món quà',
		'th': 'คุณแน่ใจหรือว่าต้องการสั่งซื้อของขวัญ'
	},
	'Добавить площадку': {
		'ru': 'Добавить площадку',
		'uk': 'Додати площадку',
		'en': 'Add a source',
		'de': 'Quelle hinzufügen',
		'vi': 'Thêm trang',
		'th': 'เพิ่มพื้นที่'
	},
	'Добавить поток': {
		'ru': 'Добавить поток',
		'uk': 'Додати потік',
		'en': 'Add campaign',
		'de': 'Kampagen hinzufügen',
		'vi': 'Thêm luồng',
		'th': 'เพิ่มแคมเปญ'
	},
	'Добавить систему': {
		'ru': 'Добавить систему',
		'uk': 'Додати систему',
		'en': 'Add system',
		'de': 'System hinzufügen',
		'vi': 'Thêm hệ thống',
		'th': 'เพิ่มระบบ'
	},
	'Добавлен': {
		'ru': 'Добавлен',
		'uk': 'Додано',
		'en': 'Added',
		'de': 'Hinzugefügt',
		'vi': 'Đã thêm',
		'th': 'ที่เพิ่ม'
	},
	'Добавление транзитки/лендинга к офферу': {
		'ru': 'Добавление транзитки/лендинга к офферу',
		'uk': 'Додавання транзитки/лендингу до офферу',
		'en': 'Adding a transit/landing to offer',
		'de': 'Transit/Landing zum Angebot hinzufügen',
		'vi': 'Thêm trang transit/landing vào offer',
		'th': 'การเพิ่มการเชื่อต่อ/ผู้คลิ๊กไปสู่ข้อเสนอ'
	},
	'Домен': {
		'ru': 'Домен',
		'uk': 'Домен',
		'en': 'Domain',
		'de': 'Domain',
		'vi': 'Tên miền',
		'th': 'ชื่อเวบไซต์หรือชื่อบล้อค'
	},
	'Домены лэндинга и транзитки должны отличаться': {
		'ru': 'Домены лэндинга и транзитки должны отличаться',
		'uk': 'Домени лендінга и транзитки повинні відрізнятися',
		'en': 'Landing and transit domains must be different',
		'de': 'Landing und Transit Domains muss unterschiedlich sein.',
		'vi': 'Miền landing và miền transit phải khác biệt',
		'th': 'เวบไซต์ร้านค้าและการรอเปลี่ยนผ่านต้องแตกต่าง'
	},
	'Введите домен':{
		'ru': 'Введите домен',
		'uk': 'Введіть домен',
		'en': 'Enter domain',
		'de': 'Domain eingeben',
		'vi': 'Nhập tên miền',
		'th': 'ป้อนโดเมน'
	},
	'Введите источник трафика':{
		'ru': 'Введите источник трафика',
		'uk': 'Введіть джерело трафіку',
		'en': 'Enter traffic source',
		'de': 'Verkehrsquelle eingeben',
		'vi': 'Nhập nguồn lưu lượng',
		'th': 'ป้อนแหล่งที่มาของการเข้าชม'
	},
	'Выберите источник трафика':{
		'ru': 'Выберите источник трафика',
		'uk': 'Виберіть джерело трафіку',
		'en': 'Select traffic source',
		'de': 'Verkehrsquelle eingeben',
		'vi': 'Nhập nguồn lưu lượng',
		'th': 'ป้อนแหล่งที่มาของการเข้าชม'
	},
	'Введите валюту': {
		'ru': 'Введите валюту',
		'uk': 'Введіть валюту',
		'en': 'Enter currency',
		'de': 'Währung eingeben',
		'vi': 'Nhập tiền tệ',
		'th': 'ป้อนสกุลเงิน'
	},
	'Дополнительное': {
		'ru': 'Дополнительное',
		'uk': 'Додаткове',
		'en': 'Additional',
		'de': 'Zusätzlich',
		'vi': 'Thêm',
		'th': 'ที่เพิ่มเติมขึ้นมา'
	},
	'Дорвеи': {
		'ru': 'Дорвеи',
		'uk': 'Дорвеї',
		'en': 'Doorways',
		'de': 'Doorways',
		'vi': 'Doorway',
		'th': 'Doorways'
	},
	'Доступные офферы': {
		'ru': 'Доступные офферы',
		'uk': 'Доступні оффери',
		'en': 'Available',
		'de': 'Verfügbar',
		'vi': 'Các offer có sẵn',
		'th': 'ข้อเสนอที่เข้าถึงได้'
	},
	'Доход': {
		'ru': 'Доход',
		'uk': 'Дохід',
		'en': 'Revenue',
		'de': 'Einnahmen',
		'vi': 'Thu nhập',
		'th': 'รายได้'
	},
	'Если вы не получили номер заявки': {
		'ru': 'Если вы не получили номер заявки, значит мы не получили ваш вопрос и не сможем вам ответить.',
		'uk': 'Якщо ви не отримали номер заявки, то ми не отримали ваше запитання і не зможемо вам відповісти.',
		'en': 'If you did not receive the application number, then we did not receive your question and can not answer you.',
		'de': 'Wenn Sie keine Bewerbungsnummer erhalten haben',
		'vi': 'Nếu bạn chưa nhận được số yêu cầu thì đó nghĩa là chúng tôi chưa nhận được câu hỏi của bạn và không thể trả lời bạn.',
		'th': 'ถ้าคุณไม่ได้รับเลขที่ในการสมัครแสดงว่าเราไม่ได้รับคำถามของคุณจึงไม่สามารถตอบกลับได้'
	},
	'Если у вас есть замечания по работе': {
		'ru': 'Если у вас есть замечания по работе',
		'uk': 'Якщо у вас є зауваження щодо роботи',
		'en': 'If you want to share feedback',
		'de': 'Falls Sie uns Feedback',
		'vi': 'Nếu bạn có ý kiến về công việc',
		'th': 'หากว่าท่านมีข้อติชมเกี่ยวกับการทำงาน'
	},
	'Загрузить': {
		'ru': 'Загрузить',
		'uk': 'Завантажити',
		'en': 'Upload',
		'de': 'Hochladen',
		'vi': 'Tải lên',
		'th': 'ดาวโหลดข้อมูล'
	},
	'Заказ': {
		'ru': 'Заказ',
		'uk': 'Замовлення',
		'en': 'Order',
		'de': 'Order',
		'vi': 'đặt hàng',
		'th': 'ลำดับขั้น'
	},
	'Заказ товара': {
		'ru': 'Заказ товара',
		'uk': 'Замовлення товару',
		'en': 'Order goods',
		'de': 'Waren bestellen',
		'vi': 'Đặt hàng',
		'th': 'ลำดับขั้น'
	},
	'Задать вопрос менеджеру': {
		'ru': 'Задать вопрос менеджеру',
		'uk': 'Задати питання менеджеру',
		'en': 'Contact your manager',
		'de': 'Kontaktieren Sie Ihren Manager. ',
		'vi': 'Hỏi người quản lý',
		'th': 'คำถามถึงผู้จัดการ'
	},
	'Заказать выплату': {
		'ru': 'Заказать выплату',
		'uk': 'Замовити виплату',
		'en': 'Request payout',
		'de': 'Auszahlung ',
		'vi': 'Đặt thanh toán',
		'th': 'การสั่งจ่ายเงิน'
	},
	'QUIDs': {
		'ru': 'QUID',
		'uk': 'QUID',
		'en': 'QUID',
		'de': 'QUID',
		'vi': 'QUID',
		'th': 'QUID'
	},
	'закрыт. Спасибо за обращение!': {
		'ru': ' закрыт. Спасибо за обращение!',
		'uk': ' зачинено. Дякую за звернення!',
		'en': ' closed. Thank you for contacting us!',
		'de': 'wurde geschlossen. Danke für Ihre Kontaktaufnahme!',
		'vi': 'đóng cửa. Cảm ơn bạn đã liên hệ với chúng tôi!',
		'th': 'ปิด ขอบคุณที่ติดต่อเรา'
	},
	'Закрыть': {
		'ru': 'Закрыть',
		'uk': 'Закрити',
		'en': 'Close',
		'de': 'Schließen',
		'vi': 'Đóng',
		'th': 'ปิด'
	},
	'Закрыть форму': {
		'ru': 'Закрыть форму',
		'uk': 'Закрити форму',
		'en': 'Close form',
		'de': 'Formular schließen ',
		'vi': 'Đóng biểu mẫu',
		'th': 'การปิดฟอร์ม'
	},
	'запрос на добавление!': {
		'ru': 'запрос на добавление!',
		'uk': 'запит на додавання!',
		'en': 'a request to add them!',
		'de': 'Anfrage zum Hinzufügen!',
		'vi': 'yêu cầu để thêm vào!',
		'th': 'คำร้องเพื่อเพิ่ม!'
	},
	'Запрос на доступ к офферу': {
		'ru': 'Запрос на доступ к офферу',
		'uk': 'Запит на доступ до оффера',
		'en': 'Request to access offer',
		'de': 'Anfrage um Zugang zum Angebot',
		'vi': 'Yêu cầu truy cập vào offer',
		'th': 'คำร้องขอการเข้าถึงข้อเสนอ'
	},
	'Запрос на изменение skype': {
		'ru': 'Запрос на изменение skype',
		'uk': 'Запит на зміну skype',
		'en': 'Request to change skype',
		'de': 'Ändern Sie bitte mein Skype auf',
		'vi': 'Yêu cầu thay đổi skype',
		'th': 'คำร้องขอเปลี่ยนสไกป์'
	},
	'Запрос на изменение данных для системы выплаты': {
		'ru': 'Запрос на изменение данных для системы выплаты',
		'uk': 'Запит на зміну даних до системи виплати',
		'en': 'Request for change of data for the payout system',
		'de': 'Anfrage nach Änderung der Daten für Auszahlungssystem',
		'vi': 'Yêu cầu thay đổi dữ liệu cho hệ thống thanh toán',
		'th': 'คำร้องขอการเปลี่ยนแปลงข้อมูลสำหรับระบบการจ่ายเงินปันผล'
	},
	'Запрос на изменение номера телефона': {
		'ru': 'Запрос на изменение номера телефона',
		'uk': 'Запит на зміну номера телефону',
		'en': 'Request to change phone number',
		'de': 'Anfrage nach Änderung der Telefonnummer auf',
		'vi': 'Yêu cầu thay đổi số điện thoại',
		'th': 'คำร้องขอเปลี่ยนเบอร์โทรศัพท์'
	},
	'Запрос на изменение электронной почты': {
		'ru': 'Запрос на изменение электронной почты',
		'uk': 'Запит на зміну електронної пошти',
		'en': 'Request to change email',
		'de': 'Anfrage nach Änderung E-Mail-Adresse ',
		'vi': 'Yêu cầu thay đổi email',
		'th': 'คำร้องขอเปลี่ยนอีเมล'
	},
	'Запрос на изменение города': {
		'ru': 'Запрос на изменение города',
		'uk': 'Запит на зміну міста',
		'en': 'Request to change city',
		'de': 'Anfrage nach Änderung Stadt',
		'vi': 'Yêu cầu đổi thành phố',
		'th': 'ขอเปลี่ยนเมือง'
	},
	'Запрос на изменение даты рождения': {
		'ru': 'Запрос на изменение даты рождения',
		'uk': 'Запит на зміну дати народження',
		'en': 'Request to change birthday',
		'de': 'Antrag auf Änderung des Geburtstages',
		'vi': 'Yêu cầu thay đổi sinh nhật',
		'th': 'ขอเปลี่ยนวันเกิด'
	},
	'Запросить доступ': {
		'ru': 'Запросить доступ',
		'uk': 'Запросити доступ',
		'en': 'Request access',
		'de': 'Anfrage auf Zugang',
		'vi': 'Yêu cầu quyền truy cập',
		'th': 'ร้องขอการเข้าถึง'
	},
	'Свяжитесь с менеджером для просмотра транзитки': {
		'ru': 'Транзитные страницы будут доступны после открытия оффера менеджером',
		'uk': 'Транзитні сторінки будуть доступні після відкриття оффера менеджером',
		'en': 'Promotional materials will be opened after a request for access to the offer, please contact your personal manager',
		'de': 'Werbematerialien werden nach einer Anfrage für den Zugang zum Angebot geöffnet. Bitte wenden Sie sich an Ihren persönlichen Manager',
		'vi': 'Tài liệu quảng cáo sẽ được mở sau khi có yêu cầu truy cập vào phiếu mua hàng, vui lòng liên hệ với người quản lý cá nhân của bạn',
		'th': 'สื่อส่งเสริมการขายจะเปิดขึ้นหลังจากมีการร้องขอการเข้าถึงข้อเสนอโปรดติดต่อผู้จัดการส่วนตัวของคุณ'
	},
	'Заявка отклонена': {
		'ru': 'Заявка отклонена',
		'uk': 'Заявка відхилена',
		'en': 'Request declined',
		'de': 'Anfrage abgelehnt',
		'vi': 'Yêu cầu đã bị từ chối',
		'th': 'การสมัครถูกปฏิเสธ'
	},
	'Заявки обрабатываются нашим колл-центром в режиме 24/7': {
		'ru': 'Заявки обрабатываются нашим колл-центром в режиме 24/7',
		'uk': 'Заявки обробляються нашим кол-центром у режимі 24/7',
		'en': 'Applications are being processed 24/7 by our call-center',
		'de': 'Die Anwendungen werden mit unserem Call Center 24/7 Service verarbeitet',
		'vi': 'Những yêu cầu được xử lý bởi trung tâm cuộc gọi của chúng tôi 24/7',
		'th': 'การสมัครดำเนินการโดยคอลเซ็นเตอร์ 24 ชม.ทุกวัน'
	},
	'Значение': {
		'ru': 'Значение',
		'uk': 'Значення',
		'en': 'Meaning',
		'de': 'Bedeutung',
		'vi': 'Giá trị',
		'th': 'ความหมาย'
	},
	'и': { 'uk': ' і ', 'ru': ' и ', en: ' and ', de: 'und', vi: 'và', th: 'และ' },
	'идентификатор потока': {
		'ru': 'идентификатор потока',
		'uk': 'ідентификатор потоку',
		'en': 'campaign identifier',
		'de': 'Kampagne Identifikator',
		'vi': 'nhận dạng lưu lượng',
		'th': 'ตัวระบุการไหลลื่นของข้อมูล'
	},
	'идентификатор программы': {
		'ru': 'идентификатор программы',
		'uk': 'ідентификатор программи',
		'en': 'offer identifier',
		'de': 'Angebote Identifikator',
		'vi': 'nhận dạng chương trình',
		'th': 'ตัวระบุโปรแกรม'
	},
	'идентификатор цели': {
		'ru': 'идентификатор цели',
		'uk': 'ідентификатор мети',
		'en': 'id of goal',
		'de': 'ID des Ziels',
		'vi': 'Id mục tiêu',
		'th': 'ตัวบ่งบอกเป้าหมาย'
	},
	'Изменен': {
		'ru': 'Изменен',
		'uk': 'Змінено',
		'en': 'Updated at',
		'de': 'Aktualisiert',
		'vi': 'Được thay đổi',
		'th': 'ถูกเปลี่ยนแปลงแล้ว'
	},
	'Изменение Skype номера возможно только по запросу в': {
		'ru': 'Изменение Skype номера возможно только по запросу в',
		'uk': 'Зміна Skype номеру можлива лише по запиту в',
		'en': 'Change of Skype number is possible only on request in',
		'de': 'Änderung der Skype-Nummer ist nur auf Anfrage',
		'vi': 'Thay đổi Skype chỉ có thể nếu được yêu cầu trong',
		'th': 'สามารถเปลี่ยนเบอร์สไกปตามคำร้องขอ'
	},
	'Изменение номера телефона возможно только по запросу в': {
		'ru': 'Изменение номера телефона возможно только по запросу в',
		'uk': 'Зміна номеру телефону можлива лише по запиту в',
		'en': 'Change of phone number is possible only on request in',
		'de': 'Änderung der Telefonnumer ist nur auf Anfrage',
		'vi': 'Thay đổi số điện thoại chỉ có thể nếu yêu cầu trong',
		'th': 'สามารถปลี่ยนเบอร์โทรได้ตามคำร้องขอ'
	},
	'Изменение электронной почты возможно только по запросу в': {
		'ru': 'Изменение электронной почты возможно только по запросу в',
		'uk': 'Зміна електронної пошти можлива лише по запиту в',
		'en': 'Change of email is possible only on request in',
		'de': 'Änderung der E-Mail Adresse ist nur auf Anfrage',
		'vi': 'Thay đổi email chỉ có thể nếu được yêu cầu trong',
		'th': 'สามารถเปลี่ยนอีเมลตามคำร้องขอ'
	},
	'Изменение города возможно только по запросу в': {
		'ru': 'Изменение города возможно только по запросу в',
		'uk': 'Зміна міста можлива лише по запиту в',
		'en': 'Change of city is possible only on request in',
		'de': 'Änderung der Stadt ist nur auf Anfrage',
		'vi': 'Thay đổi thành phố chỉ có thể theo yêu cầu trong',
		'th': 'สามารถเปลี่ยนเมืองได้ตามคำขอเท่านั้น'
	},
	'Изменение даты рождения возможно только по запросу в': {
		'ru': 'Изменение даты рождения или добавление дополнительной даты возможно только по запросу в',
		'uk': 'Зміна дати народження або додавання додаткової дати можлива лише по запиту в',
		'en': 'Change of birthday or adding additional dates is possible only on request in',
		'de': 'Change of birthday or adding additional dates is possible only on request in',
		'vi': 'Change of birthday or adding additional dates is possible only on request in',
		'th': 'Change of birthday or adding additional dates is possible only on request in'
	},
	'Изменить данные': {
		'ru': 'Изменить данные',
		'uk': 'Змінити дані',
		'en': 'Submit changes',
		'de': 'Änderungen einreichen',
		'vi': 'Thay đổi dữ liệu',
		'th': 'การเปลี่ยนข้อมูล'
	},
	'или CNAME на': {
		'ru': 'или CNAME на',
		'uk': 'або CNAME на',
		'en': 'or CNAME to',
		'de': 'oder CNAME auf',
		'vi': 'hoặc CNAME sang',
		'th': 'หรือรายการข้อมูลภายในระบบชื่อโดเมนส่งระบุตำแหน่งที่ให้คนอื่นสามารถหาหน้าเว็บได้'
	},
	'или отслеживаете конверсии на источниках трафика.': {
		'ru': 'или отслеживаете конверсии на источниках трафика.',
		'uk': 'або відслідковуйте конверсії на джерелах трафіку.',
		'en': 'or monitoring conversions at traffic sources.',
		'de': 'oder Sie verwenden Conversion Tracking auf den Traffic-Quellen.',
		'vi': 'hoặc theo dõi các chuyển đổi trên các nguồn lưu lượng truy cập.',
		'th': 'หรือติดตามการแปลงค่าในแหล่งการเข้าถึงลูกค้า'
	},
	'Или сохранить как...': {
		'ru': 'Или сохранить как...',
		'uk': 'Або зберегти як...',
		'en': 'Or save as...',
		'de': 'Speichern unter',
		'vi': 'Hoặc save as ...',
		'th': 'หรือบันทึกเป็น'
	},
	'Имя потока': {
		'ru': 'Имя потока',
		'uk': 'Назва потоку',
		'en': 'Campaign name',
		'de': 'Name des kampagnen',
		'vi': 'Tên luồng',
		'th': 'ชื่อของการไหลเวียนข้อมูล'
	},
	'имя потока': {
		'ru': 'имя потока',
		'uk': 'назва потоку',
		'en': 'campaign name',
		'de': 'Kampagnename',
		'vi': 'tên luồng',
		'th': 'ชื่อการไหลเวียนของข้อมูล'
	},
	'имя программы': {
		'ru': 'имя программы',
		'uk': 'назва програми',
		'en': 'offer name',
		'de': 'Name des Angebots',
		'vi': 'tên chương trình',
		'th': 'ชื่อรายการ'
	},
	'Инструменты': {
		'ru': 'Инструменты',
		'uk': 'Інструменти',
		'en': 'Tools',
		'de': 'Instrumente',
		'vi': 'Công cụ',
		'th': 'เครื่องมือ'
	},
	'информацию о совершенной конверсии.': {
		'ru': 'информацию о совершенной конверсии.',
		'uk': 'информацію про конверсії.',
		'en': 'information about conversions automatically.',
		'de': 'Informationen über Conversions automatisch erhalten müssen.',
		'vi': 'thông tin về việc chuyển đổi hoàn thành.',
		'th': 'ข้อมูลเกี่ยวกับการแปลงค่าที่สมบูรณ์'
	},
	'Использовать наш домен': {
		'ru': 'Использовать наш домен',
		'uk': 'Використовувати наш домен',
		'en': 'Use our domain',
		'de': 'Nutzen unseren Domain',
		'vi': 'Sử dụng tên miền của chúng tôi',
		'th': 'ใช้ชื่อเว็บไซต์หรือชื่อบล้อคของเรา'
	},
	'История': {
		'ru': 'История',
		'uk': 'Істория',
		'en': 'History',
		'de': 'Verlauf',
		'vi': 'Lịch sử',
		'th': 'ประวัติ'
	},
	'источник трафика': {
		'ru': 'источник трафика',
		'uk': 'джерело трафіку',
		'en': 'traffic source',
		'de': 'Traffic-Quelle',
		'vi': 'nguồn lưu lương',
		'th': 'แหล่งที่มาของผู้เยี่ยมชมเวบไซต์'
	},
	'Источник': {
		'ru': 'Источник',
		'uk': 'Джерело',
		'en': 'Source',
		'de': 'Quelle',
		'vi': 'nguồn',
		'th': 'แหล่ง'
	},
	'Источники трафика': {
		'ru': 'Источники трафика',
		'uk': 'Джерело трафіку',
		'en': 'Traffic sources',
		'de': 'Traffic-Quelle',
		'vi': 'Nguồn lưu lượng truy cập',
		'th': 'แหล่งที่มาของการคลิ๊ก'
	},
	'Источник трафика': {
		'ru': 'Источник трафика',
		'uk': 'Джерело трафіку',
		'en': 'Traffic source',
		'de': 'Traffic-Quelle',
		'vi': 'nguồn lưu lương',
		'th': 'แหล่งที่มาของผู้เยี่ยมชมเวบไซต์'
	},
	'Категория': {
		'ru': 'Категория',
		'uk': 'Категорія',
		'en': 'Category',
		'de': 'Kategorie',
		'vi': 'Danh mục',
		'th': 'ประเภท'
	},
	'Категория:': {
		'ru': 'Категория:',
		'uk': 'Категорія:',
		'en': 'Category:',
		'de': 'Kategorie:',
		'vi': 'Danh mục:',
		'th': 'ประเภท:'
	},
	'Не найдено подходящих офферов. Попробуйте еще.': {
		'ru': 'Не найдено подходящих офферов. Попробуйте еще.',
		'uk': 'Не знайдено підходящих офферов. Спробуйте ще.',
		'en': 'No matching offers found. Try again.',
		'de': 'Keine passenden Angebote gefunden. Versuchen Sie es noch einmal.',
		'vi': 'Không tìm thấy cung cấp phù hợp. Hãy thử lại.',
		'th': 'ไม่พบข้อเสนอที่ตรงกัน ลองใหม่อีกครั้ง:'
	},
	'Код ответа': {
		'ru': 'Код ответа',
		'uk': 'Код відповіді',
		'en': 'Response code',
		'de': 'Antwortcode',
		'vi': 'Mã phản hồi',
		'th': 'รหัสที่ใช้ตอบกลับ'
	},
	'alert handshake failure': {
		'ru': 'cбой ssl handshak-a',
		'uk': 'збій ssl handshak-a',
		'en': 'ssl handshake failure',
		'de': 'ssl handshake failure',
		'vi': 'ssl handshake failure',
		'th': 'ssl handshake failure'
	},
	'cannot find your host address': {
		'ru': 'не удается найти адрес вашего хоста',
		'uk': 'не вдається знайти адресу вашого хоста',
		'en': 'cannot find your host address',
		'de': 'cannot find your host address',
		'vi': 'cannot find your host address',
		'th': 'cannot find your host address'
	},
	'cannot establish connection': {
		'ru': 'не удается установить соединение',
		'uk': 'не вдаєтся встановити з\'єднання',
		'en': 'cannot establish connection',
		'de': 'cannot establish connection',
		'vi': 'cannot establish connection',
		'th': 'cannot establish connection'
	},
	'page not found': {
		'ru': 'не удается найти адрес',
		'uk': 'не вдается знайти адресу',
		'en': 'cannot find url',
		'de': 'cannot find url',
		'vi': 'cannot find url',
		'th': 'cannot find url'
	},
	'other_error': {
		'ru': 'другая ошибка',
		'uk': 'інша помилка',
		'en': 'other error',
		'de': 'other error',
		'vi': 'other error',
		'th': 'other error'
	},
	'Ошибка': {
		'ru': 'Ошибка',
		'uk': 'Помилка',
		'en': 'Error',
		'de': 'Error',
		'vi': 'Error',
		'th': 'Error'
	},
	'Кол-во': {
		'ru': 'Кол-во',
		'uk': 'К-ть',
		'en': 'Your',
		'de': 'Deine',
		'vi': 'Điểm',
		'th': ' '
	},
	'Твои': {
		'ru': 'Твои',
		'uk': 'Твої',
		'en': 'Your',
		'de': 'Your',
		'vi': 'Your',
		'th': 'Your'
	},
	'Ever-ы': {
		'ru': 'Ever-ы',
		'uk': 'Ever-и',
		'en': 'Evers',
		'de': 'Evers',
		'vi': 'Evers',
		'th': 'Evers'
	},
	'гонка': {
		'ru': 'гонка',
		'uk': 'гонка',
		'en': 'race',
		'de': 'race',
		'vi': 'race',
		'th': 'race'
	},
	'Позиция в первой гонке': {
		'ru': 'Позиция в первой гонке',
		'uk': 'Позиція в першій гонці',
		'en': 'Place in the first race',
		'de': 'Place in the first race',
		'vi': 'Place in the first race',
		'th': 'Place in the first race'
	},
	'Позиция в %s гонке': {
		'ru': 'Позиция в %s гонке',
		'uk': 'Позиція в %s гонці',
		'en': 'Place in the %s race',
		'de': 'Place in the %s race',
		'vi': 'Place in the %s race',
		'th': 'Place in the %s race'
	},
	'поинтов': {
		'ru': 'поинтов',
		'uk': 'поінтів',
		'en': 'points',
		'de': 'Punkte',
		'vi': 'của bạn',
		'th': 'คะแนนของคุณ'
	},
	'Поинты': {
		'ru': 'Поинты',
		'uk': 'Поінти',
		'en': 'Points',
		'de': 'Punkte',
		'vi': 'Của bạn',
		'th': 'คะแนนของคุณ'
	},
	'Позиция в конкурсе': {
		'ru': 'Позиция в конкурсе',
		'uk': 'Позиція в конкурсі',
		'en': 'Ranking in contest',
		'de': 'Ranking in contest',
		'vi': 'Ranking in contest',
		'th': 'Ranking in contest'
	},
	'Заведи траф,': {
		'ru': 'Заведи траф,',
		'uk': 'Заведи траф,',
		'en': 'Drive traffic',
		'de': 'Drive traffic',
		'vi': 'Drive traffic',
		'th': 'Drive traffic'
	},
	'заведи тачку': {
		'ru': 'заведи тачку',
		'uk': 'заведи тачку',
		'en': 'to drive cool car',
		'de': 'to drive cool car',
		'vi': 'to drive cool car',
		'th': 'to drive cool car'
	},
	'Абсолютное место': {
		'ru': 'Абсолютное место',
		'uk': 'Абсолютне місце',
		'en': 'Absolute ranking',
		'de': 'Absolute ranking',
		'vi': 'Absolute ranking',
		'th': 'Absolute ranking'
	},
	'Получай больше тикетов и множь свои шансы на победу!': {
		'ru': 'Получай больше тикетов и множь свои шансы на победу!',
		'uk': 'Отримуй більше тикетів і множ свої шанси на перемогу!',
		'en': 'Get more draw tickets and increase your chances to win!',
		'de': 'Get more draw tickets and increase your chances to win!',
		'vi': 'Get more draw tickets and increase your chances to win!',
		'th': 'Get more draw tickets and increase your chances to win!'
	},
	'Количество звонков': {
		'ru': 'Количество звонков',
		'uk': 'Кількість звонков',
		'en': 'Calls amount',
		'de': 'Anzahl der Anrufe',
		'vi': 'Số cuộc gọi',
		'th': 'จำนวนการโทร'
	},
	'Комментарий': {
		'ru': 'Комментарий',
		'uk': 'Коментарій',
		'en': 'Comment',
		'de': 'Kommentar',
		'vi': 'Bình luận',
		'th': 'ข้อคิดเห็น'
	},
	'Конверсии': {
		'ru': 'Конверсии',
		'uk': 'Конверсії',
		'en': 'Conversions',
		'de': 'Umwandlungen',
		'vi': 'Chuyển đổi',
		'th': 'การแปลงสภาพ'
	},
	'Конверсия': {
		'ru': 'Конверсия',
		'uk': 'Конверсія',
		'en': 'Conversion',
		'de': 'Umwandlungen',
		'vi': 'Chuyển đổi',
		'th': 'การแปลงสภาพ'
	},
	'Конкурсные': {
		'ru': 'Конкурсные',
		'uk': 'Конкурсні',
		'en': 'Contest',
		'de': 'Wettbewerb',
		'vi': 'Cạnh tranh',
		'th': 'ที่แข่งขันได้'
	},
	'Конструктор ссылок': {
		'ru': 'Конструктор ссылок',
		'uk': 'Конструктор посилань',
		'en': 'Link builder',
		'de': 'Link Builder',
		'vi': 'Thiết kế liên kết',
		'th': 'นักออกแบบลิ้งค์'
	},
	'Контакты': {
		'ru': 'Контакты',
		'uk': 'Контакти',
		'en': 'Contacts',
		'de': 'Kontakte',
		'vi': 'Liên hệ',
		'th': 'รายชื่อผู้ติดต่อ'
	},
	'Контекстная реклама': {
		'ru': 'Контекстная реклама',
		'uk': 'Контекстна реклама',
		'en': 'Context advertising',
		'de': 'Kontextwerbung',
		'vi': 'Quảng cáo theo ngữ cảnh',
		'th': 'ข้อความโฆษณา'
	},
	'Контекстная реклама на бренд': {
		'ru': 'Контекстная реклама на бренд',
		'uk': 'Контекстна реклама на бренд',
		'en': 'Brand context advertising',
		'de': 'Kontextwerbung für Marken',
		'vi': 'Quảng cáo theo ngữ cảnh cho thương hiệu',
		'th': 'โฆษณาทาง E-Commerceสำหรับยี่ห้อสินค้า'
	},
	'Конфиденциальность': {
		'ru': 'Конфиденциальность',
		'uk': 'Конфіденційність',
		'en': 'Privacy',
		'de': 'Datenschutz ',
		'vi': 'Bảo mật',
		'th': 'การรักษาความเป็นส่วนตัว'
	},
	'Копировать': {
		'ru': 'Копировать',
		'uk': 'Копіювати',
		'en': 'Copy',
		'de': 'Kopieren',
		'vi': 'Sao chép',
		'th': 'คัดลอกสำเนา'
	},
	'Коэффициенты': {
		'ru': 'Коэффициенты',
		'uk': 'Коефіцієнти',
		'en': 'Ratios',
		'de': 'Koeffizienten',
		'vi': 'Hệ số',
		'th': 'ค่าสัมประสิทธิ'
	},
	'Краткое описание': {
		'ru': 'Краткое описание',
		'uk': 'Короткий опис',
		'en': 'Short description',
		'de': 'Kurze Beschreibung',
		'vi': 'Mô tả ngắn',
		'th': 'การอธิบายฉบับย่อ'
	},
	'Л': { 'ru': 'Л', 'uk': 'Л', en: 'L', de: 'L', vi: 'L', th: 'การเหนี่ยวนำ' },
	'Лендинг': {
		'ru': 'Лендинг',
		'uk': 'Лендінг',
		'en': 'Landing',
		'de': 'Landing',
		'vi': 'Trang Landing',
		'th': 'หน้าโฆษณา'
	},
	'Лендинги': {
		'ru': 'Лендинги',
		'uk': 'Лендінги',
		'en': 'Landings',
		'de': 'Landings',
		'vi': 'Các trang landing',
		'th': 'ผู้คลิกดูโฆษณา'
	},
	'Личные данные': {
		'ru': 'Личные данные',
		'uk': 'Особисті дані',
		'en': 'Personal data',
		'de': 'Persönliche Daten',
		'vi': 'Thông tin cá nhân',
		'th': 'ข้อมูลส่วนบุคคล'
	},
	'Логин': {
		'ru': 'Логин',
		'uk': 'Логін',
		'en': 'Login',
		'de': 'Benutzername',
		'vi': 'Đăng nhập',
		'th': 'ล้อคอิน (การเปิดเข้าสู่คอมพิวเตอร์)'
	},
	'Макрос': {
		'ru': 'Макрос',
		'uk': 'Макрос',
		'en': 'Macro',
		'de': 'Macro',
		'vi': 'Macro',
		'th': 'แมโคร'
	},
	'менеджера, пожалуйста,': {
		'ru': 'менеджера, пожалуйста,',
		'uk': 'менеджера, будь ласка,',
		'en': 'about your manager, please',
		'de': 'über Ihre Manager geben möchten,',
		'vi': 'Xin gọi quản lý',
		'th': 'ผู้จัดการ, กรุณา'
	},
	'Минимум 100 символов. Данный текст будет видеть рекламодатель.': {
		'ru': 'Минимум 100 символов. Данный текст будет видеть рекламодатель.',
		'uk': 'Мінімум 100 символів. Даний текст буде бачити рекламодавець.',
		'en': 'At least 100 symbols. Advertisers will see this message.',
		'de': 'Mindestens 100 Symbole. Werbetreibender wird diese Nachricht sehen.',
		'vi': 'Tối thiểu 100 ký tự. Nhà quảng cáo sẽ thấy được văn bản này.',
		'th': 'ไม่น้อยกว่า 100 ตัวอักษร ผู้ลงโฆษณาจะมองเห็นคำอธิบายนี้'
	},
	'Метки': {
		'ru': 'Метки',
		'uk': 'Мітки',
		'en': 'Marks',
		'de': 'Marken',
		'vi': 'điểm',
		'th': 'เครื่องหมาย'
	},
	'Мобильный': {
		'ru': 'Мобильный',
		'uk': 'Мобільний',
		'en': 'Mobile',
		'de': 'Mobile',
		'vi': 'Di động',
		'th': 'แบบพกพาได้'
	},
	'Мои офферы': {
		'ru': 'Мои офферы',
		'uk': 'Мої офери',
		'en': 'My offers',
		'de': 'Meine Angebote',
		'vi': 'Các offer của tôi',
		'th': 'ข้อเสนอของฉัน'
	},
	'Мои площадки': {
		'ru': 'Мои площадки',
		'uk': 'Мої площадки',
		'en': 'My sources',
		'de': 'Meine Quellen',
		'vi': 'Các trang web của tôi',
		'th': 'พื้นที่ของฉัน'
	},
	'Мои потоки': {
		'ru': 'Мои потоки',
		'uk': 'Мої потоки',
		'en': 'My campaigns',
		'de': 'Meine kampagen',
		'vi': 'Các luồng của tôi',
		'th': 'กระแสเข้าชมเว็บของฉัน'
	},
	'Мотивированный': {
		'ru': 'Мотивированный',
		'uk': 'Мотивований',
		'en': 'Motivated',
		'de': 'Motiviert',
		'vi': 'Động lực',
		'th': 'ที่สร้างแรงจูงใจ'
	},
	'На дашборд': {
		'ru': 'На дашборд',
		'uk': 'На дашборд',
		'en': 'To dashboard',
		'de': 'zum Dashboard',
		'vi': 'Trên dashboard',
		'th': 'บนหน้าแดชบอร์ดคือหน้าแรกที่รวมข้อมูลที่สำคัญ'
	},
	'На сайте': {
		'ru': 'На сайте',
		'uk': 'На сайті',
		'en': 'On website',
		'de': 'Auf der Website',
		'vi': 'Trên trang web',
		'th': 'บนเว็บไซต์'
	},
	'На холде': {
		'ru': 'На холде',
		'uk': 'На холді',
		'en': 'On hold',
		'de': 'Auf hold',
		'vi': 'Đang giữ',
		'th': 'กำลังตรวจสอบ'
	},
	'Назад': {
		'ru': 'Назад',
		'uk': 'Назад',
		'en': 'Back',
		'de': 'Zurück',
		'vi': 'Trở lại',
		'th': 'ย้อนกลับไป'
	},
	'Назад к тикетам': {
		'ru': 'Назад к тикетам',
		'uk': 'Назад до тікетів',
		'en': 'Back to tickets list',
		'de': 'Zurück zur Ticketliste',
		'vi': 'Trở lại tickets',
		'th': 'กลับไปที่รายการการส่งคำถามหรือข้อร้องเรียน'
	},
	'Название': {
		'ru': 'Название',
		'uk': 'Назва',
		'en': 'Title',
		'de': 'Name',
		'vi': 'Tên',
		'th': 'ชื่อเรียก'
	},
	'Название потока': {
		'ru': 'Название потока',
		'uk': 'Назва потоку',
		'en': 'Campaign name',
		'de': 'Name des kampagen',
		'vi': 'Tên luồng',
		'th': 'ชื่อการเรียกดูภาพ'
	},
	'напишите нам': {
		'ru': 'напишите нам',
		'uk': 'напишіть нам',
		'en': 'contact us',
		'de': 'kontaktieren Sie uns bitte',
		'vi': 'viết cho chúng tôi',
		'th': 'เขียนหาเรา'
	},
	'Например, в случае, когда Вы ведете учет конверсий в сторонней системе статистики': {
		'ru': 'Например, в случае, когда Вы ведете учет конверсий в сторонней системе статистики',
		'uk': 'Наприклад, у випадку, коли Ви ведете облік конверсій у сторонній системі статистики',
		'en': 'Use cases include accounting conversions in third party statistics tools',
		'de': 'Wenn Sie zum Beispiel Conversion Tracking vom Drittanbieter nutzen',
		'vi': 'Ví dụ, trong trường hợp bạn đang tính toán chuyển đổi trong hệ thống thống kê của bên thứ ba',
		'th': 'ยกตัวอย้างเช่นในกรณีเมื่อคุณกำลังทำบัญชีเพื่อการแปลงค่าในระบบสถิติ'
	},
	'Настройка постбэка': {
		'ru': 'Настройка постбэка',
		'uk': 'Налаштування постбеку',
		'en': 'Postback settings',
		'de': 'Postback - Einstellung',
		'vi': 'Cài đặt Postback',
		'th': 'การตั้งค่าการส่งข้อมูลกลับไปยังตนเอง'
	},
	'Настройки': {
		'ru': 'Настройки',
		'uk': 'Налаштування',
		'en': 'Settings',
		'de': 'Einstellungen',
		'vi': 'Cài đặt',
		'th': 'การตั้งค่า'
	},
	'Настройки оповещений': {
		'ru': 'Настройки оповещений',
		'uk': 'Налаштування оповіщень',
		'en': 'Notification settings',
		'de': 'Benachrichtigungseinstellungen',
		'vi': 'Cài đặt thông báo',
		'th': 'การตั้งการแจ้งเตือน'
	},
	'Не использовать': {
		'ru': 'Не использовать',
		'uk': 'Не використовувати',
		'en': 'Don\'t use',
		'de': 'Nicht verwenden',
		'vi': 'Không dùng',
		'th': 'ห้ามใช้'
	},
	'Не нашли нужные лендинг или транзитку? Отправьте': {
		'ru': 'Не нашли нужные лендинг или транзитку? Отправьте',
		'uk': 'Не знайшли потрібні лендинг чи транзитку? Надішліть',
		'en': 'Have not found required landing or transit pages? Send',
		'de': 'Haben Sie keine Landing oder Transit Seiten gefunden? Senden Sie',
		'vi': 'Bạn không tìm thấy được trang landing hoặc trang transit cần thiết? Hãy gửi',
		'th': 'ไม่พบผู้คลิกหรือการเปลี่ยนผ่านใช่ไหม? ส่ง'
	},
	'Не слать постбэк по лидам со статусом trash': {
		'ru': 'Не слать постбэк по лидам со статусом trash',
		'uk': 'Не надсилати постбек по лідам зі статусом trash',
		'en': 'Do not send postback to leads with trash status',
		'de': 'Senden Sie kein Postback an Leads mit Papierkorbstatus',
		'vi': 'Không gửi bài đăng lại cho khách hàng tiềm năng với trạng thái thùng rác',
		'th': 'อย่าส่งไปรษณีย์กลับไปยังลูกค้าเป้าหมายที่มีสถานะเป็นถังขยะ'
	},
	'Неактивен': {
		'ru': 'Неактивен',
		'uk': 'Неактивний',
		'en': 'Inactive',
		'de': 'Inaktiv',
		'vi': 'Không hoạt động',
		'th': 'ไม่พร้อมใช้งาน'
	},
	'Невалидные': {
		'ru': 'Невалидные',
		'uk': 'Невалідні',
		'en': 'Invalid',
		'de': 'Ungültig',
		'vi': 'Không hợp lệ',
		'th': 'ไม่ตอบสนอง'
	},
	'Невалидный': {
		'ru': 'Невалидный',
		'uk': 'Невалідний',
		'en': 'Trash',
		'de': 'Müll',
		'vi': 'Không hợp lệ',
		'th': 'ใช้ไม่ได้'
	},
	'Некоторые рекламные системы используют utm-метки и подставляют их к партнерской ссылке': {
		'ru': 'Некоторые рекламные системы используют utm-метки и подставляют их к партнерской ссылке автоматически. В нашей системе у вас есть возможность смотреть статистику по таким меткам, аналогично меткам sid. Для этого нужно связать конкретные параметры utm-меток с конкретным sid.',
		'uk': 'Деякі рекламні системи використовують utm-мітки та підставляють їх до партнерського посилання автоматично. У нашій системі у вас є можливість дивитися статистику за такими мітками, аналогічно міткам sid. Для цього потрібно зв\'язати конкретні параметри utm-міток із конкретним sid.',
		'en': 'Some advertising systems use utm-tags and substitute them to the affiliate link automatically. In our system, you have the ability to view statistics on such labels, similar to the sid tags. To do this, you need to associate specific parameters of utm-labels with a specific sid.',
		'de': 'Einige Werbesysteme generieren UTM-Tags automatisch.',
		'vi': 'Một số hệ thống quảng cáo sử dụng các dấu utm và tự động đính kèm nó cho liên kết đối tác. Trong hệ thống của chúng tôi, bạn có cơ hội xem số liệu thống kê các dấu đó, cũng như các dấu sid. Để làm điều này, bạn cần kết hợp các thông số cụ thể của các dấu utm với một sid cụ thể.',
		'th': 'ระบบโฆษณาบางระบบใช้ป้ายกำกับUTMและเชื่อมเวบไซต์หรือพื้นที่ออนไลน์อัตโนมัติ ในระบบของเราคุณมีโอกาสชมสถิติในป้ายกำกับนั้นเช่นนั้นเหมือนกับติดป้ายกำกับระบุความปลอดภัย\nเพื่อที่จะทำสิ่งนี้ คุณต้องเชื่อมโยงค่าตัวแปรเฉพาะที่ได้กำหนดไว้ที่ป้ายกำกับUTMพร้อมกับตัวระบุความปลอดภัยพิเศษ'
	},
	'Нет, остались вопросы': {
		'ru': 'Нет, остались вопросы',
		'uk': 'Ні, залишилися питання',
		'en': 'No, I have more questions',
		'de': 'Nein, ich habe noch Fragen',
		'vi': 'Chưa, những câu hỏi vẫn còn',
		'th': 'ไม่ คำถามยังคงค้างอยู่'
	},
	'нет комментария': {
		'ru': 'нет комментария',
		'uk': 'немає коментаря',
		'en': 'no comment',
		'de': 'kein Kommentar',
		'vi': 'miễn bình luận',
		'th': 'ไม่มีความเห็น'
	},
	'новинка': {
		'ru': 'новинка',
		'uk': 'новинка',
		'en': 'new',
		'de': 'neue',
		'vi': 'mới nhất',
		'th': 'มือใหม่'
	},
	'Новые': {
		'ru': 'Новые',
		'uk': 'Нові',
		'en': 'New',
		'de': 'Neue',
		'vi': 'Ḿi nhất',
		'th': 'มือใหม่'
	},
	'Партнерские': {
		'ru': 'Партнерские',
		'uk': 'Партнерскі',
		'en': 'Affiliate',
		'de': 'Affiliate',
		'vi': 'Chi nhánh',
		'th': 'หุ้นส่วน'
	},
	'Новинка': { 'ru': 'Новинка', 'uk': 'Новинка', en: 'New', de: 'Neu', vi: 'Mới', th: 'ใหม่' },
	'Новое сообщение': {
		'ru': 'Новое сообщение',
		'uk': 'Нове повідомлення',
		'en': 'New message',
		'de': 'Neue Nachricht',
		'vi': 'Tin nhắn mới',
		'th': 'ข้อความใหม่'
	},
	'Присоединяйся к нам в соц сетях': {
		'ru': 'Присоединяйся к нам в соц сетях',
		'uk': 'Приєднуйся до нас в соц мережах',
		'en': 'Join us on social networks',
		'de': 'Besuchen Sie uns in sozialen Netzwerken',
		'vi': 'Tham gia với chúng tôi trên các mạng xã hội',
		'th': 'เข้าร่วมกับเราบนเครือข่ายสังคม'
	},
	'Новости': {
		'ru': 'Новости',
		'uk': 'Новини',
		'en': 'News',
		'de': 'Nachrichten',
		'vi': 'Tin tức',
		'th': 'ข่าวสาร'
	},
	'Новости Everad': {
		'ru': 'Новости Everad',
		'uk': 'Новини Everad',
		'en': 'Everad news',
		'de': 'Everad Nachrichten',
		'vi': 'Tin tức Everad',
		'th': 'ข่าว Everad'
	},
	'Telegram группа': {
		'ru': 'Telegram группа',
		'uk': 'Telegram група',
		'en': 'Telegram group',
		'de': 'Telegramm gruppe',
		'vi': 'Nhóm Telegram',
		'th': 'กลุ่มโทรเลข'
	},
	'Telegram канал': {
		'ru': 'Telegram канал',
		'uk': 'Telegram канал',
		'en': 'Telegram channel',
		'de': 'Telegramm kanal',
		'vi': 'Kênh Telegram',
		'th': 'ช่องโทรเลข'
	},
	'Страница в Facebook': {
		'ru': 'Страница в Facebook',
		'uk': 'Сторінка в Facebook',
		'en': 'Facebook page',
		'de': 'Facebook Seite',
		'vi': 'trang Facebook',
		'th': 'หน้า Facebook'
	},
	'Страница в VK': {
		'ru': 'Страница в VK',
		'uk': 'Сторінка в VK',
		'en': 'VK page',
		'de': 'VK Seite',
		'vi': 'trang VK',
		'th': 'หน้า VK'
	},
	'Новые офферы': {
		'ru': 'Новые офферы',
		'uk': 'Нові офери',
		'en': 'New offers',
		'de': 'Neue Angebote',
		'vi': 'Các offer mới',
		'th': 'ข้อเสนอใหม่ๆ'
	},
	'ТОП офферы': {
		'ru': 'ТОП офферы',
		'uk': 'ТОП офери',
		'en': 'TOP offers',
		'de': 'TOP Angebote',
		'vi': 'Ưu đãi hàng đầu',
		'th': 'ข้อเสนอยอดนิยม'
	},
	'идентификатор оффера': {
		'ru': 'идентификатор оффера',
		'uk': 'ідентификатор оферу',
		'en': 'offer identifier',
		'de': 'Angebots-ID',
		'vi': 'id cung cấp',
		'th': 'รหัสข้อเสนอพิเศษ'
	},
	'код страны': {
		'ru': 'код страны',
		'uk': 'код країни',
		'en': 'country code',
		'de': 'Landcode',
		'vi': 'mã quốc gia',
		'th': 'รหัสประเทศ'
	},
	'Мастер-Аккаунты': {
		'ru': 'Мастер-Аккаунты',
		'uk': 'Майстер-Акаунти',
		'en': 'Master-accounts',
		'de': 'Master-accounts',
		'vi': 'Master-accounts',
		'th': 'Master-accounts'
	},
	'IP адрес': {
		'ru': 'IP адрес',
		'uk': 'IP адреса',
		'en': 'IP address',
		'de': 'IP adres',
		'vi': 'địa chỉ IP',
		'th': 'ที่อยู่ IP'
	},
	'Новый пароль': {
		'ru': 'Новый пароль',
		'uk': 'Новий пароль',
		'en': 'New password',
		'de': 'Neues Passwort',
		'vi': 'Mật khẩu mới',
		'th': 'รหัสผ่านใหม่'
	},
	'О нас': {
		'ru': 'О нас',
		'uk': 'Про нас',
		'en': 'About us',
		'de': 'Über uns',
		'vi': 'Giới thiệu về chúng tôi',
		'th': 'เกี่ยวกับเรา'
	},
	'О системе': {
		'ru': 'О системе',
		'uk': 'Про систему',
		'en': 'About',
		'de': 'Über uns',
		'vi': 'Về hệ thống',
		'th': 'เกี่ยวกับระบบ'
	},
	'Общая': {
		'ru': 'Общая',
		'uk': 'Загальна',
		'en': 'General',
		'de': 'Allgemein',
		'vi': 'Chung',
		'th': 'ทั่วไป'
	},
	'Общий размер загруженных файлов': {
		'ru': 'Общий размер загруженных файлов',
		'uk': 'Спільний розмір завантажених файлів',
		'en': 'Total attachments size',
		'de': 'Gesamtdateigröße',
		'vi': 'Tổng kích thước của tệp được tải lên',
		'th': 'ขนาดทั้งหมดของการโอนย้ายไฟล์'
	},
	'Общий размер загруженных файлов не более 5 МБ': {
		'ru': 'Общий размер загруженных файлов не более 5 МБ',
		'uk': 'Загальний розмір завантажених файлів не більше 5 МБ',
		'en': 'Maximum attachments size 5MB',
		'de': 'Die Größe aller Attachments darf 5 MB nicht überschreiten.',
		'vi': 'Tổng kích thước của các tệp tin được tải không nên quá 5 MB',
		'th': 'ขนาดไฟล์ที่อัพโหลดไม่เกิน 5 MB'
	},
	'Ожидает': {
		'ru': 'Ожидает',
		'uk': 'Очікує',
		'en': 'Pending',
		'de': 'Im Wartezustand',
		'vi': 'Đang chờ',
		'th': 'กำลังรอ'
	},
	'Ожидается активация': {
		'ru': 'Ожидается активация',
		'uk': 'Очікує активації',
		'en': 'Waiting for activation',
		'de': 'Auf Aktivierung warten',
		'vi': 'Kích hoạt đang chờ xử lý',
		'th': 'กำลังอยู่ระหว่างการยืนยันตัวตน'
	},
	'Ожидание ответа': {
		'ru': 'Ожидание ответа',
		'uk': 'Очікує відповіді',
		'en': 'Awaiting answer',
		'de': 'Warten auf eine Antwort',
		'vi': 'Đang đợi phản hồi',
		'th': 'กำลังรอคำตอบ'
	},
	'Описание': {
		'ru': 'Описание',
		'uk': 'Опис',
		'en': 'Description',
		'de': 'Beschreibung',
		'vi': 'Miêu tả',
		'th': 'คำอธิบาย'
	},
	'Основное': {
		'ru': 'Основное',
		'uk': 'Основне',
		'en': 'Main',
		'de': 'Hauptsächlich',
		'vi': 'Chính',
		'th': 'พื้นฐาน'
	},
	'Основные': {
		'ru': 'Основные',
		'uk': 'Основні',
		'en': 'Main',
		'de': 'Hauptsächlich',
		'vi': 'Chính',
		'th': 'พื้นฐาน'
	},
	'Оставьте поле пустым и сабдомен будет сгенерирован автоматически.': {
		'ru': 'Оставьте поле пустым и сабдомен будет сгенерирован автоматически.',
		'uk': 'Залишіть поле порожнім і сабдомен буде згенеровано автоматично.',
		'en': 'Leave the field empty and the subdomain will be generated automatically.',
		'de': 'Lassen Sie das Feld leer und die Subdomain wird automatisch generiert.',
		'vi': 'Để ô trống và tên miền phụ sẽ được tạo một cách tự động.',
		'th': 'ไม่ต้องใส่รหัสผ่านและหน้าเว็บไซต์ย่อยจะถูกสร้างขึ้นมาโดยอัตโนมัติ'
	},
	'Остановлено': {
		'ru': 'Остановлено',
		'uk': 'Зупинено',
		'en': 'Stopped at',
		'de': 'Gestoppt',
		'vi': 'Đã dừng',
		'th': 'หยุดแล้ว'
	},
	'От администрации': {
		'ru': 'От администрации',
		'uk': 'Від адміністрації',
		'en': 'From administration',
		'de': 'Von Administration',
		'vi': 'Từ quản trị',
		'th': 'จากฝ่ายบริหาร'
	},
	'Ответы': {
		'ru': 'Ответы',
		'uk': 'Відповіді',
		'en': 'Answers',
		'de': 'Antworten',
		'vi': 'Các câu trả lời',
		'th': 'คำตอบ'
	},
	'Отклонено': {
		'ru': 'Отклонено',
		'uk': 'Відхилено',
		'en': 'Rejected',
		'de': 'Abgelehnt',
		'vi': 'Bị từ chối',
		'th': 'ไม่ได้รับการอนุมัติ'
	},
	'Отменить': {
		'ru': 'Отменить',
		'uk': 'Відмінити',
		'en': 'Cancel',
		'de': 'Löschen',
		'vi': 'Hủy bỏ',
		'th': 'ยกเลิก'
	},
	'Отправить тикет': {
		'ru': 'Отправить тикет',
		'uk': 'Відправити тікет',
		'en': 'Submit ticket',
		'de': 'Ticket einreichen',
		'vi': 'Gửi ticket',
		'th': 'ส่งคำถามหรือคำร้อง'
	},
	'Отправить тикет в систему': {
		'ru': 'Отправить тикет в систему',
		'uk': 'Відправити тікет в систему',
		'en': 'Create ticket',
		'de': 'Ticket aufgeben',
		'vi': 'Gửi ticket vào hệ thống',
		'th': 'ส่งคำถามหรือข้อร้องเรียนไปยังระบบ'
	},
	'Оффер': {
		'ru': 'Оффер',
		'uk': 'Офер',
		'en': 'Offer',
		'de': 'Angebot',
		'vi': 'Offer',
		'th': 'ข้อเสนอ'
	},
	'Офферы': {
		'ru': 'Офферы',
		'uk': 'Офери',
		'en': 'Offers',
		'de': 'Angebote',
		'vi': 'Các offer',
		'th': 'ข้อเสนอต่างๆ'
	},
	'Место в ТОПе': {
		'ru': 'Ваше место в ТОПе конкурса The Wolf of Everad',
		'uk': 'Ваше місце у ТОПі конкурсу The Wolf of Everad',
		'en': 'Your place in TOP of The Wolf of Everad',
		'de': 'Your place in TOP of The Wolf of Everad',
		'vi': 'Your place in TOP of The Wolf of Everad',
		'th': 'Your place in TOP of The Wolf of Everad'
	},
	'Очистить': {
		'ru': 'Очистить',
		'uk': 'Очистити',
		'en': 'Clear',
		'de': 'Löschen',
		'vi': 'Xóa',
		'th': 'ทำให้ว่าง ลบล้าง'
	},
	'Ошибка!': {
		'ru': 'Ошибка!',
		'uk': 'Помилка!',
		'en': 'Error!',
		'de': 'Fehler!',
		'vi': 'Lỗi!',
		'th': 'ผิดพลาด'
	},
	'Парковка': {
		'ru': 'Парковка',
		'uk': 'Парковка',
		'en': 'Parking',
		'de': 'Parkplatz',
		'vi': 'Parking',
		'th': 'ที่จอดรถ'
	},
	'Пароли должны совпадать': {
		'ru': 'Пароли должны совпадать',
		'uk': 'Паролі повинні співпадати',
		'en': 'Passwords must match',
		'de': 'Die Passwörter müssen übereinstimmen',
		'vi': 'Mật khẩu phải như nhau',
		'th': 'รหัสผ่านต้องตรงกัน'
	},
	'Пароль': {
		'ru': 'Пароль',
		'uk': 'Пароль',
		'en': 'Password',
		'de': 'Passwort',
		'vi': 'Mật khẩu',
		'th': 'รหัสผ่าน'
	},
	'Пароль должен состоять не менее чем из шести символов': {
		'ru': 'Пароль должен состоять не менее чем из шести символов',
		'uk': 'Пароль повинен складатися не менше ніж із шести символів',
		'en': 'New password must be at least six characters long',
		'de': 'Das Passwort muss mindestens sechs Zeichen enthalten',
		'vi': 'Mật khẩu phải có ít nhất sáu ký tự',
		'th': 'รหัสผ่านต้องยาวอย่างน้อยที่สุด6ตัวอักษร'
	},
	'Партнёрская сеть %s': {
		'ru': 'Партнёрская сеть %s',
		'uk': 'Партнерська мережа %s',
		'en': '%s affiliate network',
		'de': '%s Affiliate-Netzwerk',
		'vi': 'Mạng đối tác %s',
		'th': 'พันธมิตรด้านการตลาด %s'
	},
	'Первый параметр': {
		'ru': 'Первый параметр',
		'uk': 'Перший параметр',
		'en': 'First setting',
		'de': 'Erste Parameter',
		'vi': 'Tham số đầu tiên',
		'th': 'ค่าตัวแปรอันดับแรก'
	},
	'Перевод средств на баланс': {
		'ru': 'Перевод средств на баланс',
		'uk': 'Переказ коштів на баланс',
		'en': 'Transfer of funds to the balance',
		'de': 'Überweisung von Geldern auf Ihr Saldo',
		'vi': 'Chuyển tiền sang số dư',
		'th': 'การโอนเงินไปยังเงินคงเหลือ'
	},
	'Переходы': {
		'ru': 'Переходы',
		'uk': 'Переходи',
		'en': 'Transitions',
		'de': 'Übergänge',
		'vi': 'Các chuyển tiếp',
		'th': 'การเชื่อมโยง'
	},
	'Платежные данные': {
		'ru': 'Платежные данные',
		'uk': 'Платіжні дані',
		'en': 'Payout systems',
		'de': 'Zahlungsdaten',
		'vi': 'Thông tin thanh toán',
		'th': 'ข้อมูลรายจ่าย'
	},
	'Площадка': {
		'ru': 'Площадка',
		'uk': 'Площадка',
		'en': 'Source',
		'de': 'Platz',
		'vi': 'Trang web',
		'th': 'พื้นที่'
	},
	'Площадки': {
		'ru': 'Площадки',
		'uk': 'Площадки',
		'en': 'Sources',
		'de': 'Quellen',
		'vi': 'Các trang web',
		'th': 'พื้นที่'
	},
	'По Вашему запросу нет данных': {
		'ru': 'По Вашему запросу нет данных',
		'uk': 'По Вашему запиту немає даних',
		'en': 'Your request did not return any data',
		'de': 'Ihre Abfrage hat keine Daten zurückgegeben.',
		'vi': 'Không có dữ liệu nào theo yêu cầu của Bạn',
		'th': 'ไม่มีข้อมูลตามคำขอของท่าน'
	},
	'Повторите новый пароль': {
		'ru': 'Повторите новый пароль',
		'uk': 'Повторіть новий пароль',
		'en': 'Confirm new password',
		'de': 'Neues Passwort wiederholen',
		'vi': 'Lặp lại mật khẩu mới',
		'th': 'กรอกรหัสผ่านใหม่ซ้ำ'
	},
	'Под.': {
		'ru': 'Под.',
		'uk': 'Під.',
		'en': 'Appr.',
		'de': 'Bestätigt',
		'vi': 'Dưới',
		'th': 'ภายใต้'
	},
	'Поддержка': {
		'ru': 'Поддержка',
		'uk': 'Підтримка',
		'en': 'Support',
		'de': 'Hilfe',
		'vi': 'Hỗ trợ',
		'th': 'การช่วยเหลือลูกค้า'
	},
	'поддержку!': {
		'ru': 'поддержку!',
		'uk': 'підтримку!',
		'en': 'support!',
		'de': 'Unterstützung!',
		'vi': 'hỗ trợ!',
		'th': 'สนับสนุน!'
	},
	'Подключить оффер': {
		'ru': 'Подключить оффер',
		'uk': 'Підключити офер',
		'en': 'Add offer',
		'de': 'Angebot hinzufügen',
		'vi': 'Kết nối offer',
		'th': 'เชื่อมต่อข้อเสนอ'
	},
	'Подключить': {
		'ru': 'Подключить',
		'uk': 'Підключити',
		'en': 'Connect',
		'de': 'Verbinden',
		'vi': 'Kết nố',
		'th': 'ต่อ'
	},
	'Подтв.': {
		'ru': 'Подтв.',
		'uk': 'Підтв.',
		'en': 'Appr.',
		'de': 'Bestätigt',
		'vi': 'Xác nhận',
		'th': 'ยืนยัน'
	},
	'Подтверждена': {
		'ru': 'Подтверждена',
		'uk': 'Підтвержена',
		'en': 'Approved',
		'de': 'Bestätigt',
		'vi': 'Xác nhận',
		'th': 'ยืนยันแล้ว'
	},
	'Подтверждено': {
		'ru': 'Подтверждено',
		'uk': 'Підтвержено',
		'en': 'Approved',
		'de': 'Bestätigt',
		'vi': 'Xác nhận',
		'th': 'ยืนยันแล้ว'
	},
	'Пожалуйста, подтвердите свой Email, чтобы иметь возможность заказывать выплаты': {
		'ru': 'Пожалуйста, подтвердите свой Email, чтобы иметь возможность заказывать выплаты',
		'uk': 'Будь ласка, підтвердіть свій e-mail, щоб мати можливість замовляти виплати',
		'en': 'Please confirm your Email to be able to request payouts',
		'de': 'Bestätigen Sie bitte Ihre E-Mail-Adresse um Ihre Zahlungen zu bestellen',
		'vi': 'Vui lòng xác nhận email của bạn để có thể đặt thanh toán',
		'th': 'โปรดยืนยันอีเมลของคุณเพื่อที่จะสามารถชำระเงินตามคำสั่งซื้อได้'
	},
	'Пожалуйста, покажите скриншот статистики.': {
		'ru': 'Пожалуйста, покажите скриншот статистики.',
		'uk': 'Покажіть скріншот статистики.',
		'en': 'Please provide a screenshot of your statistics.',
		'de': 'Senden sie bitte einen Screenshot Ihrer Statistik.',
		'vi': 'Vui lòng cho xem ảnh chụp màn hình của thống kê.',
		'th': 'โปรดแสดงภาพหน้าจอของสถิติ'
	},
	'Пожалуйста, укажите в тикете ссылку на нужный лэндинг/транзитку.': {
		'ru': 'Пожалуйста, укажите в тикете ссылку на нужный лэндинг/транзитку.',
		'uk': 'Будь ласка, вкажіть у тикеті посилання на потрібний лендінг/транзит.',
		'en': 'Please, provide a link to the required landing/transit page in the ticket.',
		'de': 'Geben Sie bitte einen Link auf gewünschte Landing/Transit Seite in dem Ticket',
		'vi': 'Xin vui lòng cho để trong ticket liên kết của trang transit/landing cần thiết.',
		'th': 'โปรดระบุลิ้งค์ที่เชื่อมโยงไปยังหน้าโฆษณาหรือหน้าเชื่อมต่อจากลิ้งค์'
	},
	'Поиск по новостям, офферам': {
		'ru': 'Поиск по новостям, офферам',
		'uk': 'Пошук за новинами, офферами',
		'en': 'Search news, offers',
		'de': 'Suchen nach Nachrichten, Angeboten',
		'vi': 'Tìm kiếm theo tin tức, offer',
		'th': 'หาตามข่าวสาร, ตามข้อเสนอ'
	},
	'Поиск по офферам': {
		'ru': 'Поиск по офферам',
		'uk': 'Пошук за офферами',
		'en': 'Search offers',
		'de': 'Suchen nach Angebote',
		'vi': 'Tìm kiếm theo các offer',
		'th': 'หาจากข้อเสนอต่างๆ'
	},
	'Поиск по потокам': {
		'ru': 'Поиск по потокам',
		'uk': 'Пошук за потоками',
		'en': 'Search campaigns',
		'de': 'Suchen nach kampagnen',
		'vi': 'Tìm luồng',
		'th': 'ค้นหาโดยการเรียกดูภาพ'
	},
	'Показать ещё': {
		'ru': 'Показать ещё',
		'uk': 'Показати ще',
		'en': 'Show more',
		'de': 'Zeigen mehr',
		'vi': 'Hiển thị nhiều hơn',
		'th': 'แสดงอีก'
	},
	'Полное описание': {
		'ru': 'Полное описание',
		'uk': 'Повний опис',
		'en': 'Full description',
		'de': 'Gesamte Beschreibung',
		'vi': 'Mô tả đầy đủ',
		'th': 'การอธิบายฉบับเต็ม'
	},
	'Получать новости сети': {
		'ru': 'Получать новости сети',
		'uk': 'Отримати новини мережі',
		'en': 'Receive news from the network',
		'de': 'Nachrichten aus dem Netzwerk erhalten',
		'vi': 'Nhận tin tức về mạng lưới',
		'th': 'รับข่าวจากเครือข่าย'
	},
	'Получать уведомления о новых офферах': {
		'ru': 'Получать уведомления о новых офферах',
		'uk': 'Отримати сповіщення про нові оффери',
		'en': 'Receive notifications about new offers',
		'de': 'Benachrichtigungen über neue Angebote erhalten.',
		'vi': 'Nhận thông báo về các offer mới',
		'th': 'รับการแจ้งข้อเสนอใหม่'
	},
	'Получать уведомления о новых сообщениях в тикетах': {
		'ru': 'Получать уведомления о новых сообщениях в тикетах',
		'uk': 'Отримати сповіщення про нові повідомлення та тікети',
		'en': 'Receive notifications of new messages in tickets',
		'de': 'Benachrichtigungen über neuen Nachrichten in den Tickets erhalten',
		'vi': 'Nhận thông báo về tin nhắn mới trong các ticket',
		'th': 'ได้รับแจ้งข้อความใหม่ในหน้าเว็บ'
	},
	'Получать уведомления об изменении офферов': {
		'ru': 'Получать уведомления об изменении офферов',
		'uk': 'Отримати сповіщення про зміни офферів',
		'en': 'Receive notifications of the offers changes',
		'de': 'Benachrichtigungen über Angebotsänderungen erhalten',
		'vi': 'Nhận thông báo về những thay đổi offer',
		'th': 'รับการแจ้งการเปลี่ยนแปลงข้อเสนอ'
	},
	'Часы': {
		'ru': 'Часы',
		'uk': 'Години',
		'en': 'Hours',
		'de': 'Std.',
		'vi': 'Đồng hồ',
		'th': 'นาฬิกา'
	},
	'Помог ли менеджер решить Ваш вопрос?': {
		'ru': 'Помог ли менеджер решить Ваш вопрос?',
		'uk': 'Чи допоміг менеджер вирішити ваше питання?',
		'en': 'Did the manager help you solve your question?',
		'de': 'Hat unser Manager geholfen, Ihre Problem zu lösen?',
		'vi': 'Người quản lý có giúp bạn giải quyết vấn đề của bạn không?',
		'th': 'ผู้จัดการได้ช่วยแก้ปัญหาให้คุณหรือไม่?'
	},
	'понедельник': {
		'ru': 'понедельник',
		'uk': 'понеділок',
		'en': 'monday',
		'de': 'Montag',
		'vi': 'thứ hai',
		'th': 'วันจันทร์'
	},
	'Постбэк': {
		'ru': 'Постбэк',
		'uk': 'Постбек',
		'en': 'Postback',
		'de': 'Postback',
		'vi': 'Postback',
		'th': 'การโพสต์ย้อนกลับ'
	},
	'Постбэк URL': {
		'ru': 'Постбэк URL',
		'uk': 'Постбек URL',
		'en': 'Postback URL',
		'de': 'Postback URL',
		'vi': 'Postback URL',
		'th': 'โพสต์ย้อนกลับไปยังURL'
	},
	'Постбэк URL будет полезен, если Вам необходимо в автоматическом режиме получать': {
		'ru': 'Постбэк URL будет полезен, если Вам необходимо в автоматическом режиме получать',
		'uk': 'Постбек URL буде корисний, коли Вам необхідно в автоматичному режимі отримати',
		'en': 'Postback URL is useful when you need to receive',
		'de': 'Postback - URL wird nützlich sein, wenn Sie',
		'vi': 'Postback URL sẽ hữu ích nếu bạn cần tự động nhận',
		'th': 'ส่งโพสต์ย้อนกลับURLจะมีประโยชน์หากคุณต้องการรับข้อมูลโดยอัตโนมัติ'
	},
	'Постбэк запрос будет отправлен на указанный адрес методом': {
		'ru': 'Постбэк запрос будет отправлен на указанный адрес методом',
		'uk': 'Постбек запит буде відправлено на вказану адресу методом',
		'en': 'Postback request will be sent to specified address using method',
		'de': 'Postback Anfrage wird mit der Methode an die angegebene Adresse gesendet',
		'vi': 'Yêu cầu postback sẽ được gửi đến địa chỉ đã chỉ định bằng cách',
		'th': 'คำร้องขอการส่งย้อนกลับจะถูกส่งไปยังที่อยู่ที่ระบุเฉพาะด้วยวิธี'
	},
	'Постбэк запрос будет отправлен на указанный адрес методом GET.': {
		'ru': 'Постбэк запрос будет отправлен на указанный адрес методом GET.',
		'uk': 'Постбек запит буде відправлено на вказану адресу методом GET.',
		'en': 'A postback request will be sent to the specified address using the GET method.',
		'de': 'Postback Anfrage wird mit dem GET Method an die gewünschte Adresse gesendet werden.',
		'vi': 'Yêu cầu postback sẽ được gửi tới địa chỉ được xác định bằng phương thức GET.',
		'th': 'คำร้องขอการย้อนกลับไปจะถูกส่งไปยังที่อยู่ที่ระบุไว้โดยใช้ตัวแปรที่สร้างขึ้นไว้ในไฟล์'
	},
	'Постбэк лог': {
		'ru': 'Постбэк лог',
		'uk': 'Постбек лог',
		'en': 'Postback log',
		'de': 'Postback log',
		'vi': 'Log postback',
		'th': 'แสดงสถานะของการส่งข้อมูลกลับ'
	},
	'Постбэк при смене статуса': {
		'ru': 'Постбэк при смене статуса',
		'uk': 'Постбек при зміні статусу',
		'en': 'Postback on conversion status change',
		'de': 'Postback bei der Statusänderung ',
		'vi': 'Postback khi đổi trạng thái',
		'th': 'โพสต์ย้อนกลับเปลี่ยนสเมื่อมีการถานะ'
	},
	'Лиды в статусе "approved"': {
		'ru': 'Лиды в статусе "approved"',
		'uk': 'Ліди в статусі "approved"',
		'en': 'Approved conversions',
		'de': 'Approved conversions',
		'vi': 'Approved conversions',
		'th': 'Approved conversions'
	},
	'Не слать постбек по restricted регионам': {
		'ru': 'Не слать постбек по restricted регионам',
		'uk': 'Не слати постбек по restricted регіонам',
		'en': "Don't send restricted region postback",
		'de': "Don't send restricted region postback",
		'vi': "Don't send restricted region postback",
		'th': "Don't send restricted region postback"
	},
	'Постбек при смене payout': {
		'ru': 'Постбек при смене payout-а',
		'uk': 'Постбек при зміні payout-а',
		'en': "Postback on payout change",
		'de': "Postback on payout change",
		'vi': "Postback on payout change",
		'th': "Postback on payout change"
	},
	'Лиды в статусе "rejected"': {
		'ru': 'Лиды в статусе "rejected"',
		'uk': 'Ліди в статусі "rejected"',
		'en': "Rejected conversions",
		'de': "Rejected conversions",
		'vi': "Rejected conversions",
		'th': "Rejected conversions"
	},
	'Слать выплату только по апрувнутым лидам': {
		'ru': 'Слать выплату только по апрувнутым лидам',
		'uk': 'Слати виплату тільки по апрувнутим лідам',
		'en': 'Send payment only for approved leads',
		'de': 'Senden Sie die Zahlung nur für genehmigte Leads',
		'vi': 'Chỉ gửi thanh toán cho các khách hàng tiềm năng được chấp thuận',
		'th': 'ส่งการชำระเงินสำหรับโอกาสในการขายที่ได้รับอนุมัติเท่านั้น'
	},
	'Лиды в статусе "pending"': {
		'ru': 'Лиды в статусе "pending"',
		'uk': 'Ліди в статусі "pending"',
		'en': 'Pending conversions',
		'de': 'Pending conversions',
		'vi': 'Pending conversions',
		'th': 'Pending conversions'
	},
	'Постклик': {
		'ru': 'Постклик',
		'uk': 'Постклік',
		'en': 'Postclick',
		'de': 'Postclick',
		'vi': 'PostClick',
		'th': 'PostClick'
	},
	'Поток': {
		'ru': 'Поток',
		'uk': 'Потік',
		'en': 'Campaign',
		'de': 'Kam­pa­g­ne',
		'vi': 'Luồng',
		'th': 'การไหลเวียนในเครือข่าย'
	},
	'Потоки': {
		'ru': 'Потоки',
		'uk': 'Потоки',
		'en': 'Campaigns',
		'de': 'Kampagnen',
		'vi': 'Các luồng',
		'th': 'แคมเปญ'
	},
	'Запрос': {
		'ru': 'Запрос',
		'uk': 'Запит',
		'en': 'Request',
		'de': 'Request',
		'vi': 'Request',
		'th': 'Request'
	},
	'Правила': {
		'ru': 'Правила',
		'uk': 'Правила',
		'en': 'Terms',
		'de': 'Regeln',
		'vi': 'Quy tắc',
		'th': 'กฎระเบียบ'
	},
	'Выберите оффер': {
		'ru': 'Выберите оффер',
		'uk': 'Виберіть оффер',
		'en': 'Select an offer',
		'de': 'Wählen Sie ein Angebot',
		'vi': 'Chọn đề  offer',
		'th': 'เลือกข้อเสนอพิเศษ'
	},
	'превышает лимит в 5МБ': {
		'ru': ' превышает лимит в 5МБ',
		'uk': ' перевищує лімит в 5МБ',
		'en': ' exceeds the limit of 5MB',
		'de': 'überschreitet die maximal zulässige Größe (5 MB)',
		'vi': 'vượt quá giới hạn 5MB',
		'th': 'เกินขนาดที่จำกัด5เมกะไบต์'
	},
	'Превью лэндинга': {
		'ru': 'Превью лэндинга',
		'uk': 'Превью лендингу',
		'en': 'Landing Preview',
		'de': 'Landing Preview',
		'vi': 'Landing preview',
		'th': 'การชมร้านค้าก่อน'
	},
	'Превью транзитки': {
		'ru': 'Превью транзитки',
		'uk': 'Превью транзитки',
		'en': 'Transit Preview',
		'de': 'Transit Preview',
		'vi': 'Preview trang transit',
		'th': 'ตัวอย่างหน้าเชื่อมต่อไปยังหน้าเว็บอื่น'
	},
	'предпочтение отдается параметру sid.': {
		'ru': 'предпочтение отдается параметру sid.',
		'uk': 'перевага віддаєтся параметру sid.',
		'en': 'preference is given to the sid parameter.',
		'de': 'bevorzugte Stellung hat SID Parameter.',
		'vi': 'tham số sid được ưu tiên',
		'th': 'ความชอบถูกให้ไปยังค่าระบุความปลอดภัย'
	},
	'При настроенном постбэке в каком-то из потоков, он имеет приоритет над глобальным.': {
		'ru': 'При настроенном постбэке в каком-то из потоков, он имеет приоритет над глобальным.',
		'uk': 'При налаштованому постбеку в одному з потоків він має пріоритет над глобальним.',
		'en': 'When a postback is configured in one of the campaigns, it has priority over the global one.',
		'de': 'Wenn Postback für eine Kampagne konfiguriert ist, es hat Vorrang vor dem Globalen.',
		'vi': 'Nếu postback được cấu hình trong một luồng nó có ưu tiên trên postback toàn cầu.',
		'th': 'ถ้ามีการจัดการย้อนกลับไปที่บางการทำงานย่อยที่มีการแบ่งปันทรัพยากรต่างๆก็จะมีความสำคัญเหนือตำแหน่งโลก'
	},
	'При сохранении будет сгенерирован новый ключ сплит-сессии.': {
		'ru': 'При сохранении будет сгенерирован новый ключ сплит-сессии.',
		'uk': 'При збереженні буде згенеровано новий ключ спліт-сесії.',
		'en': 'New split-session key will be generated on save',
		'de': 'Beim Speichern wird ein neuer Schlüssel Split-Session generiert.',
		'vi': 'Khi lưu sẽ có một khoá phiên mới sẽ được tạo ra.',
		'th': 'เมื่อบันทึก เนื้อหาสำคัญของการแยกประชุมใหม่จะถูกสร้างขึ้น'
	},
	'Прикрепить файл': {
		'ru': 'Прикрепить файл',
		'uk': 'Прикріпити файл',
		'en': 'Add attachment',
		'de': 'Datei anhängen',
		'vi': 'Đính kèm tệp',
		'th': 'แนบไฟล์'
	},
	'Применить': {
		'ru': 'Применить',
		'uk': 'Застосувати',
		'en': 'Apply',
		'de': 'Bestätigen',
		'vi': 'Áp dụng',
		'th': 'การสมัคร การประยุกต์'
	},
	'Автотреш обьяснение 1': {
		'ru': `В данный раздел попадают заказы, которые Колл-центр не может обработать по причинам: `,
		'uk': `У цей розділ потрапляють замовлення, які Кол-центр не може обробити з таких причин: `,
		'en': `This section includes orders that the Call Center cannot process for the following reasons: `,
		'de': `This section includes orders that the Call Center cannot process for the following reasons: `,
		'vi': `This section includes orders that the Call Center cannot process for the following reasons: `,
		'th': `This section includes orders that the Call Center cannot process for the following reasons: `
	},
	'Автотреш обьяснение 1.1': {
		'ru': `заказы от клиентов из <b>черного списка</b> (клиент оформил и не выкупил заказ 5 и более раз подряд);`,
		'uk': `замовлення від клієнтів з <b>чорного списку</b> (клієнт оформив і не викупив замовлення 5 і більше разів поспіль);`,
		'en': `orders from customers on the <b>blacklist</b> (the customer has placed and not redeemed the order 5 or more times in a row);`,
		'de': `orders from customers on the <b>blacklist</b> (the customer has placed and not redeemed the order 5 or more times in a row);`,
		'vi': `orders from customers on the <b>blacklist</b> (the customer has placed and not redeemed the order 5 or more times in a row);`,
		'th': `orders from customers on the <b>blacklist</b> (the customer has placed and not redeemed the order 5 or more times in a row);`
	},
	'Автотреш обьяснение 1.2': {
		'ru': `заказы с <b>коротким номером</b> телефона (менее 4 цифр);`,
		'uk': `замовлення з <b>коротким номером</b> телефону (менше 4 цифр);`,
		'en': `orders with a <b>short phone</b> number (less than 4 digits);`,
		'de': `orders with a <b>short phone</b> number (less than 4 digits);`,
		'vi': `orders with a <b>short phone</b> number (less than 4 digits);`,
		'th': `orders with a <b>short phone</b> number (less than 4 digits);`
	},
	'Автотреш обьяснение 1.3': {
		'ru': `заказы в <b>активном статусе</b> (если заказ клиента находится в обработке или доставке по одному и тому же офферу)`,
		'uk': `замовлення в <b>активному статусі</b> (якщо замовлення клієнта перебуває в обробці або доставці по тому самому офферу)`,
		'en': `orders in <b>active status</b> (if the customer's order is being processed or delivered for the same offer)`,
		'de': `orders in <b>active status</b> (if the customer's order is being processed or delivered for the same offer)`,
		'vi': `orders in <b>active status</b> (if the customer's order is being processed or delivered for the same offer)`,
		'th': `orders in <b>active status</b> (if the customer's order is being processed or delivered for the same offer)`
	},
	'Автотреш обьяснение 2': {
		'ru': `Для оптимизации расходов на рекламу - рекомендуем добавлять <b>скрипты для определения заказов из Черного списка, и валидации номера телефона</b>.`,
		'uk': `Для оптимізації витрат на рекламу - рекомендуємо додавати <b>скрипти для визначення замовлень із Чорного списку та валідації номера телефону</b>.`,
		'en': `To optimize advertising costs, we recommend adding <b>scripts to identify orders from the Blacklist and validate the phone number</b>.`,
		'de': `To optimize advertising costs, we recommend adding <b>scripts to identify orders from the Blacklist and validate the phone number</b>.`,
		'vi': `To optimize advertising costs, we recommend adding <b>scripts to identify orders from the Blacklist and validate the phone number</b>.`,
		'th': `To optimize advertising costs, we recommend adding <b>scripts to identify orders from the Blacklist and validate the phone number</b>.`
	},
	'Автотреш обьяснение 3': {
		'ru': `Также, рекомендуем добавить <b>скрипт сокращения кол-ва Дубликатов</b> по заказам в <b>активном статусе</b>.`,
		'uk': `Також рекомендуємо додати <b>скрипт скорочення кількості Дублікатів</b> по замовленнях в <b>активному статусі</b>.`,
		'en': `Also we recommend adding a <b>script to reduce the number of Duplicates</b> for orders in <b>active status</b>.`,
		'de': `Also we recommend adding a <b>script to reduce the number of Duplicates</b> for orders in <b>active status</b>.`,
		'vi': `Also we recommend adding a <b>script to reduce the number of Duplicates</b> for orders in <b>active status</b>.`,
		'th': `Also we recommend adding a <b>script to reduce the number of Duplicates</b> for orders in <b>active status</b>.`
	},
	'Автотреш обьяснение 4': {
		'ru': `Скрипты работают по следующему флоу:`,
		'uk': `Скрипти працюють за наступним флоу:`,
		'en': `The scripts work according to the following flow:`,
		'de': `The scripts work according to the following flow:`,
		'vi': `The scripts work according to the following flow:`,
		'th': `The scripts work according to the following flow:`
	},
	'Автотреш обьяснение 5': {
		'ru': `пользователь, номер телефона которого попадает под ограничения - не переходит на страницу благодарности, а остается на лендинге, и дополнительно появляется поп-ап с текстом причины ошибки.`,
		'uk': `користувач, номер телефону якого підпадає під обмеження - не переходить на сторінку подяки, а залишається на лендінгу, і додатково з'являється поп-ап з текстом причини помилки.`,
		'en': `the user whose phone number falls under the restrictions does not go to the thank you page, but remains on the landing page, and an additional pop-up appears with the text of the reason for the error.`,
		'de': `the user whose phone number falls under the restrictions does not go to the thank you page, but remains on the landing page, and an additional pop-up appears with the text of the reason for the error.`,
		'vi': `the user whose phone number falls under the restrictions does not go to the thank you page, but remains on the landing page, and an additional pop-up appears with the text of the reason for the error.`,
		'th': `the user whose phone number falls under the restrictions does not go to the thank you page, but remains on the landing page, and an additional pop-up appears with the text of the reason for the error.`
	},
	'Автотреш обьяснение 6': {
		'ru': `<b>Получить скрипт для работы по API можно у вашего менеджера.</b>`,
		'uk': `<b>Отримати скрипт для роботи по API можна у вашого менеджера.</b>`,
		'en': `<b>You can get a script for working with the API from your manager.</b>`,
		'de': `<b>You can get a script for working with the API from your manager.</b>`,
		'vi': `<b>You can get a script for working with the API from your manager.</b>`,
		'th': `<b>You can get a script for working with the API from your manager.</b>`
	},
	'Автотреш обьяснение 7': {
		'ru': `При работе с потоковыми ссылками, данные скрипты будут работать автоматически.`,
		'uk': `При роботі з потоковими посиланнями ці скрипти будуть працювати автоматично.`,
		'en': `If you work with our domain links, these scripts will work automatically.`,
		'de': `If you work with our domain links, these scripts will work automatically.`,
		'vi': `If you work with our domain links, these scripts will work automatically.`,
		'th': `If you work with our domain links, these scripts will work automatically.`
	},
	'Невалидные лиды': {
		'ru': 'Невалидные лиды',
		'uk': 'Невалідні ліди',
		'en': 'Invalid leads',
		'de': 'Invalid leads',
		'vi': 'Invalid leads',
		'th': 'Invalid leads'
	},
	'Автотреш': {
		'ru': 'Автотреш',
		'uk': 'Автотреш',
		'en': 'Autotrash',
		'de': 'Autotrash',
		'vi': 'Autotrash',
		'th': 'Autotrash'
	},
	'Применить фильтр': {
		'ru': 'Применить фильтр',
		'uk': 'Застосувати фільтр',
		'en': 'Apply filters',
		'de': 'Filter anwenden',
		'vi': 'Áp dụng bộ lọc',
		'th': 'ใช้ตัวกรอง'
	},
	'Продолжить': {
		'ru': 'Продолжить',
		'uk': 'Продовжити',
		'en': 'Continue',
		'de': 'Fortsetzen',
		'vi': 'Tiếp tục',
		'th': 'ดำเนินการต่อ'
	},
	'Страны': {
		'ru': 'Страны',
		'uk': 'Країни',
		'en': 'Countries',
		'de': 'Länder',
		'vi': 'Các nước',
		'th': 'ประเทศ'
	},
	'Пример, постбэк ссылки для передачи суммы заработка и субаккаунта:': {
		'ru': 'Пример, постбэк ссылки для передачи суммы заработка и субаккаунта:',
		'uk': 'Приклад, постбек посилання для передачі суми зарабітку й субаккаунту:',
		'en': 'For example, here is a postback URL to send revenue amount and subaccount:',
		'de': 'Zum Beispiel, Postback URL für den Einnahmebetrag und das Unterkonto zu senden:',
		'vi': 'Ví dụ, liên kết postback để chuyển số tiền thu nhập và tài khoản phụ:',
		'th': 'ยกตัวอย่างเช่นการเชื่อมโยงการโพสต์ย้อนกลับไปเพื่อการโอนจำนวนรายได้และการเพิ่มให้contactsสามารถเข้าถึงข้อมูลข่าวสารการดำเนินการต่างๆในระบบตามที่เจ้าของบัญชีผู้ใช้งานกำหนด'
	},
	'Припарковать домен': {
		'ru': 'Припарковать домен',
		'uk': 'Припаркувати домен',
		'en': 'Park a domain',
		'de': 'Domain parken',
		'vi': 'Parking tên miền',
		'th': 'การฝากแปะโดเมน'
	},
	'Программа': {
		'ru': 'Программа',
		'uk': 'Програма',
		'en': 'Offer',
		'de': 'Angebot',
		'vi': 'Chương trình',
		'th': 'รายการ'
	},
	'программа': {
		'ru': 'программа',
		'uk': 'програма',
		'en': 'campaign',
		'de': 'Kam­pa­g­ne',
		'vi': 'chương trình',
		'th': 'รายการ'
	},
	'Программы': {
		'ru': 'Программы',
		'uk': 'Програми',
		'en': 'Offers',
		'de': 'Angebote',
		'vi': 'Các chương trình',
		'th': 'รายการ'
	},
	'Промо материалы': {
		'ru': 'Промо материалы',
		'uk': 'Промо матеріали',
		'en': 'Promo materials',
		'de': 'Promo Materials',
		'vi': 'Tài liệu quảng cáo',
		'th': 'สินค้าที่มีโปรโมชั่น'
	},
	'Фото и видео материалы': {
		'ru': 'Фото и видео материалы',
		'uk': 'Фото та відео матеріали',
		'en': 'Photo and video materials',
		'de': 'Foto- und Videomaterial',
		'vi': 'Tài liệu ảnh và video',
		'th': 'วัสดุรูปภาพและวิดีโอ'
	},
	'Прошу изменить данные для системы ': {
		'ru': 'Прошу изменить данные для системы ',
		'uk': 'Прошу змінити дані для системи ',
		'en': 'Please change data for the payout system ',
		'de': 'Ändern Sie bitte die Daten für das Auszahlungssystem auf',
		'vi': 'Vui lòng thay đổi dữ liệu cho hệ thống',
		'th': 'กรุณาเปลี่ยนข้อมูลสำหรับระบบ'
	},
	'Прошу изменить мне skype на': {
		'ru': 'Прошу изменить мне skype на',
		'uk': 'Прошу змінити мені skype на',
		'en': 'Please change my skype to',
		'de': 'Ändern Sie bitte mein Skype auf',
		'vi': 'Vui lòng thay đổi skype của tôi thành',
		'th': 'โปรดเปลี่ยนสไกป์ของฉันที่'
	},
	'Прошу изменить мне адрес электронной почты на': {
		'ru': 'Прошу изменить мне адрес электронной почты на',
		'uk': 'Прошу змінити мені адресу email на',
		'en': 'Please change my email to',
		'de': 'Ändern Sie bitte meine E-Mail-Adresse auf',
		'vi': 'Vui lòng thay đổi địa chỉ email của tôi thành',
		'th': 'โปรดเปลี่ยนที่อยู่อีเมลของฉันที่'
	},
	'Прошу изменить мне город на': {
		'ru': 'Прошу изменить мне город на',
		'uk': 'Прошу змінити мені місто на',
		'en': 'Please change my city to',
		'de': 'Ändern Sie bitte meine Stadt auf',
		'vi': 'Hãy đổi thành phố của tôi thành',
		'th': 'โปรดเปลี่ยนเมืองของฉันเป็น'
	},
	'Прошу изменить мне дату рождения на': {
		'ru': 'Прошу изменить мне дату рождения на',
		'uk': 'Прошу змінити мені дату народження на',
		'en': 'Please change my birthday to',
		'de': 'Ändern Sie bitte meinen Geburtstag auf',
		'vi': 'Hãy đổi ngày sinh nhật của tôi thành',
		'th': 'กรุณาเปลี่ยนวันเกิดของฉันเป็น'
	},
	'Добавить персональный домен для потоков': {
		'ru': 'Добавить персональный домен для потоков',
		'uk': 'Додати персональний домен для потоків',
		'en': 'Add a custom domain for campaigns',
		'de': 'Add a custom domain for campaigns',
		'vi': 'Add a custom domain for campaigns',
		'th': 'Add a custom domain for campaigns'
	},
	'Прошу довабить перскональный домен для потоков': {
		'ru': 'Прошу довабить перскональный домен для потоков',
		'uk': 'Прошу додати персональний домен для потоків',
		'en': 'Please add a personal domain for campaigns',
		'de': 'Please add a personal domain for campaigns',
		'vi': 'Please add a personal domain for campaigns',
		'th': 'Please add a personal domain for campaigns'
	},
	'Для прикрепления персонального домена, обратитесь в': {
		'ru': 'Для прикрепления персонального домена, обратитесь в',
		'uk': 'Для прикріплення персонального домену, зверніться в',
		'en': 'To attach a personal domain, go to',
		'de': 'To attach a personal domain, go to',
		'vi': 'To attach a personal domain, go to',
		'th': 'To attach a personal domain, go to'
	},
	'Прошу изменить мне номер телефона на': {
		'ru': 'Прошу изменить мне номер телефона на',
		'uk': 'Прошу змінити мені номер телефона на',
		'en': 'Please change my phone number to',
		'de': 'Ändern Sie bitte meine Telefonnummer auf',
		'vi': 'Vui lòng thay đổi số điện thoại của tôi thành',
		'th': 'โปรดเปลี่ยนเบอร์โทรศัพท์ของฉันที่'
	},
	'пятница': {
		'ru': 'пятница',
		'uk': 'п\'ятница',
		'en': 'friday',
		'de': 'Freitag',
		'vi': 'thứ sáu',
		'th': 'วันศุกร์'
	},
	'размер выплаты': {
		'ru': 'размер выплаты',
		'uk': 'розмір виплати',
		'en': 'payout amount',
		'de': 'Auszahlungsbetrag',
		'vi': 'khoảng thanh toán',
		'th': 'จำนวนการจ่ายเงิน'
	},
	'Размер файла': {
		'ru': 'Размер файла',
		'uk': 'Розмір файлу',
		'en': 'File size',
		'de': 'Dateigröße',
		'vi': 'Kích thước tệp',
		'th': 'ขนาดไฟล์'
	},
	'Редактировать площадку': {
		'ru': 'Редактировать площадку',
		'uk': 'Редагувати площадку',
		'en': 'Edit source',
		'de': 'Platz bearbeiten',
		'vi': 'Chỉnh sửa trang web',
		'th': 'แก้ไขหน้าเว็บไซต์'
	},
	'Редактировать поток': {
		'ru': 'Редактировать поток',
		'uk': 'Редагувати потік',
		'en': 'Edit campaign',
		'de': 'Quelle bearbeiten',
		'vi': 'Chỉnh sửa luồng',
		'th': 'แก้ไขการเรียกดูภาพ'
	},
	'Клонировать поток': {
		'ru': 'Клонировать поток',
		'uk': 'Клонувати потік',
		'en': 'Clone campaign',
		'de': 'Kampagne klonen',
		'vi': 'Chiến dịch sao chép',
		'th': 'ในการโคลนแคมเปญ'
	},
	'Конвертации': {
		'ru': 'Конвертации',
		'uk': 'Конвертації',
		'en': 'Conversions',
		'de': 'Konvertierungen',
		'vi': 'Chuyển đổi',
		'th': 'การแปลง'
	},
	'Конвертация по курсу': {
		'ru': 'Конвертация по курсу',
		'uk': 'Конвертація по курсу',
		'en': 'Rate conversion',
		'de': 'Ratenumrechnung',
		'vi': 'Tỷ lệ chuyển đổi',
		'th': 'อัตราการแปลง'
	},
	'Поток успешно клонирован': {
		'ru': 'Поток успешно клонирован',
		'uk': 'Потік успішно клоновано',
		'en': 'Сampaign successfully cloned',
		'de': 'Kampagne erfolgreich geklont',
		'vi': 'Chiến dịch được nhân bản thành công',
		'th': 'โคลนแคมเปญสำเร็จแล้ว'
	},
	'Рекламодателю': {
		'ru': 'Рекламодателю',
		'uk': 'Рекламодавцю',
		'en': 'For advertisers',
		'de': 'Für Werbekunden',
		'vi': 'Cho nhà quảng cáo',
		'th': 'ผู้ให้โฆษณา'
	},
	'Ретаргетинг': {
		'ru': 'Ретаргетинг',
		'uk': 'Ретаргетинг',
		'en': 'Retargeting',
		'de': 'Retargeting',
		'vi': 'Nhắm mục tiêu lại',
		'th': 'การทำการตลาดเพื่อสร้างความสนใจไปยังกลุ่มเป้าหมาย'
	},
	'Ручное': {
		'ru': 'Ручное',
		'uk': 'Ручне',
		'en': 'Manual',
		'de': 'Manuell',
		'vi': 'thuần hóa',
		'th': 'คู่มือ'
	},
	'Корректировка': {
		'ru': 'Корректировка',
		'uk': 'Коректування',
		'en': 'Correction',
		'de': 'Korrektur',
		'vi': 'sửa chữa',
		'th': 'การแก้ไข'
	},
	'Ручная корректировка': {
		'ru': 'Ручная корректировка',
		'uk': 'Ручне коректування',
		'en': 'Manual correction',
		'de': 'Manuelle Korrekturk',
		'vi': 'chỉnh tay',
		'th': 'การแก้ไขด้วยตนเอง'
	},
	'exchange goods to money': {
		'ru': 'Обмен QUID на деньги',
		'uk': 'Обмін QUID на гроші',
		'en': 'Exchange QUID to money',
		'de': 'Exchange QUID to money',
		'vi': 'Exchange QUID to money',
		'th': 'Exchange QUID to money'
	},
	'С 10:00 до 19:00 по МСК': {
		'ru': 'С 10:00 до 19:00 по МСК',
		'uk': 'З 10:00 по 19:00 по МСК',
		'en': 'From 10am till 7pm MSK',
		'de': 'Von 10.00 bis 19.00 MSK',
		'vi': 'Từ 10h đến 19h theo giờ Moscow',
		'th': 'ตั้งแต่เวลา 10:00 ถึง 19:00 ตามเวลามอสโก'
	},
	'С 10:00 до 19:00 по Киеву': {
		'ru': 'С 10:00 до 19:00 по Киеву',
		'uk': 'З 10:00 по 19:00 по Києву',
		'en': 'From 10:00 to 19:00 Kyiv time',
		'de': 'From 10:00 to 19:00 Kyiv time',
		'vi': 'From 10:00 to 19:00 Kyiv time',
		'th': 'From 10:00 to 19:00 Kyiv time'
	},
	'Сабдомен': {
		'ru': 'Сабдомен',
		'uk': 'Сабдомен',
		'en': 'Subdomain',
		'de': 'Subdomain',
		'vi': 'Tên miền phụ',
		'th': 'เวบไซต์ย่อย'
	},
	'Сайт': {
		'ru': 'Сайт',
		'uk': 'Сайт',
		'en': 'Site',
		'de': 'Site',
		'vi': 'Trang web',
		'th': 'เว็บมาสเตอร์'
	},
	'Свой Колл-Центр': {
		'ru': 'Свой Колл-Центр',
		'uk': 'Власний Колл-Центр',
		'en': 'Own Call-Center',
		'de': 'Eigene Call-Center',
		'vi': 'Trung tâm cuộc gọi riêng',
		'th': 'คอลเซ็นเตอร์ของคุณเอง'
	},
	'Связка и описание': {
		'ru': 'Связка и описание',
		'uk': 'Звязка й опис',
		'en': 'Combo and description',
		'de': 'Combo und beschreibung',
		'vi': 'Combo và mô tả',
		'th': 'คำอธิบายผสมและคำอธิบาย'
	},
	'Сегодня': {
		'ru': 'Сегодня',
		'uk': 'Сьогодні',
		'en': 'Today',
		'de': 'Heute',
		'vi': 'Hôm nay',
		'th': 'วันนี้'
	},
	'Система рекламы': {
		'ru': 'Система рекламы',
		'uk': 'Система реклами',
		'en': 'Advertising system',
		'de': 'Werbesystem',
		'vi': 'Hệ thống quảng cáo',
		'th': 'ระบบการโฆษณา'
	},
	'Скопировано': {
		'ru': 'Скопировано',
		'uk': 'Скопійовано',
		'en': 'Copied',
		'de': 'Kopiert',
		'vi': 'Đã sao chép',
		'th': 'คัดลอกสำเนาแล้ว'
	},
	'службу поддержки': {
		'ru': 'службу поддержки',
		'uk': 'службу підтримки',
		'en': 'support',
		'de': 'im Unterstützungdienst möglich.',
		'vi': 'dịch vụ hỗ trợ',
		'th': 'ฝ่ายสนับสนุนและแก้ปัญหาของลูกค้า'
	},
	'Смена пароля': {
		'ru': 'Смена пароля',
		'uk': 'Зміна паролю',
		'en': 'Change Password',
		'de': 'Passwort ändern',
		'vi': 'Thay đổi mật khẩu',
		'th': 'เปลี่ยนรหัสผ่าน'
	},
	'Совпадения не найдены': {
		'ru': 'Совпадения не найдены',
		'uk': 'Співпадіння не знайдені',
		'en': 'No match',
		'de': 'Keine Übereinstimmung',
		'vi': 'Không tìm thấy kết quả phù hợp',
		'th': 'ไม่พบที่ตรงกัน'
	},
	'Создано': {
		'ru': 'Создано',
		'uk': 'Створено',
		'en': 'Created at',
		'de': 'Erstellt von',
		'vi': 'Đã tạo',
		'th': 'สร้างขึ้นแล้ว'
	},
	'Создано в Everad': {
		'ru': 'Создано в Everad',
		'uk': 'Створено в Everad',
		'en': 'Created by Everad',
		'de': 'Erstellt von Everad',
		'vi': 'Được tạo bởi Everad',
		'th': 'สร้างโดย Everad'
	},
	'Создать площадку': {
		'ru': 'Создать площадку',
		'uk': 'Створити площадку',
		'en': 'Create source',
		'de': 'Quelle erstellen',
		'vi': 'Tạo trang',
		'th': 'สร้างพื้นที่'
	},
	'Создать поток': {
		'ru': 'Создать поток',
		'uk': 'Створити потік',
		'en': 'Create a campaign',
		'de': 'Kampagen erstellen',
		'vi': 'Tạo luồng',
		'th': 'สร้างกระแส'
	},
	'Сохранить': {
		'ru': 'Сохранить',
		'uk': 'Зберегти',
		'en': 'Save',
		'de': 'Speichern',
		'vi': 'Lưu',
		'th': 'บันทึกข้อมูล'
	},
	'Сохранить поток': {
		'ru': 'Сохранить поток',
		'uk': 'Збарегти потік',
		'en': 'Save campaign',
		'de': 'Kampagen speichern',
		'vi': 'Lưu luồng',
		'th': 'บันทึกการเรียกดูภาพ'
	},
	'news_feed': {
		'ru': 'новостная витрина',
		'uk': 'новинна вітрина',
		'en': 'news feed',
		'de': 'news feed',
		'vi': 'bảng tin tức',
		'th': 'กระดานข่าว'
	},
	'Сохраняю поток': {
		'ru': 'Сохраняю поток',
		'uk': 'Зберігаю потік',
		'en': 'Saving campaign',
		'de': 'Kampagne wird gespeichert',
		'vi': 'Chiến dịch tiết kiệm',
		'th': 'กำลังบันทึกแคมเปญ'
	},
	'Список тикетов': {
		'ru': 'Список тикетов',
		'uk': 'Список тикетів',
		'en': 'Tickets list',
		'de': 'Ticketliste',
		'vi': 'Danh sách các ticket',
		'th': 'รายการคำถามหรือคำร้อง'
	},
	'Сплит': {
		'ru': 'Сплит',
		'uk': 'Спліт',
		'en': 'Split',
		'de': 'Split',
		'vi': 'Split',
		'th': 'การแยกชุดตัวอักษร'
	},
	'Сплит-сессии': {
		'ru': 'Сплит-сессии',
		'uk': 'Спліт-сессії',
		'en': 'Split-sessions',
		'de': 'Split-Sessions',
		'vi': 'Split session',
		'th': 'การแยกประชุม'
	},
	'Способ вывода': {
		'ru': 'Способ вывода',
		'uk': 'Спосіб виводу',
		'en': 'Payout method',
		'de': 'Zahlungsmethoden',
		'vi': 'Phương thức đầu ra',
		'th': 'วิธีสรุปผล'
	},
	'среда': {
		'ru': 'среда',
		'uk': 'середа',
		'en': 'wednesday',
		'de': 'Mittwoch',
		'vi': 'thứ tư',
		'th': 'วันพุธ'
	},
	'Ссылка': {
		'ru': 'Ссылка',
		'uk': 'Посилання',
		'en': 'Link',
		'de': 'Link',
		'vi': 'Liên kết',
		'th': 'ลิงค์'
	},
	'Ссылка лендинга': {
		'ru': 'Ссылка лендинга',
		'uk': 'Посилання лендинга',
		'en': 'Landing link',
		'de': 'Landing link',
		'vi': 'Liên kết của landing',
		'th': 'การอ้างอิงการกู้ยืมเงิน'
	},
	'Ссылка на корзину': {
		'ru': 'Ссылка на корзину',
		'uk': 'Посилання на корзину',
		'en': 'Cart link',
		'de': 'Cart link',
		'vi': 'Cart link',
		'th': 'Cart link'
	},
	'Партнерский лендинг': {
		'ru': 'Партнерский лендинг',
		'uk': 'Партнерський лендінг',
		'en': 'Partner landing',
		'de': 'Partner landing',
		'vi': 'Partner landing',
		'th': 'Partner landing'
	},
	'Корзина товара': {
		'ru': 'Корзина товара',
		'uk': 'Корзина товару',
		'en': 'Product cart',
		'de': 'Product cart',
		'vi': 'Product cart',
		'th': 'Product cart'
	},
	'Ссылка транзитки': {
		'ru': 'Ссылка транзитки',
		'uk': 'Посилання транзитки',
		'en': 'Transit link',
		'de': 'Transit link',
		'vi': 'Liên kết của trang transit',
		'th': 'การเปลี่ยนผ่านการเชื่อมโยง'
	},
	'Старый пароль': {
		'ru': 'Старый пароль',
		'uk': 'Старий пароль',
		'en': 'Old password',
		'de': 'Altes Passwort',
		'vi': 'Mật khẩu cũ',
		'th': 'รหัสผ่านเก่า'
	},
	'Связки': {
		'ru': 'Связки',
		'uk': 'Звязки',
		'en': 'Combos',
		'de': 'Combo',
		'vi': 'Combo',
		'th': 'วงดนตรีผสม'
	},
	'Статистика': {
		'ru': 'Статистика',
		'uk': 'Статистика',
		'en': 'Statistics',
		'de': 'Statistiken',
		'vi': 'Thống kê',
		'th': 'สถิติ'
	},
	'Статус': {
		'ru': 'Статус',
		'uk': 'Статус',
		'en': 'Status',
		'de': 'Status',
		'vi': 'Trạng thái',
		'th': 'สถานะ'
	},
	'статус конверсии': {
		'ru': 'статус конверсии',
		'uk': 'статус конверсії',
		'en': 'conversion status',
		'de': 'Status Umwandlungen',
		'vi': 'trạng thái của conversio',
		'th': 'สถานะการแปลงสภาพ'
	},
	'Статус платежа': {
		'ru': 'Статус платежа',
		'uk': 'Статус платежу',
		'en': 'Payment status',
		'de': 'Status Auszahlung',
		'vi': 'Trạng thái thanh toán',
		'th': 'สถานะการจ่ายเงิน'
	},
	'Страна': {
		'ru': 'Страна',
		'uk': 'Країна',
		'en': 'Country',
		'de': 'Land',
		'vi': 'Quốc gia',
		'th': 'ประเทศ'
	},
	'Страница не найдена!': {
		'ru': 'Страница не найдена!',
		'uk': 'Сторінка не знайдена!',
		'en': 'Page not found!',
		'de': 'Seite nicht gefunden!',
		'vi': 'Trang không được tìm thấy!',
		'th': 'ไม่พบหน้าที่ค้นหา'
	},
	'суббота': {
		'ru': 'суббота',
		'uk': 'субота',
		'en': 'saturday',
		'de': 'Samstag',
		'vi': 'thứ bảy',
		'th': 'วันเสาร์'
	},
	'Сумма': {
		'ru': 'Сумма',
		'uk': 'Сума',
		'en': 'Amount',
		'de': 'Betrag',
		'vi': 'Tổng số',
		'th': 'จำนวน'
	},
	'Счет': {
		'ru': 'Счет',
		'uk': 'Рахунок',
		'en': 'Balance',
		'de': 'Saldo',
		'vi': 'Tài khoản',
		'th': 'บัญชี'
	},
	'Таргетинг': {
		'ru': 'Таргетинг',
		'uk': 'Таргетинг',
		'en': 'Targeting',
		'de': 'Targeting',
		'vi': 'Nhắm mục tiêu',
		'th': 'การเลือกเป้าหมาย'
	},
	'Текст сообщения': {
		'ru': 'Текст сообщения',
		'uk': 'Текст повідомлення',
		'en': 'Message',
		'de': 'Nachricht',
		'vi': 'Văn bản tin nhắn',
		'th': 'ข้อความ'
	},
	'Телефон': {
		'ru': 'Телефон',
		'uk': 'Телефон',
		'en': 'Phone',
		'de': 'Telefon',
		'vi': 'Điện thoại',
		'th': 'โทรศัพท์'
	},
	'Тема вопроса': {
		'ru': 'Тема вопроса',
		'uk': 'Тема питання',
		'en': 'Topic',
		'de': 'Gegenstand',
		'vi': 'Chủ đề của câu hỏi',
		'th': 'หัวข้อคำถาม'
	},
	'Тема закрыта': {
		'ru': 'Тема закрыта',
		'uk': 'Тема закрита',
		'en': 'Thread is closed',
		'de': 'Thema ist geschlossen',
		'vi': 'Chủ đề bị đóng',
		'th': 'หัวข้อที่ถูกปิด'
	},
	'имя оффера': {
		'ru': 'имя оффера',
		'uk': 'ім\'я оффера',
		'en': 'offer name',
		'de': 'Angebotsname',
		'vi': 'tên offer',
		'th': 'ชื่อข้อเสนอพิเศษ'
	},
	'Тема тикета': {
		'ru': 'Тема тикета',
		'uk': 'Тема тікету',
		'en': 'Topic',
		'de': 'Gegenstand',
		'vi': 'Chủ đề của ticket',
		'th': 'ห้วข้อจดหมาย'
	},
	'Тизерная реклама': {
		'ru': 'Тизерная реклама',
		'uk': 'Тизерна реклама',
		'en': 'Teaser advertising',
		'de': 'Teaser-Werbung ',
		'vi': 'Quảng cáo teasing',
		'th': 'โฆษณาที่ชวนให้ติดตามตอนต่อไป'
	},
	'Тикет #': {
		'ru': 'Тикет #',
		'uk': 'Тікет #',
		'en': 'Ticket #',
		'de': 'Ticket #',
		'vi': 'Ticket #',
		'th': 'คำถามหรือข้อร้องเรียน#'
	},
	'Тикеты': {
		'ru': 'Тикеты',
		'uk': 'Тікети',
		'en': 'Tickets',
		'de': 'Tickets',
		'vi': 'Tickets',
		'th': 'ตั๋ว'
	},
	'Тип': { 'uk': 'Тип', 'ru': 'Тип', en: 'Type', de: 'Typ', vi: 'Loại', th: 'ประเภท' },
	'Тип потока': {
		'ru': 'Тип потока',
		'uk': 'Тип потоку',
		'en': 'Campaign type',
		'de': 'Kampagnentyp',
		'vi': 'Loại luồng',
		'th': 'ประเภทของการไหลเวียนข้อมูล'
	},
	'Тип траффика': {
		'ru': 'Тип траффика',
		'uk': 'Тип трафіку',
		'en': 'Traffic type',
		'de': 'Traffic Typ',
		'vi': 'loại lưu lương',
		'th': 'ประเภทการเข้ามาเยี่ยมชมเวบไซต์หรือจำนวนคนเข้าเวบ'
	},
	'тип конверсии': {
		'ru': 'тип конверсии',
		'uk': 'тип конверсії',
		'en': 'conversion type',
		'de': 'Conversion-Typ',
		'vi': 'loại chuyển đổi',
		'th': 'ประเภทการแปลง'
	},
	'ТОП стран': {
		'ru': 'ТОП стран',
		'uk': 'ТОП країн',
		'en': 'TOP countries',
		'de': 'TOP Länder',
		'vi': 'TOP quốc gia',
		'th': 'ประเทศ TOP'
	},
	'ТОП офферов': {
		'ru': 'ТОП офферов',
		'uk': 'ТОП офферів',
		'en': 'TOP offers',
		'de': 'TOP-Angebote',
		'vi': 'TOP cung cấp',
		'th': 'TOP เสนอ'
	},
	'Транзитка': {
		'ru': 'Транзитка',
		'uk': 'Транзитка',
		'en': 'Transit',
		'de': 'Transit',
		'vi': 'Trang transit',
		'th': 'การเปลี่ยนผ่าน'
	},
	'Транзитки': {
		'ru': 'Транзитки',
		'uk': 'Транзитки',
		'en': 'Transits',
		'de': 'Transits',
		'vi': 'Các trang transit',
		'th': 'การเปลี่ยนผ่าน'
	},
	'оффер': {
		'ru': 'оффер',
		'uk': 'оффер',
		'en': 'offer',
		'de': 'Angebot',
		'vi': 'offer',
		'th': 'เสนอ'
	},
	'Транзитная страница': {
		'ru': 'Транзитная страница',
		'uk': 'Транзитна сторінка',
		'en': 'Transit page',
		'de': 'Transit Seite',
		'vi': 'Trang transit',
		'th': 'หน้าเว็บที่รอเปลี่ยนไปยังหน้าอื่น'
	},
	'Транзитные страницы': {
		'ru': 'Транзитные страницы',
		'uk': 'Транзитні сторінки',
		'en': 'Transit pages',
		'de': 'Transit Seite',
		'vi': 'Các trang transit',
		'th': 'หน้ารอเปลี่ยนผ่านไปหน้าเว็บอื่น'
	},
	'Трафик': {
		'ru': 'Трафик',
		'uk': 'Трафік',
		'en': 'Traffic',
		'de': 'Traffic',
		'vi': 'Lưu lương',
		'th': 'การเข้ามาเยี่ยมชมเวบไซต์'
	},
	'Траффикбэк URL': {
		'ru': 'Траффикбэк URL',
		'uk': 'Трафікбек URL',
		'en': 'Trafficback URL',
		'de': 'Trafficback URL',
		'vi': 'URL Trafficback',
		'th': 'Trafficback URL'
	},
	'Удалить': {
		'ru': 'Удалить',
		'uk': 'Видалити',
		'en': 'Remove',
		'de': 'Löschen',
		'vi': 'Xóa',
		'th': 'ลบทิ้ง'
	},
	'Удалить поток': {
		'ru': 'Удалить поток',
		'uk': 'Видалити потік',
		'en': 'Delete campaign',
		'de': 'Kampagen löschen',
		'vi': 'Xóa luồng',
		'th': 'ลบการเรียกดูภาพ'
	},
	'Архивировать поток': {
		'ru': 'Архивировать поток',
		'uk': 'Архівувати потік',
		'en': 'Archive campaign',
		'de': 'Archive campaign',
		'vi': 'Archive campaign',
		'th': 'Archive campaign'
	},
	'Участвует в конкурсе': {
		'ru': 'Участвует в конкурсе',
		'uk': 'Бере участь у конкурсі',
		'en': 'Eligible for contest',
		'de': 'In Wettbewerb steht',
		'vi': 'Tham gia vào một cuộc thi',
		'th': 'เข้าร่วมการแข่งขัน'
	},
	'Фильтры': {
		'ru': 'Фильтры',
		'uk': 'Фільтри',
		'en': 'Filters',
		'de': 'Filters',
		'vi': 'Bộ lọc',
		'th': 'ตัวกรอง'
	},
	'Отмена': {
		'ru': 'Отмена',
		'uk': 'Скасування',
		'en': 'Cancel',
		'de': 'Stornieren',
		'vi': 'Huỷ bỏ',
		'th': 'ยกเลิก'
	},
	'Время работы колл-центра:': {
		'ru': 'Время работы колл-центра:',
		'uk': 'Час роботи колл-центру:',
		'en': 'Call center working hours:',
		'de': 'Öffnungszeiten des Call Centers:',
		'vi': 'Giờ mở cửa của tổng đài:',
		'th': 'เวลาทำการของศูนย์บริการ:'
	},
	'Финансы': {
		'ru': 'Финансы',
		'uk': 'Фінанси',
		'en': 'Finance',
		'de': 'Finanzen',
		'vi': 'Tài chính',
		'th': 'การเงิน'
	},
	'Более подробную информацию об эксплуатации конвертера вы сможете найти по': {
		'ru': 'Более подробную информацию об эксплуатации конвертера вы сможете найти по',
		'uk': 'Більш детальну інформацію про використання конвертера ви зможете знайти за посиланням',
		'en': 'You can find more information about the operation of the converter at',
		'de': 'Weitere Informationen zum Betrieb des Konverters finden Sie unter',
		'vi': 'Bạn có thể tìm thêm thông tin về hoạt động của bộ chuyển đổi tại',
		'th': 'คุณสามารถหาข้อมูลเพิ่มเติมเกี่ยวกับการทำงานของตัวแปลงได้ที่'
	},
	'ссылке': {
		'ru': 'ссылке',
		'uk': 'посилання',
		'en': 'link',
		'de': 'der link',
		'vi': 'liên kết',
		'th': 'ลิงค์'
	},
	'Конвертация валют внутри кабинета теперь доступна в разделе "финансы".': {
		'ru': 'Конвертация валют внутри кабинета теперь доступна в разделе "финансы".',
		'uk': 'Конвертація валют всередині кабінету тепер доступна в розділі "фінанси".',
		'en': 'Currency conversion inside the cabinet is now available in the "finance" section.',
		'de': 'Die Währungsumrechnung im Schrank ist jetzt im Bereich "Finanzen" verfügbar.',
		'vi': 'Chuyển đổi tiền tệ trong nội các hiện có sẵn trong phần "tài chính".',
		'th': 'ขณะนี้การแปลงสกุลเงินภายในคณะรัฐมนตรีมีอยู่ในส่วน "การเงิน"'
	},
	'Магазин': {
		'ru': 'Магазин',
		'uk': 'Крамниця',
		'en': 'Market',
		'de': 'Laden',
		'vi': 'Cửa hàng',
		'th': 'ทางร้านค้า'
	},
	'Хиты': {
		'ru': 'Хиты',
		'uk': 'Хіти',
		'en': 'Hits',
		'de': 'Hits',
		'vi': 'Lượt truy cập',
		'th': 'Hits'
	},
	'Холд': {
		'ru': 'Холд',
		'uk': 'Холд',
		'en': 'Hold',
		'de': 'Hold',
		'vi': 'Hold',
		'th': 'ที่จัดเก็บ'
	},
	'Хосты': {
		'ru': 'Хосты',
		'uk': 'Хости',
		'en': 'Hosts',
		'de': 'Hosts',
		'vi': 'Máy chủ',
		'th': 'Hosts'
	},
	'Часовой пояс': {
		'ru': 'Часовой пояс',
		'uk': 'Часовий пояс',
		'en': 'Time zone',
		'de': 'Zeitzone',
		'vi': 'Múi giờ',
		'th': 'เขตเวลา'
	},
	'Часто задаваемые вопросы': {
		'ru': 'Часто задаваемые вопросы',
		'uk': 'Часті питання (FAQ)',
		'en': 'Frequently Asked Questions',
		'de': 'Häufig gestellte Fragen (FAQ)',
		'vi': 'Câu hỏi thường gặp',
		'th': 'คำถามที่พบบ่อย'
	},
	'четверг': {
		'ru': 'четверг',
		'uk': 'четвер',
		'en': 'thursday',
		'de': 'Donnerstag',
		'vi': 'thứ năm',
		'th': 'วันพฤหัสบดี'
	},
	'Что-то пошло не так, или страница не найдена. Вы можете перейти на главную страницу или обратиться в': {
		'ru': 'Что-то пошло не так, или страница не найдена. Вы можете перейти на главную страницу или обратиться в',
		'uk': 'Щось пішло не так, або сторінку не знайдено. Ви можете перейти на головну сторінку або звернутися до',
		'en': 'Something went wrong or the page was not found. You can go to the main page or contact',
		'de': 'Etwas ging schief und die gewünschte Seite wurde nicht gefunden. Sie können auf die Hauptseite gehen oder kontaktieren Sie uns unter',
		'vi': 'Đã xảy ra sự cố hoặc trang không được tìm thấy. Bạn có thể vào trang đầu hoặc liên hệ với',
		'th': 'มีบางอย่างผิดปกติหรือไม่พบหน้าที่ค้นหา คุณสามารถกลับไปยังหน้าหลักหรือติดต่อฝ่ายสนับสนุนการแก้ปัญหา'
	},
	'юзер агент (идентификатор браузера) пользователя': {
		'ru': 'юзер агент (идентификатор браузера) пользователя',
		'uk': 'юзер агент (ідентифікатор браузера) користувача',
		'en': 'user-agent (identity of user\'s brouser)',
		'de': 'User-Agent (Identität des Browser des Benutzers)',
		'vi': 'user agent (id trình duyệt) của người dùng',
		'th': 'โปรแกรมคอมพิวเตอร์ทางด้านผู้ใช้งาน'
	},
	'Язык': {
		'ru': 'Язык',
		'uk': 'Мова',
		'en': 'Language',
		'de': 'Sprache',
		'vi': 'Ngôn ngữ',
		'th': 'ภาษา'
	},
	'Языки': {
		'ru': 'Языки',
		'uk': 'Мова',
		'en': 'Languages',
		'de': 'Sprachen',
		'vi': 'Ngôn ngữ',
		'th': 'ภาษา'
	},
	'Агентский кабинет': {
		'ru': 'Агентский кабинет',
		'uk': 'Агентський кабінет',
		'en': 'Cabinets',
		'de': 'Kabinett',
		'vi': 'Văn phòng của đại lý',
		'th': 'สำนักงานของบริษัทที่เป็นตัวแทน'
	},
	'Facebook: таргетированная реклама': {
		'ru': 'Facebook: таргетированная реклама',
		'uk': 'Facebook: таргетована реклама',
		'en': 'Facebook: targeted advertising',
		'de': 'Facebook: gezielte werbung',
		'vi': 'Facebook: quảng cáo nhắm mục tiêu',
		'th': 'เฟสบุ้ค:ผู้ให้บริการสื่อโฆษณาออนไลน์ให้ตรงกลุ่มเป้าหมายผู้รับบริการมากที่สุด'
	},
	'Facebook: паблики, игры, приложения': {
		'ru': 'Facebook: паблики, игры, приложения',
		'uk': 'Facebook: пабліки, ігри, додатки',
		'en': 'Facebook: groups, games, apps',
		'de': 'Facebook: Gruppen, Spiele, Apps',
		'vi': 'Facebook: công luận, trò chơi, ứng dụng',
		'th': 'เฟสบุ้ค:สาธารณะ เกม แอพ'
	},
	'Всего доступно к выплате': {
		'ru': 'Всего доступно к выплате',
		'uk': 'Усього доступно до виплати',
		'en': 'Total available for payment',
		'de': 'Summe steht zur Zahlung zur Verfügung',
		'vi': 'Tổng cộng có sẵn để thanh toán',
		'th': 'ทั้งหมดมีให้สำหรับการจ่ายเงิน'
	},
	'conversion approve': {
		'ru': 'аппрув конверсий',
		'uk': 'аппрув конверсій',
		'en': 'conversion approve',
		'de': 'conversion genehmigen',
		'vi': 'Phê duyệt chuyển đổi',
		'th': 'การแปลงค่า'
	},
	'Гарант аппрува конверсий': {
		'ru': 'Заработано. Гарант аппрува конверсий',
		'uk': 'Зароблено. Гарант аппрува конверсій',
		'en': 'Earned. Guaranteed approve payment',
		'de': 'Earned. Guaranteed approve payment',
		'vi': 'Earned. Guaranteed approve payment',
		'th': 'Earned. Guaranteed approve payment'
	},
	'approved conversion rejection': {
		'ru': 'отмена аппрува конверсий',
		'uk': 'скасування аппрува конверсій',
		'en': 'approved conversion rejection',
		'de': 'Goedgekeurde conversiewering',
		'vi': 'Chấp nhận chuyển đổi được chấp thuận',
		'th': 'อนุมัติการปฏิเสธ การแปลง'
	},
	'Покупка аккаунта': {
		'ru': 'Покупка аккаунта',
		'uk': 'Покупка аккаунту',
		'en': 'Buying an account',
		'de': 'Buying an account',
		'vi': 'Buying an account',
		'th': 'Buying an account'
	},
	'approved conversion bonus rejection': {
		'ru': 'отмена бонуса',
		'uk': 'скасування бонусу',
		'en': 'approved conversion bonus rejection',
		'de': 'Goedgekeurde conversiewering',
		'vi': 'Chấp nhận chuyển đổi được chấp thuận',
		'th': 'อนุมัติการปฏิเสธการแปลงโบนัส'
	},
	'geo amount correction': {
		'ru': 'коррекция начисления по гео',
		'uk': 'корекція нарахування за гео',
		'en': 'geo amount correction',
		'de': 'geo betragskorrektur',
		'vi': 'điều chỉnh số lượng địa lý',
		'th': 'การแก้ไขจำนวนพื้นที่ทางภูมิศาสตร์'
	},
	'geo bonus correction': {
		'ru': 'коррекция начисления бонуса по гео',
		'uk': 'корекція нарахування бонусу за гео',
		'en': 'geo bonus correction',
		'de': 'geo bonus korrektur',
		'vi': 'chỉnh sửa tiền thưởng địa lý',
		'th': 'การแก้ไขโบนัสทางภูมิศาสตร์'
	},
	bonus: {
		'ru': 'бонус',
		'uk': 'бонус',
		'en': 'bonus payout',
		'de': 'Bonusauszahlung',
		'vi': 'Thanh toán tiền thưởng',
		'th': 'การจ่ายเงินโบนัสพิเศษ'
	},
	'id конверсии': {
		'ru': 'id конверсии',
		'uk': 'id конверсії',
		'en': 'conversion id',
		'de': 'Umwandlungs id',
		'vi': 'Id chuyển đổi',
		'th': 'รหัส การแปลง'
	},
	'время конверсии UTC+0': {
		'ru': 'время конверсии UTC+0',
		'uk': 'час конверсії UTC+0',
		'en': 'conversion time UTC+0',
		'de': 'Umwandlungszeit\tUTC+0',
		'vi': 'thời gian chuyển đổi UTC + 0',
		'th': 'เวลาการแปลงสภาพ UTC+O'
	},
	'Изменение ника Telegram возможно только по запросу в': {
		'ru': 'Изменение ника Telegram возможно только по запросу в',
		'uk': 'Зміна ніка Telegram можлива лише за запитом в',
		'en': 'Change of Telegram nickname is possible only on request in',
		'de': 'Änderung des Telegram-Nicknamens ist nur auf Anfrage',
		'vi': 'Thay đổi tên Telegram chỉ có thể được theo yêu cầu trong',
		'th': 'สามารถเปลี่ยนโทรเลขตามคำร้องขอ'
	},
	'Изменение данных возможно только после обращения к': {
		'ru': 'Изменение данных возможно только после обращения к',
		'uk': 'Зміна даних можлива лише після звернення до',
		'en': 'Change of data is possible only upon request to',
		'de': 'Änderung der Daten ist nur auf Anfrage',
		'vi': 'Thay đổi dữ liệu chỉ có thể sau khi liên hệ',
		'th': 'สามารถเปลี่ยนข้อมูลภายหลังการติดต่อ'
	},
	'личному менеджеру': {
		'ru': 'личному менеджеру',
		'uk': 'особистого менеджера',
		'en': 'your personal manager',
		'de': 'zum Personalmanager möglich.',
		'vi': 'quản lý cá nhân',
		'th': 'ผู้จัดการส่วนตัว'
	},
	'Группа': {
		'ru': 'Группа',
		'uk': 'Група',
		'en': 'Group',
		'de': 'Group',
		'vi': 'Group',
		'th': 'Group'
	},
	'Подписаться': {
		'ru': 'Подписаться',
		'uk': 'Підписатись',
		'en': 'Subscribe',
		'de': 'Subscribe',
		'vi': 'Subscribe',
		'th': 'Subscribe'
	},
	'Мы в Facebook': {
		'ru': 'Мы в Facebook',
		'uk': 'Ми в Facebook',
		'en': 'We are on Facebook',
		'de': 'We are on Facebook',
		'vi': 'We are on Facebook',
		'th': 'We are on Facebook'
	},
	'Мы в Telegram': {
		'ru': 'Мы в Telegram',
		'uk': 'Ми в Telegram',
		'en': 'We are on Telegram',
		'de': 'We are on Telegram',
		'vi': 'We are on Telegram',
		'th': 'We are on Telegram'
	},
	'Канал': {
		'ru': 'Канал',
		'uk': 'Канал',
		'en': 'Channel',
		'de': 'Channel',
		'vi': 'Channel',
		'th': 'Channel'
	},
	'Канал': {
		'ru': 'Канал',
		'uk': 'Канал',
		'en': 'Channel',
		'de': 'Channel',
		'vi': 'Channel',
		'th': 'Channel'
	},
	'Страница': {
		'ru': 'Страница',
		'uk': 'Сторінка',
		'en': 'Page',
		'de': 'Page',
		'vi': 'Page',
		'th': 'Page'
	},
	'Вступить': {
		'ru': 'Вступить',
		'uk': 'Вступити',
		'en': 'Join',
		'de': 'Join',
		'vi': 'Join',
		'th': 'Join'
	},
	'Мы в VK': {
		'ru': 'Мы в VK',
		'uk': 'Ми в VK',
		'en': 'We are on VK',
		'de': 'We are on VK',
		'vi': 'We are on VK',
		'th': 'We are on VK'
	},
	'EVERAD | CPA | Арбитраж трафика': {
		'ru': 'EVERAD | CPA | Арбитраж трафика',
		'uk': 'EVERAD | CPA | Арбітраж трафіку',
		'en': 'EVERAD | CPA | Traffic arbitrage',
		'de': 'EVERAD | CPA | Traffic arbitrage',
		'vi': 'EVERAD | CPA | Traffic arbitrage',
		'th': 'EVERAD | CPA | Traffic arbitrage'
	},
	'Получать уведомления о новых тикетах': {
		'ru': 'Получать уведомления о новых тикетах',
		'uk': 'Отримувати повідомлення про нові тікети',
		'en': 'Receive new support tickets notifications',
		'de': 'Benachrichtigungen über neue Tickets erhalten',
		'vi': 'Nhận thông báo về ticket mới',
		'th': 'รับการแจ้งหมายเลขใหม่'
	},
	'Получать уведомления о статусах выплат': {
		'ru': 'Получать уведомления о статусах выплат',
		'uk': 'Отримувати повідомлення про статуси виплат',
		'en': 'Receive payment status notification',
		'de': 'Benachrichtigungen über die Zahlungsstatus erhalten',
		'vi': 'Nhận thông báo về trạng thái thanh toán',
		'th': 'รับการแจ้งเกี่ยวกับสถานะภาพการชำระเงิน'
	},
	'Получать уведомления о промоакциях': {
		'ru': 'Получать уведомления о промоакциях',
		'uk': 'Отримувати повідомлення про акції',
		'en': 'Receive promo events notifications',
		'de': 'Benachrichtigungen über Promo-Aktionen erhalten',
		'vi': 'Nhận thông báo về chương trình khuyến mãi',
		'th': 'รับการแจ้งเกี่ยวกับการส่งเสริมการขาย'
	},
	'Получать системные уведомления': {
		'ru': 'Получать системные уведомления',
		'uk': 'Отримувати системні повідомлення',
		'en': 'Receive system notifications',
		'de': 'Benachrichtigungen von System erhalten',
		'vi': 'Nhận thông báo hệ thống',
		'th': 'รับการแจ้งข่าวอย่างเป็นระบบ'
	},
	'Запрос на изменение telegram': {
		'ru': 'Запрос на изменение telegram',
		'uk': 'Запит на зміну телеграм',
		'en': 'Request to change telegram',
		'de': 'Anfrage zur Änderung von Telegram',
		'vi': 'Yêu cầu thay đổi telegram',
		'th': 'เปลี่ยนโทรเลขที่ร้องขอ'
	},
	'Прошу изменить мне telegram на': {
		'ru': 'Прошу изменить мне telegram на',
		'uk': 'Прошу змінити мені telegram на',
		'en': 'Please change my telegram to',
		'de': 'Bitte ändern Sie Telegram auf',
		'vi': 'Xin vui lòng thay đổi tôi telegram tín trên',
		'th': 'โปรดเปลี่ยนเทเลแกรมให้ฉันที่'
	},
	'в': { 'uk': 'в', 'ru': 'в', en: 'at', de: 'в', vi: 'trong', th: 'ที่' },
	'Сводная статистика': {
		'uk': 'Зведена статистика',
		'ru': 'Вільна статистика',
		'en': 'Summary statistics',
		'de': 'Zusammenfassende Statistik',
		'vi': 'Thống kê tóm tắt',
		'th': 'สถิติสรุป'
	},
	'За неделю': {
		'ru': 'За неделю',
		'uk': 'За тиждень',
		'en': 'Week',
		'de': 'Der Woche',
		'vi': 'Trong tuần',
		'th': 'ในหนึ่งสัปดาห์'
	},
	'За день': {
		'ru': 'За день',
		'uk': 'За день',
		'en': 'Today',
		'de': 'Des Tages',
		'vi': 'Trong ngày',
		'th': 'ในหนึ่งวัน'
	},
	'за неделю': {
		'ru': 'за неделю',
		'uk': 'за тиждень',
		'en': 'week',
		'de': 'der Woche',
		'vi': 'trong tuần',
		'th': 'ในหนึ่งสัปดาห์'
	},
	'за день': {
		'ru': 'за день',
		'uk': 'за день',
		'en': 'today',
		'de': 'des Tages',
		'vi': 'trong ngày',
		'th': 'ใยหนึ่งวัน'
	},
	'Заработок': {
		'ru': 'Заработок',
		'uk': 'Заробіток',
		'en': 'Income',
		'de': 'Einkommen',
		'vi': 'Thu nhập',
		'th': 'รายได้'
	},
	'Доп. монетизация': {
		'ru': 'Домонетизация',
		'uk': 'Домонетизація',
		'en': 'Extra monetization',
		'de': 'Extra monetization',
		'vi': 'Extra monetization',
		'th': 'Extra monetization'
	},
	'Условия конкурса': {
		'ru': 'Условия конкурса',
		'uk': 'Умови конкурсу',
		'en': 'Rules of the contest',
		'de': 'Rules of the contest',
		'vi': 'Rules of the contest',
		'th': 'Rules of the contest'
	},
	'Условия': {
		'ru': 'Условия',
		'uk': 'Умови',
		'en': 'Conditions',
		'de': 'Conditions',
		'vi': 'Conditions',
		'th': 'Conditions'
	},
	'Как выиграть Range Rover?': {
		'ru': 'Как выиграть Range Rover?',
		'uk': 'Як виграти Range Rover?',
		'en': 'How to win Range Rover?',
		'de': 'How to win Range Rover?',
		'vi': 'How to win Range Rover?',
		'th': 'How to win Range Rover?'
	},
	'Добавить': {
		'ru': 'Добавить',
		'uk': 'Додати',
		'en': 'Add',
		'de': 'Hinzufügen',
		'vi': 'Thêm',
		'th': 'การเพิ่ม'
	},
	'Добавление потока на': {
		'ru': 'Добавление потока на',
		'uk': 'Додавання потоку на',
		'en': 'Adding a campaign to',
		'de': 'Hinzufügen eines Streams zu',
		'vi': 'Thêm luồng vào',
		'th': 'การเพิ่มสตรีมไปที่'
	},
	'Добавив поток на указанный вами оффер, Вы автоматически согласны с нижеприведенными правилами': {
		'ru': 'Добавив поток на указанный вами оффер, Вы автоматически согласны с нижеприведенными правилами',
		'uk': 'Додавши потік на вказаний вами оффер, Ви автоматично згодні з наведеними нижче правилами',
		'en': 'By adding a stream to the offer you specified, you automatically agree with the rules below',
		'de': 'Durch Hinzufügen eines Streams zu dem von Ihnen angegebenen Angebot stimmen Sie automatisch den folgenden Regeln zu.',
		'vi': 'Bằng cách thêm luồng vào phiếu mua hàng bạn đã chỉ định, bạn tự động đồng ý với các quy tắc bên dưới',
		'th': 'โดยการเพิ่มสตรีมในข้อเสนอที่คุณระบุแสดงว่าคุณยอมรับกฎด้านล่างโดยอัตโนมัติ'
	},
	'Добавив данный оффер Вы автоматически подтверждаете, что согласны с правилами': {
		'ru': 'Добавив данный оффер Вы автоматически подтверждаете, что согласны с нижеприведенными правилами',
		'uk': 'Додавши цей оффер Ви автоматично підтверджуєте, що згодні з наведеними нижче правилами',
		'en': 'By adding this offer you automatically confirm that you agree with the following rules',
		'de': 'Wenn Sie dieses Angebot hinzufügen, akzeptieren Sie automatisch die folgenden Regeln.',
		'vi': 'Bằng cách thêm chương trình này, bạn tự động xác nhận rằng bạn đồng ý với các quy tắc sau',
		'th': 'การเพิ่มข้อเสนอนี้จะทำให้คุณยืนยันโดยอัตโนมัติว่าคุณเห็นด้วยกับกฎ'
	},
	'Добавив данную программу Вы автоматически подтверждаете, что согласны с правилами': {
		'ru': 'Добавив данную программу Вы автоматически подтверждаете, что согласны с нижеприведенными правилами',
		'uk': 'Додавши цю програму Ви автоматично підтверджуєте, що згодні з наведеними нижче правилами',
		'en': 'By adding this program you automatically confirm that you agree with the following rules',
		'de': 'Wenn Sie dieses Programm hinzufügen, akzeptieren Sie automatisch die folgenden Regeln.',
		'vi': 'Bằng cách thêm chương trình này, bạn tự động xác nhận rằng bạn đồng ý với các quy tắc sau',
		'th': 'โดยการเพิ่มรายการนี้ คุณได้ยืนยันอัตโนมัติว่าคุณเห็นด้วยในกฏเกณฑ์ดังต่อไปนี้'
	},
	'Отмена': {
		'ru': 'Отмена',
		'uk': 'Скасування',
		'en': 'Cancel',
		'de': 'Stornierung',
		'vi': 'Hủy',
		'th': 'ยกเลิก'
	},
	'Принять': {
		'ru': 'Принять',
		'uk': 'Прийняти',
		'en': 'Accept',
		'de': 'Akzeptiere',
		'vi': 'Chấp nhận',
		'th': 'นำมาใช้'
	},
	'Отклонить': {
		'ru': 'Отклонить',
		'uk': 'Відхилити',
		'en': 'Cancel',
		'de': 'Abbrechen',
		'vi': 'Hủy bỏ',
		'th': 'การยกเลิก'
	},
	'Подтверждение': {
		'ru': 'Подтверждение',
		'uk': 'Підтвердження',
		'en': 'Approve',
		'de': 'Bestätigung',
		'vi': 'Xác nhận',
		'th': 'การยืนยัน'
	},
	'Минимальная сумма выплаты': {
		'ru': 'Минимальная сумма выплаты',
		'uk': 'Мінімальна сума виплати',
		'en': 'Minimum payout amount is',
		'de': 'Der Mindestauszahlungsbetrag',
		'vi': 'Số tiền thanh toán tối thiểu',
		'th': 'จำนวนการชำระเงินขั้นต่ำ'
	},
	'Минимальная сумма': {
		'ru': 'Минимальная сумма',
		'uk': 'Мінімальна сума',
		'en': 'Minimum amount is',
		'de': 'Mindestbetrag',
		'vi': 'Số tiền tối thiểu',
		'th': 'จำนวนขั้นต่ำ'
	},
	'Аппрув': {
		'ru': 'Аппрув',
		'uk': 'Аппрув',
		'en': 'Approve',
		'de': 'Bestätigung',
		'vi': 'Approve',
		'th': 'Approve'
	},
	'Ключ сессии': {
		'ru': 'Ключ сессии',
		'uk': 'Ключ сесії',
		'en': 'Session key',
		'de': 'Sitzungsschlüssel',
		'vi': 'Khóa phiên',
		'th': 'กุญแจเข้าที่ประชุม'
	},
	'Все': { 'ru': 'Все', 'uk': 'Усі', en: 'All', de: 'Alle', vi: 'Tất cả', th: 'ทั้งหมด' },
	'стран': {
		'ru': 'стран',
		'uk': 'країн',
		'en': 'countries',
		'de': 'Länder',
		'vi': 'nước',
		'th': 'ประเทศ'
	},
	'страну': {
		'ru': 'страну',
		'uk': 'країну',
		'en': 'country',
		'de': 'Land',
		'vi': 'nước',
		'th': 'ประเทศ'
	},
	'страны': {
		'ru': 'страны',
		'uk': 'країни',
		'en': 'countries',
		'de': 'Länder',
		'vi': 'nước',
		'th': 'ประเทศ'
	},
	'Скрыть': {
		'ru': 'Скрыть',
		'uk': 'Приховати',
		'en': 'Hide',
		'de': 'Verstecken',
		'vi': 'Giấu',
		'th': 'ซ่อน'
	},
	'У вас не подключено ни одной из валют, доступных для этого офера': {
		'ru': 'У вас не подключено ни одной из валют, доступных для этого офера. Пожалуйста, подключите в профиле',
		'uk': 'У вас не підключена жодна з валют, доступних для цього офера. Будь ласка, підключіть у профілі',
		'en': 'You have not added any currency from available for this offer. Please add in your profile',
		'de': 'Sie haben keine Währungen zu diesem Angebot verbunden. Fügen Sie bitte die Währung in Ihr Profil hinzu',
		'vi': 'Bạn không có bất kỳ loại tiền tệ nào có sẵn cho offer này. Vui lòng kết nối nó trên trang cá nhân',
		'th': 'คุณไม่มีค่าสกุลเงินใดๆที่ใช้ได้กับข้อเสนอนี้ โปรดเชื่อมต่อไปยังประวัติ'
	},
	'язык': {
		'ru': 'язык',
		'uk': 'мова',
		'en': 'langs',
		'de': 'Sprache',
		'vi': 'ngôn ngữ',
		'th': 'ภาษา'
	},
	'языка': {
		'ru': 'языка',
		'uk': 'язика',
		'en': 'langs',
		'de': 'Sprache',
		'vi': 'ngôn ngữ',
		'th': 'ภาษา'
	},
	'языков': {
		'ru': 'языков',
		'uk': 'мов',
		'en': 'langs',
		'de': 'Sprachen',
		'vi': 'ngôn ngữ',
		'th': 'ภาษา'
	},
	'Посмотреть старую статистику': {
		'ru': 'Посмотреть старую статистику',
		'uk': 'Переглянути стару статистику',
		'en': 'View old statistics',
		'de': 'Alte Statistiken anzeigen',
		'vi': 'Xem thống kê cũ',
		'th': 'ดูสถิติเก่า'
	},
	'Сервер не найден': {
		'ru': 'Сервер не найден',
		'uk': 'Сервер не знайдено',
		'en': 'Server not found',
		'de': 'Server nicht gefunden',
		'vi': 'Không tìm thấy máy chủ',
		'th': 'ไม่พบเซิฟเวอร์หรือผู้ให้บริการ'
	},
	'API конверсий': {
		'ru': 'API конверсий',
		'uk': 'API конверсій',
		'en': 'Conversions API',
		'de': 'API von Conversions',
		'vi': 'API Chuyển đổi',
		'th': 'การแปลงสภาพ API'
	},
	'Дисконты и Бонусы': {
		'ru': 'Бонусы и дисконты',
		'uk': 'Бонуси та дисконти',
		'en': 'Discounts',
		'de': 'Rabatte und Boni',
		'vi': 'Giảm giá thưởng',
		'th': 'ส่วนลดและโบนัส'
	},
	'Поздравлям, вы получили новый ранг': {
		'ru': 'Поздравлям, вы получили новый ранг',
		'uk': 'Вітаємо, ви отримали новий ранг',
		'en': 'Congrads you achived new rank',
		'de': 'Congrads you achived new rank',
		'vi': 'Congrads you achived new rank',
		'th': 'Congrads you achived new rank'
	},
	'QUID за этот месяц': {
		'ru': 'QUID за этот месяц',
		'uk': 'QUID за цей місяць',
		'en': 'Monthly QUID',
		'de': 'Monthly QUID',
		'vi': 'Monthly QUID',
		'th': 'Monthly QUID'
	},
	'QUID за этот месяц': {
		'ru': 'QUID за этот месяц',
		'uk': 'QUID за цей місяць',
		'en': 'Monthly QUID',
		'de': 'Monthly QUID',
		'vi': 'Monthly QUID',
		'th': 'Monthly QUID'
	},
	'QUID за все время': {
		'ru': 'QUID за все время',
		'uk': 'QUID за весь час',
		'en': 'Total QUID',
		'de': 'Total QUID',
		'vi': 'Total QUID',
		'th': 'Total QUID'
	},
	'Текущая позиция': {
		'ru': 'Текущая позиция',
		'uk': 'Поточна позиція',
		'en': 'Current position',
		'de': 'Current position',
		'vi': 'Current position',
		'th': 'Current position'
	},
	'Ваш статус': {
		'ru': 'Ваш статус',
		'uk': 'Ваш статус',
		'en': 'Your status',
		'de': 'Your status',
		'vi': 'Your status',
		'th': 'Your status'
	},
	'Осталось': {
		'ru': 'Осталось',
		'uk': 'Залишилось',
		'en': 'Left',
		'de': 'Left',
		'vi': 'Left',
		'th': 'Left'
	},
	'Начальный от': {
		'ru': 'Beginner от',
		'uk': 'Початковий від',
		'en': 'Beginner from',
		'de': 'Beginner from',
		'vi': 'Beginner from',
		'th': 'Beginner from'
	},
	'Бронза': {
		'ru': 'Бронза',
		'uk': 'Бронза',
		'en': 'Bronze',
		'de': 'Bronze',
		'vi': 'Bronze',
		'th': 'Bronze'
	},
	'Зиппо зажигалка': {
		'ru': 'Зиппо зажигалка',
		'uk': 'Зиппо запальничка',
		'en': 'Zippo lighter',
		'de': 'Zippo lighter',
		'vi': 'Zippo lighter',
		'th': 'Zippo lighter'
	},
	'Серебро': {
		'ru': 'Серебро',
		'uk': 'Срібло',
		'en': 'Silver',
		'de': 'Silver',
		'vi': 'Silver',
		'th': 'Silver'
	},
	'Золото': {
		'ru': 'Золото',
		'uk': 'Золото',
		'en': 'Gold',
		'de': 'Gold',
		'vi': 'Gold',
		'th': 'Gold'
	},
	'Даймонд': {
		'ru': 'Даймонд',
		'uk': 'Діамант',
		'en': 'Diamond',
		'de': 'Diamond',
		'vi': 'Diamond',
		'th': 'Diamond'
	},
	'Бомбер Rocket': {
		'ru': 'Бомбер Rocket',
		'uk': 'Бомбер Rocket',
		'en': 'Bomber Rocket',
		'de': 'Bomber Rocket',
		'vi': 'Bomber Rocket',
		'th': 'Bomber Rocket'
	},
	'При накопление от': {
		'ru': 'При накопление от',
		'uk': 'При накопиченні від',
		'en': 'When accumulating from',
		'de': 'When accumulating from',
		'vi': 'When accumulating from',
		'th': 'When accumulating from'
	},
	'до': {
		'ru': 'до',
		'uk': 'до',
		'en': 'to',
		'de': 'to',
		'vi': 'to',
		'th': 'to'
	},
	'Подробнее о программе': {
		'ru': 'Подробнее о программе',
		'uk': 'Докладніше про програму',
		'en': 'More about the program',
		'de': 'More about the program',
		'vi': 'More about the program',
		'th': 'More about the program'
	},
	'который необходимо подтверждать ежeмесячно, вебмастер получает': {
		'ru': 'который необходимо подтверждать ежeмесячно, вебмастер получает',
		'uk': 'який необхідно підтверджувати щомісяця, вебмайстер отримує',
		'en': 'which must be confirmed monthly, the webmaster receives',
		'de': 'which must be confirmed monthly, the webmaster receives',
		'vi': 'which must be confirmed monthly, the webmaster receives',
		'th': 'which must be confirmed monthly, the webmaster receives'
	},
	'ко всем заработаным': {
		'ru': 'ко всем заработаным',
		'uk': 'до всіх зароблених',
		'en': 'to all earned',
		'de': 'to all earned',
		'vi': 'to all earned',
		'th': 'to all earned'
	},
	'за месяц': {
		'ru': 'за месяц',
		'uk': 'за місяць',
		'en': 'during month',
		'de': 'during month',
		'vi': 'during month',
		'th': 'during month'
	},
	'Заработать от': {
		'ru': 'Заработать от',
		'uk': 'Заробити від',
		'en': 'Earn from',
		'de': 'Earn from',
		'vi': 'Earn from',
		'th': 'Earn from'
	},
	'Обложка на паспорт': {
		'ru': 'Обложка на паспорт',
		'uk': 'Обкладинка на паспорт',
		'en': 'Passport Cover',
		'de': 'Passport Cover',
		'vi': 'Passport Cover',
		'th': 'Passport Cover'
	},
	'Условия использования': {
		'ru': 'Условия использования',
		'uk': 'Умови використання',
		'en': 'Terms of Use',
		'de': 'Terms of Use',
		'vi': 'Terms of Use',
		'th': 'Terms of Use'
	},
	'QUID - самая что ни на есть настоящая космическая валюта, которая\
	расшифровывается как квазиуниверсальная интергалактическая деноминация\
	, сокращенно - куид (QUID). Именно так называются бонусы RocketProfit,\
	которые можно обменивать на крутые подарки в': {
		'ru': `QUID - самая что ни на есть настоящая космическая валюта, которая
			расшифровывается как квазиуниверсальная интергалактическая деноминация
			, сокращенно - куид (QUID). Именно так называются бонусы RocketProfit,
			которые можно обменивать на крутые подарки в`,
		'uk': `QUID — це справжня космічна валюта, 
			яка розшифровується як квазіуніверсальна інтегалактична деномінація, 
			скорочено — куид (QUID). Саме так називаються бонуси RocketProfit, 
			які можна обмінювати на класні подарунки в`,
		'en': `QUID is the most real space currency, which
			stands for quasi-universal intergalactic denomination
			, abbreviated as quid (QUID). That's what RocketProfit bonuses are called,
			which can be exchanged for cool gifts in `,
		'de': `QUID is the most real space currency, which
			stands for quasi-universal intergalactic denomination
			, abbreviated as quid (QUID). That's what RocketProfit bonuses are called,
			which can be exchanged for cool gifts in `,
		'vi': `QUID is the most real space currency, which
			stands for quasi-universal intergalactic denomination
			, abbreviated as quid (QUID). That's what RocketProfit bonuses are called,
			which can be exchanged for cool gifts in `,
		'th': `QUID is the most real space currency, which
			stands for quasi-universal intergalactic denomination
			, abbreviated as quid (QUID). That's what RocketProfit bonuses are called,
			which can be exchanged for cool gifts in `
	},
	'Чем больше QUID вы заработали, тем выше статус, а вместе\
	сним и увеличивается сумма заработанных бонусов. Подостижению статуса всех\
	наших Бро ждут приятные подарки!': {
		'ru': `Чем больше QUID вы заработали, тем выше статус,
			а вместе с ним и увеличивается сумма заработанных бонусов.
			По достижению статуса всех наших Бро ждут приятные подарки!`,
		'uk': `Чим більше QUID ви заробили, тим вищий статус, 
			а разом з ним і збільшується сума зароблених бонусів. 
			При досягненні статусу всіх наших Бро чекають приємні подарунки!`,
		'en': `The more QUID you have earned, the higher your status,
			and together with it, the amount of bonuses earned will increase.
			To achieve the status of all our bros, pleasant gifts are waiting!`,
		'de': `The more QUID you have earned, the higher your status,
			and together with it, the amount of bonuses earned will increase.
			To achieve the status of all our bros, pleasant gifts are waiting!`,
		'vi': `The more QUID you have earned, the higher your status,
			and together with it, the amount of bonuses earned will increase.
			To achieve the status of all our bros, pleasant gifts are waiting!`,
		'th': `The more QUID you have earned, the higher your status,
			and together with it, the amount of bonuses earned will increase.
			To achieve the status of all our bros, pleasant gifts are waiting!`
	},
	'Ваши подарки': {
		'ru': 'Ваши подарки',
		'uk': 'Ваші подарунки',
		'en': 'Your gifts',
		'de': 'Your gifts',
		'vi': 'Your gifts',
		'th': 'Your gifts'
	},
	'Халат Rocket и носки': {
		'ru': 'Халат Rocket и носки',
		'uk': 'Халат Rocket та шкарпетки',
		'en': 'Rocket Robe and Socks',
		'de': 'Rocket Robe and Socks',
		'vi': 'Rocket Robe and Socks',
		'th': 'Rocket Robe and Socks'
	},
	'IQOS, личный анимированый стикерпак': {
		'ru': 'IQOS, личный анимированый стикерпак',
		'uk': 'IQOS, особистий анімований стікерпак',
		'en': 'IQOS, personal animated sticker pack',
		'de': 'IQOS, personal animated sticker pack',
		'vi': 'IQOS, personal animated sticker pack',
		'th': 'IQOS, personal animated sticker pack'
	},
	'Заработать от 1 до 2 499 QUID за месяц.': {
		'ru': 'Заработать от 1 до 2 499 QUID за месяц.',
		'uk': 'Заробити від 1 до 2499 QUID за місяць.',
		'en': 'Earn starting from 1 to 2 499 QUID per month.',
		'de': 'Earn starting from 1 to 2 499 QUID per month.',
		'vi': 'Earn starting from 1 to 2 499 QUID per month.',
		'th': 'Earn starting from 1 to 2 499 QUID per month.'
	},
	'Подарки': {
		'ru': 'Подарки',
		'uk': 'Подарунки',
		'en': 'Gifts',
		'de': 'Gifts',
		'vi': 'Gifts',
		'th': 'Gifts'
	},
	'и забирай подарки от Everad.': {
		'ru': 'и забирай подарки от Everad.',
		'uk': 'та забирай подарунки від Everad.',
		'en': 'and take gifts from Everad.',
		'de': 'and take gifts from Everad.',
		'vi': 'and take gifts from Everad.',
		'th': 'and take gifts from Everad.'
	},
	'В период с 27 Ноября по 4 Декабря 2021 наливай': {
		'ru': 'В период с 27 Ноября по 4 Декабря 2021 наливай',
		'uk': 'У період з 27 Листопада по 4 Грудня 2021 наливай',
		'en': 'In the period from November 27 to December 4, 2021 pour',
		'de': 'In the period from November 27 to December 4, 2021 pour',
		'vi': 'In the period from November 27 to December 4, 2021 pour',
		'th': 'In the period from November 27 to December 4, 2021 pour'
	},
	'от 200 заапрувленных лидов': {
		'ru': 'от 200 заапрувленных лидов',
		'uk': 'від 200 заапрувлених лідів',
		'en': 'from 200 approved leads',
		'de': 'from 200 approved leads',
		'vi': 'from 200 approved leads',
		'th': 'from 200 approved leads'
	},
	'от': {
		'ru': 'от',
		'uk': 'від',
		'en': 'from',
		'de': 'from',
		'vi': 'from',
		'th': 'from'
	},
	'заапрувленных лидов': {
		'ru': 'апрувнутых лидов',
		'uk': 'апрувнутих лідів',
		'en': 'approved leads',
		'de': 'approved leads',
		'vi': 'approved leads',
		'th': 'approved leads'
	},
	'Налей': {
		'ru': 'Налей',
		'uk': 'Налий',
		'en': 'Pour',
		'de': 'Pour',
		'vi': 'Pour',
		'th': 'Pour'
	},
	'Сертификат': {
		'ru': 'Сертификат',
		'uk': 'Сертифікат',
		'en': 'Certificate',
		'de': 'Certificate',
		'vi': 'Certificate',
		'th': 'Certificate'
	},
	'Лицензия': {
		'ru': 'Лицензия',
		'uk': 'Ліцензія',
		'en': 'License',
		'de': 'License',
		'vi': 'License',
		'th': 'License'
	},
	'Профессиональный': {
		'ru': 'Профессиональный',
		'uk': 'Професійний',
		'en': 'Professional',
		'de': 'Professional',
		'vi': 'Professional',
		'th': 'Professional'
	},
	'пожиз': {
		'ru': 'пожизненная',
		'uk': 'довічна',
		'en': 'lifelong',
		'de': 'lifelong',
		'vi': 'lifelong',
		'th': 'lifelong'
	},
	'тариф': {
		'ru': 'тариф',
		'uk': 'тариф',
		'en': 'rate',
		'de': 'rate',
		'vi': 'rate',
		'th': 'rate'
	},
	'мес': {
		'ru': 'мес',
		'uk': 'міс',
		'en': 'month',
		'de': 'month',
		'vi': 'month',
		'th': 'month'
	},
	'Лицензия Keitaro Pro': {
		'ru': 'Лицензия Keitaro Pro',
		'uk': 'Ліцензія Keitaro Pro',
		'en': 'Keitaro Pro License',
		'de': 'Keitaro Pro License',
		'vi': 'Keitaro Pro License',
		'th': 'Keitaro Pro License'
	},
	'Набор эксклюзивного мерча': {
		'ru': 'Набор эксклюзивного мерча',
		'uk': 'Набір ексклюзивного мерчу',
		'en': 'Exclusive merch bundle',
		'de': 'Exclusive merch bundle',
		'vi': 'Exclusive merch bundle',
		'th': 'Exclusive merch bundle'
	},
	'Смотреть подарки': {
		'ru': 'Смотреть подарки',
		'uk': 'Дивитись подарунки',
		'en': 'View gifts',
		'de': 'View gifts',
		'vi': 'View gifts',
		'th': 'View gifts'
	},
	'Лиды': {
		'ru': 'Лиды',
		'uk': 'Ліди',
		'en': 'Leads',
		'de': 'Leads',
		'vi': 'Leads',
		'th': 'Leads'
	},
	'Осталось %s лидов': {
		'ru': 'Еще %s Лидов...',
		'uk': 'Ще %s Лідів...',
		'en': '%s leads left',
		'de': '%s leads left',
		'vi': '%s leads left',
		'th': '%s leads left'
	},
	'Поздравляем, ты участвуешь в розыгрыше подарков!': {
		'ru': 'Поздравляем, ты участвуешь в розыгрыше подарков!',
		'uk': 'Вітаємо, ти береш участь у розіграші подарунків!',
		'en': 'Congratulations, you are participating in the raffle of gifts!',
		'de': 'Congratulations, you are participating in the raffle of gifts!',
		'vi': 'Congratulations, you are participating in the raffle of gifts!',
		'th': 'Congratulations, you are participating in the raffle of gifts!'
	},
	'с 27 ноября по 4 декабря и участвуй в розыгрыше подарков “Черной пятницы” от Everad': {
		'ru': 'с 27 ноября по 4 декабря и участвуй в розыгрыше подарков “Черной пятницы” от Everad',
		'uk': 'з 27 листопада по 4 грудня та бери участь у розіграші подарунків “Чорної п\'ятниці” від Everad',
		'en': 'from November 27 to December 4 and participate in the "Black Friday" gift raffle from Everad',
		'de': 'from November 27 to December 4 and participate in the "Black Friday" gift raffle from Everad',
		'vi': 'from November 27 to December 4 and participate in the "Black Friday" gift raffle from Everad',
		'th': 'from November 27 to December 4 and participate in the "Black Friday" gift raffle from Everad'
	},
	'Черная пятница дарит подарки!': {
		'ru': 'Черная пятница дарит подарки!',
		'uk': 'Чорна п\'ятниця дарує подарунки!',
		'en': 'Black Friday gives gifts!',
		'de': 'Black Friday gives gifts!',
		'vi': 'Black Friday gives gifts!',
		'th': 'Black Friday gives gifts!'
	},
	'Тебя ожидают:': {
		'ru': 'Тебя ожидают:',
		'uk': 'Тебе очикують:',
		'en': 'Gifts await you:',
		'de': 'Gifts await you:',
		'vi': 'Gifts await you:',
		'th': 'Gifts await you:'
	},
	'Смотреть стрим': {
		'ru': 'Смотреть стрим!',
		'uk': 'Дивитись стрім!',
		'en': 'Watch stream',
		'de': 'Watch stream',
		'vi': 'Watch stream',
		'th': 'Watch stream'
	},
	'Смотри': {
		'ru': 'Смотри',
		'uk': 'Дивись',
		'en': 'Watch',
		'de': 'Watch',
		'vi': 'Watch',
		'th': 'Watch'
	},
	'стрим розыгрыша подарков Черной пятницы': {
		'ru': 'стрим розыгрыша подарков Черной пятницы',
		'uk': 'стрім розіграшу подарунків Чорної п\'ятниці',
		'en': 'black friday gift raffle stream',
		'de': 'black friday gift raffle stream',
		'vi': 'black friday gift raffle stream',
		'th': 'black friday gift raffle stream'
	},
	'9го декабря': {
		'ru': '9го декабря',
		'uk': '9-го грудня',
		'en': 'December 9th',
		'de': 'December 9th',
		'vi': 'December 9th',
		'th': 'December 9th'
	},
	'Билеты на': {
		'ru': 'Билеты на',
		'uk': 'Квитки на',
		'en': 'Tickets to',
		'de': 'Tickets to',
		'vi': 'Tickets to',
		'th': 'Tickets to'
	},
	'При накоплении от': {
		'ru': 'При накоплении от',
		'uk': 'При накопиченні від',
		'en': 'Having accumulated from',
		'de': 'Having accumulated from',
		'vi': 'Having accumulated from',
		'th': 'Having accumulated from'
	},
	'за месяц. По достижению статуса "Бронза", который необходимо подтверждать ежемесячно, вебмастер получает': {
		'ru': 'за месяц. По достижению статуса "Bronze", который необходимо подтверждать ежемесячно, вебмастер получает дополнительный коэффициент',
		'uk': 'за місяць. При досягненні статусу "Bronze", який потрібно підтверджувати щомісяця, вебмайстер отримує додатковий коефіцієнт.',
		'en': 'a month while reaching the status "Bronze", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'de': 'a month while reaching the status "Bronze", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'vi': 'a month while reaching the status "Bronze", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'th': 'a month while reaching the status "Bronze", which must be confirmed monthly, the webmaster receives an additional coefficient of'
	},
	'за месяц. По достижению статуса "Серебро", который необходимо подтверждать ежемесячно, вебмастер получает': {
		'ru': 'за месяц. По достижению статуса "Silver", который необходимо подтверждать ежемесячно, вебмастер получает дополнительный коэффициент',
		'uk': 'за місяць. При досягненні статусу "Silver", який потрібно підтверджувати щомісяця, вебмайстер отримує додатковий коефіцієнт',
		'en': 'a month while reaching the status "Silver", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'de': 'a month while reaching the status "Silver", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'vi': 'a month while reaching the status "Silver", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'th': 'a month while reaching the status "Silver", which must be confirmed monthly, the webmaster receives an additional coefficient of',
	},
	'за месяц. По достижению статуса "Золото", который необходимо подтверждать ежемесячно, вебмастер получает': {
		'ru': 'за месяц. По достижению статуса "Gold", который необходимо подтверждать ежемесячно, вебмастер получает дополнительный коэффициент',
		'uk': 'за місяць. При досягненні статусу "Gold", який потрібно підтверджувати щомісяця, вебмайстер отримує додатковий коефіцієнт',
		'en': 'a month while reaching the status "Gold", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'de': 'a month while reaching the status "Gold", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'vi': 'a month while reaching the status "Gold", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'th': 'a month while reaching the status "Gold", which must be confirmed monthly, the webmaster receives an additional coefficient of'
	},
	'за месяц. По достижению статуса "Даймонд", который необходимо подтверждать ежемесячно, вебмастер получает': {
		'ru': 'за месяц. По достижению статуса "Diamond", который необходимо подтверждать ежемесячно, вебмастер получает дополнительный коэффициент',
		'uk': 'за місяць. При досягненні статусу "Diamond", який потрібно підтверджувати щомісяця, вебмайстер отримує додатковий коефіцієнт.',
		'en': 'a month while reaching the status "Diamond", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'de': 'a month while reaching the status "Diamond", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'vi': 'a month while reaching the status "Diamond", which must be confirmed monthly, the webmaster receives an additional coefficient of',
		'th': 'a month while reaching the status "Diamond", which must be confirmed monthly, the webmaster receives an additional coefficient of'
	},
	'ко всем заработанным в следующем месяце QUID': {
		'ru': 'за каждый подтвержденный лид в этом и следующем месяце',
		'uk': 'за кожен підтверджений лід у цьому та наступному місяці',
		'en': `for each confirmed lead for current and the next month`,
		'de': `for each confirmed lead for current and the next month`,
		'vi': `for each confirmed lead for current and the next month`,
		'th': `for each confirmed lead for current and the next month`
	},
	'При накоплении': {
		'ru': 'При накоплении',
		'uk': 'При накопиченні',
		'en': `With the accumulation of`,
		'de': `With the accumulation of`,
		'vi': `With the accumulation of`,
		'th': `With the accumulation of`
	},
	'за все время использования бонусной программы, вебмастер получает постоянный статус и': {
		'ru': 'за все время использования бонусной программы, вебмастер получает статус "Black Member" и дополнительный коэффициент',
		'uk': 'За весь час використання бонусної програми вебмайстер отримує статус "Black Member" та додатковий коефіцієнт.',
		'en': 'for the entire time the bonus program is used, the webmaster receives the status of "Black Member" and an additional coefficient of',
		'de': 'for the entire time the bonus program is used, the webmaster receives the status of "Black Member" and an additional coefficient of',
		'vi': 'for the entire time the bonus program is used, the webmaster receives the status of "Black Member" and an additional coefficient of',
		'th': 'for the entire time the bonus program is used, the webmaster receives the status of "Black Member" and an additional coefficient of'
	},
	'ко всем заработанным в дальнейшем QUID': {
		'ru': `за каждый подтвержденный лид на постоянной основе`,
		'uk': `за кожен підтверджений лід на постійній основі`,
		'en': `for each confirmed lead on a regular basis`,
		'de': `for each confirmed lead on a regular basis`,
		'vi': `for each confirmed lead on a regular basis`,
		'th': `for each confirmed lead on a regular basis`
	},
	'Отныне каждому партнеру RocketProfit будет присвоен свой статус:': {
		'ru': 'Отныне каждому партнеру RocketProfit будет присвоен свой статус:',
		'uk': 'Відтепер кожному партнеру RocketProfit буде надано свій статус:',
		'en': 'From now on, each RocketProfit partner will be assigned its status:',
		'de': 'From now on, each RocketProfit partner will be assigned its status:',
		'vi': 'From now on, each RocketProfit partner will be assigned its status:',
		'th': 'From now on, each RocketProfit partner will be assigned its status:'
	},
	'Начальный, Бронза, Серебро, Золото, Даймонд, Black Member.': {
		'ru': 'Начальный, Бронза, Серебро, Золото, Даймонд, Black Member.',
		'uk': 'Початковий, Бронза, Срібло, Золото, Діамант, Black Member.',
		'en': 'Beginner, Bronze, Silver, Gold, Diamond, Black Member.',
		'de': 'Beginner, Bronze, Silver, Gold, Diamond, Black Member.',
		'vi': 'Beginner, Bronze, Silver, Gold, Diamond, Black Member.',
		'th': 'Beginner, Bronze, Silver, Gold, Diamond, Black Member.'
	},
	'Дисконты': {
		'ru': 'Дисконты',
		'uk': 'Дисконти',
		'en': 'Discounts',
		'de': 'Rabatte',
		'vi': 'Giảm giá',
		'th': 'ส่วนลด'
	},
	'Beginner': {
		'ru': 'Начальный',
		'uk': 'Початковий',
		'en': 'Beginner',
		'de': 'Beginner',
		'vi': 'Beginner',
		'th': 'Beginner'
	},
	'Bronze': {
		'ru': 'Бронза',
		'uk': 'Бронза',
		'en': 'Bronze',
		'de': 'Bronze',
		'vi': 'Bronze',
		'th': 'Bronze'
	},
	'Silver': {
		'ru': 'Серебро',
		'uk': 'Срібло',
		'en': 'Silver',
		'de': 'Silver',
		'vi': 'Silver',
		'th': 'Silver'
	},
	'Gold': {
		'ru': 'Золото',
		'uk': 'Золото',
		'en': 'Gold',
		'de': 'Gold',
		'vi': 'Gold',
		'th': 'Gold'
	},
	'Diamond': {
		'ru': 'Даймонд',
		'uk': 'Діамант',
		'en': 'Diamond',
		'de': 'Diamond',
		'vi': 'Diamond',
		'th': 'Diamond'
	},
	'Black member': {
		'ru': 'Black member',
		'uk': 'Black member',
		'en': 'Black member',
		'de': 'Black member',
		'vi': 'Black member',
		'th': 'Black member'
	},
	'API кабинета': {
		'ru': 'API кабинета',
		'uk': 'API кабінету',
		'en': 'Dashboard API',
		'de': 'Dashboard API',
		'vi': 'API của phòng',
		'th': 'การศึกษา API'
	},
	'Ваше имя': {
		'ru': 'Ваше ім\'я',
		'uk': 'Ваше ',
		'en': 'Your name',
		'de': 'Ihr Name',
		'vi': 'Tên của bạn',
		'th': 'ชื่อคุณ'
	},
	'Ваш телефон': {
		'ru': 'Ваш телефон',
		'uk': 'Ваш телефон',
		'en': 'Your phone',
		'de': 'Ihre Telefonnummer',
		'vi': 'Số điện thoại của bạn',
		'th': 'เบอร์โทรคุณ'
	},
	'Сделать заказ!': {
		'ru': 'Сделать заказ!',
		'uk': 'Зробити замовлення!',
		'en': 'Order now!',
		'de': 'Jetzt bestellen!',
		'vi': 'Đặt hàng!',
		'th': 'สั่งซื้อ'
	},
	'Прием заказов через': {
		'ru': 'Прием заказов через',
		'uk': 'Прийом замовлень через',
		'en': 'Receiving orders with',
		'de': 'Die Annahme von Aufträgen durch',
		'vi': 'Nhận đặt hàng thông qua',
		'th': 'รับคำสั่งซื้อผ่าน'
	},
	'Отправка с сервера': {
		'ru': 'Отправка с сервера',
		'uk': 'Відправка з сервера',
		'en': 'Sending from server',
		'de': 'Versendung vom Server',
		'vi': 'Gửi từ máy chủ',
		'th': 'การส่งจากเซิฟเวอร์หรือผู้ให้บริการ'
	},
	'Для отправки заказа по API, отправьте POST запрос': {
		'ru': 'Для отправки заказа по API, отправьте POST запрос',
		'uk': 'Для відправки замовлення через API надішліть POST запит.',
		'en': 'To send an order via API, edit the POST request',
		'de': 'To send an order via API, edit the POST request',
		'vi': 'To send an order via API, edit the POST request',
		'th': 'To send an order via API, edit the POST request'
	},
	'Запрос должен быть с заголовком': {
		'ru': 'Запрос должен быть с заголовком',
		'uk': 'Запит має бути з заголовком',
		'en': 'The request must have a header',
		'de': 'The request must have a header',
		'vi': 'The request must have a header',
		'th': 'The request must have a header'
	},
	'В теле запроса ожидаются следующие данные:': {
		'ru': 'В теле запроса ожидаются следующие данные:',
		'uk': 'У разі успішної обробки ліда сервер відповість кодом 200.',
		'en': 'The following data is expected in the request body:',
		'de': 'The following data is expected in the request body:',
		'vi': 'The following data is expected in the request body:',
		'th': 'The following data is expected in the request body:'
	},
	'В случае успешной обработки лида, сервер ответит кодом 200.': {
		'ru': 'В случае успешной обработки лида, сервер ответит кодом 200.',
		'uk': 'У разі успішної обробки ліда сервер відповість кодом 200.',
		'en': 'If the lead is successfully processed, the server will respond with code 200.',
		'de': 'If the lead is successfully processed, the server will respond with code 200.',
		'vi': 'If the lead is successfully processed, the server will respond with code 200.',
		'th': 'If the lead is successfully processed, the server will respond with code 200.'
	},
	'В случае редиректа код ответа будет 302.': {
		'ru': 'В случае редиректа код ответа будет 302.',
		'uk': 'У разі редіректу код відповіді буде 302.',
		'en': 'In case of a redirect, the response code will be 302.',
		'de': 'In case of a redirect, the response code will be 302.',
		'vi': 'In case of a redirect, the response code will be 302.',
		'th': 'In case of a redirect, the response code will be 302.'
	},
	'*subscribe1.php - наш файл-обработчик': {
		'ru': '*subscribe1.php - наш файл-обработчик, на который мы ссылаемся при отправке лидов. У вас это может быть ваш файл обработчик с обязательной трекерной ссылкой https://tracker.%s/conversion/new  и телом запроса со следующими параметрами:',
		'uk': '*subscribe1.php* — наш файл-обробник, на який ми посилаємось при відправці лідів. У вас це може бути ваш файл-обробник з обов\'язковим трекерним посиланням `https://tracker.%s/conversion/new` та тілом запиту з наступними параметрами:',
		'en': '*subscribe1.php is our handler file, which we refer to when sending leads. For you, this can be a handler for your file with a mandatory tracker link https://tracker.%s/conversion/new and your request taking into account the parameters:',
		'de': '*subscribe1.php is our handler file, which we refer to when sending leads. For you, this can be a handler for your file with a mandatory tracker link https://tracker.%s/conversion/new and your request taking into account the parameters:',
		'vi': '*subscribe1.php is our handler file, which we refer to when sending leads. For you, this can be a handler for your file with a mandatory tracker link https://tracker.%s/conversion/new and your request taking into account the parameters:',
		'th': '*subscribe1.php is our handler file, which we refer to when sending leads. For you, this can be a handler for your file with a mandatory tracker link https://tracker.%s/conversion/new and your request taking into account the parameters:'
	},
	'опциональные поля': {
		'ru': 'опциональные поля',
		'uk': 'опціональні поля',
		'en': 'optional fields',
		'de': 'optional fields',
		'vi': 'optional fields',
		'th': 'optional fields'
	},
	'В случае возникновения ошибки сервер вернет код 400 и в теле ответа будет перечень ошибок валидации.': {
		'ru': 'В случае возникновения ошибки сервер вернет код 400 и в теле ответа будет перечень ошибок валидации.',
		'uk': 'У разі виникнення помилки сервер поверне код 400, а в тілі відповіді буде перелік помилок валідації.',
		'en': 'If an error occurs, the server will return code 400 and a list of validation errors will be indicated in the response body.',
		'de': 'If an error occurs, the server will return code 400 and a list of validation errors will be indicated in the response body.',
		'vi': 'If an error occurs, the server will return code 400 and a list of validation errors will be indicated in the response body.',
		'th': 'If an error occurs, the server will return code 400 and a list of validation errors will be indicated in the response body.'
	},
	'Для отправки с веб-страницы (лендинга)': {
		'ru': 'Для отправки с веб-страницы (лендинга), создайте форму заказа с помощью HTML, чтобы она содержала все необходимые поля, как указано в примере ниже:',
		'uk': 'Для відправки з веб-сторінки (лендинга) створіть форму замовлення за допомогою HTML, щоб вона містила всі необхідні поля, як зазначено в прикладі нижче:',
		'en': 'To submit from a web page (landing page), create an order form using HTML so that it contains all the required fields, as shown in the example below:',
		'de': 'To submit from a web page (landing page), create an order form using HTML so that it contains all the required fields, as shown in the example below:',
		'vi': 'To submit from a web page (landing page), create an order form using HTML so that it contains all the required fields, as shown in the example below:',
		'th': 'To submit from a web page (landing page), create an order form using HTML so that it contains all the required fields, as shown in the example below:'
	},
	'Пример файла-обработчика на PHP': {
		'ru': 'Пример файла-обработчика на PHP',
		'uk': 'Приклад файлу-обробника на PHP',
		'en': 'Example of a handler file in PHP',
		'de': 'Example of a handler file in PHP',
		'vi': 'Example of a handler file in PHP',
		'th': 'Example of a handler file in PHP'
	},
	'Отправка с веб-страницы': {
		'ru': 'Отправка с веб-страницы',
		'uk': 'Відправка з веб-сторінки',
		'en': 'Sending from web-page',
		'de': 'Versendung von einer Webseite',
		'vi': 'Gửi từ trang web',
		'th': 'การส่งจากหน้าเวบ'
	},
	'Пример на PHP': {
		'ru': 'Пример на PHP',
		'uk': 'Приклад на PHP',
		'en': 'PHP example',
		'de': 'PHP Beispiel',
		'vi': 'Ví dụ PHP',
		'th': 'ตัวอย่าง PHP'
	},
	'Добавление пикселя facebook на скачанный ленд': {
		'ru': 'Добавление пикселя facebook на скачанный ленд',
		'uk': 'Додавання пікселя Facebook на завантажений лендінг',
		'en': 'Adding a facebook pixel to a downloaded landing',
		'de': 'Adding a facebook pixel to a downloaded landing',
		'vi': 'Adding a facebook pixel to a downloaded landing',
		'th': 'Adding a facebook pixel to a downloaded landing'
	},
	'Необходимо скачать ленд в формате php из сохраненного потока.': {
		'ru': 'Необходимо скачать ленд в формате php из сохраненного потока.',
		'uk': 'Необхідно завантажити лендінг у форматі PHP з збереженого потоку.',
		'en': 'You need to download the landing in php format from the saved campaign.',
		'de': 'You need to download the landing in php format from the saved campaign.',
		'vi': 'You need to download the landing in php format from the saved campaign.',
		'th': 'You need to download the landing in php format from the saved campaign.'
	},
	'Файл index.html переименовать на index.php.': {
		'ru': 'Файл index.html переименовать на index.php.',
		'uk': 'Файл index.html перейменувати на index.php.',
		'en': 'Rename index.html file to index.php.',
		'de': 'Rename index.html file to index.php.',
		'vi': 'Rename index.html file to index.php.',
		'th': 'Rename index.html file to index.php.'
	},
	'С помощью редактора кода или блокнота открываем index.php.': {
		'ru': 'С помощью редактора кода или блокнота открываем index.php.',
		'uk': 'За допомогою редактора коду або блокнота відкриваємо index.php.',
		'en': 'Using a code editor or notepad, open index.php.',
		'de': 'Using a code editor or notepad, open index.php.',
		'vi': 'Using a code editor or notepad, open index.php.',
		'th': 'Using a code editor or notepad, open index.php.'
	},
	'По поиску находим': {
		'ru': 'По поиску находим',
		'uk': 'По пошуку знаходимо',
		'en': 'We find by search',
		'de': 'We find by search',
		'vi': 'We find by search',
		'th': 'We find by search'
	},
	'и перед ним добавляем строчку': {
		'ru': 'и перед ним добавляем строчку',
		'uk': 'і перед ним додаємо рядок',
		'en': 'and add a line before it',
		'de': 'and add a line before it',
		'vi': 'and add a line before it',
		'th': 'and add a line before it'
	},
	'сохраняем': {
		'ru': 'сохраняем',
		'uk': 'зберігаємо',
		'en': 'safe',
		'de': 'safe',
		'vi': 'safe',
		'th': 'safe'
	},
	'В файле subscribe1.php находим строчку:': {
		'ru': 'В файле subscribe1.php находим строчку:',
		'uk': 'В файлі subscribe1.php знаходимо рядок:',
		'en': 'In the file subscribe1.php find the line',
		'de': 'In the file subscribe1.php find the line',
		'vi': 'In the file subscribe1.php find the line',
		'th': 'In the file subscribe1.php find the line'
	},
	'Под нее добавляем:': {
		'ru': 'Под нее добавляем:',
		'uk': 'Під неї додаємо:',
		'en': 'Below it add',
		'de': 'Below it add',
		'vi': 'Below it add',
		'th': 'Below it add'
	},
	'В файле  subscribe1.php, после тега': {
		'ru': 'В файле  subscribe1.php, после тега',
		'uk': 'В файлі subscribe1.php, після тегу',
		'en': 'In the subscribe1.php file, after the tag',
		'de': 'In the subscribe1.php file, after the tag',
		'vi': 'In the subscribe1.php file, after the tag',
		'th': 'In the subscribe1.php file, after the tag'
	},
	'перед': {
		'ru': 'перед',
		'uk': 'перед',
		'en': 'before',
		'de': 'before',
		'vi': 'before',
		'th': 'before'
	},
	'(это внизу страницы) добавляем:': {
		'ru': '(это внизу страницы) добавляем:',
		'uk': '(це внизу сторінки) додаємо:',
		'en': "(it's at the bottom of the page) add",
		'de': "(it's at the bottom of the page) add",
		'vi': "(it's at the bottom of the page) add",
		'th': "(it's at the bottom of the page) add"
	},
	'Сохраняем все внесенные изменения и загружаем лендинг к себе на хостинг/в трекер.': {
		'ru': 'Сохраняем все внесенные изменения и загружаем лендинг к себе на хостинг/в трекер.',
		'uk': 'Зберігаємо всі внесені зміни і завантажуємо лендинг до себе на хостинг/трекер.',
		'en': 'Save all the changes and upload the landing page to hosting/tracker.',
		'de': 'Save all the changes and upload the landing page to hosting/tracker.',
		'vi': 'Save all the changes and upload the landing page to hosting/tracker.',
		'th': 'Save all the changes and upload the landing page to hosting/tracker.'
	},
	'К рекламной ссылке дописываем': {
		'ru': 'К рекламной ссылке дописываем',
		'uk': 'До рекламного посилання дописуємо',
		'en': 'Add to the advertising link',
		'de': 'Add to the advertising link',
		'vi': 'Add to the advertising link',
		'th': 'Add to the advertising link'
	},
	'Видео-инструкция':{
		'ru': 'Видео-инструкция',
		'uk': 'Відео-інструкція',
		'en': 'Video guides',
		'de': 'Video Anweisungen',
		'vi': 'Hướng dẫn bằng video',
		'th': 'วิดีโอแนะนำ'
	},
	'Для отправки заказа через API, отправьте POST запрос': {
		'ru': 'Для отправки заказа через API, отправьте POST запрос',
		'uk': 'Щоб надіслати замовлення через API, надішліть POST запит',
		'en': 'To send order via API, send POST query',
		'de': 'Zum Bestellen von Angeboten über die API senden Sie die POST-Anfrage',
		'vi': 'Để gửi một đơn đặt hàng thông qua API hãy gửi yêu cầu POST',
		'th': 'เพื่อที่จะส่งคำสั่งซื้อโดยผ่าน API ส่งคำร้องขอที่โพสต์มา'
	},
	'на': { 'ru': 'на', 'uk': 'на', en: 'to', de: 'an', vi: 'trên', th: 'บน' },
	'с телом (application/x-www-form-urlencoded):': {
		'ru': ' с телом (application/x-www-form-urlencoded):',
		'uk': ' з тілом (application/x-www-form-urlencoded):',
		'en': ' with body (application/x-www-form-urlencoded):',
		'de': '\tmit dem Körper (application / x-www-form-urlencoded):',
		'vi': 'với nội dung (application/x-www-form-urlencoded):',
		'th': ' ร่างแบบฟอร์ม (การสมัคร/x-www-form-urlencoded)'
	},
	'campaign_id=500401&ip=54.67.12.1&name=John&phone=74521231314, где:': {
		'ru': 'campaign_id=500401&ip=54.67.12.1&name=John&phone=74521231314, где:',
		'uk': 'campaign_id=500401&ip=54.67.12.1&name=John&phone=74521231314, де:',
		'en': 'campaign_id=500401&ip=54.67.12.1&name=John&phone=74521231314, where:',
		'de': 'campaign_id=500401&ip=54.67.12.1&name=John&phone=74521231314, где:',
		'vi': 'campaign_id=500401&ip=54.67.12.1&name=John&phone=74521231314, nơi đâu:',
		'th': 'campaign_id=500401&ip=54.67.12.1&name=John&phone=74521231314, ที่ไหน:'
	},
	'IP клиента (критично передавать корректный IP для правильной работы системы ...': {
		'ru': 'IP клиента (критично передавать корректный IP для правильной работы системы, если ничего не передано, будет использоваться IP клиента, совершающего запрос)',
		'uk': 'IP клієнта (критично передавати коректний IP для правильної роботи системи, якщо нічого не передано, використовуватиметься IP клієнта, який здійснює запит)',
		'en': 'client\'s IP (it is important to send correct IP for proper system work, current client\'s IP will be used by default)',
		'de': 'IP-Adresse des Clients (Wichtig dabei: die richtige IP-Adresse für den korrekten Systembetrieb zu übertragen)',
		'vi': 'IP khách hàng (điều quan trọng là chuyển IP chính xác để hệ thống hoạt động đúng, nếu không gửi gì thì IP của khách hàng yêu cầu sẽ được sử dụng)',
		'th': 'ลูกค้าIPคือลูกค้ามาตรฐานที่สร้างขึ้นในเรื่องของการเชื่อมต่อข้อมูลระหว่างเครี่องปลายทางในเครือข่ายคอมพิวเตอร์หรือตัวเลียนแบบ เป็นเรื่องสำคัญที่ต้องถ่ายโอนIPที่ถูกต้องสำหรับการทำงานที่ถูกต้องของระบบ ถ้าไม่มีการถ่ายโอนสิ่งใด IPของลูกค้าที่ทำการร้องขอจะถูกนำมาใช้'
	},
	'ID кампании (берется из id потока, например 500401)': {
		'ru': 'ID кампании (берется из id потока, например 500401)',
		'uk': 'ID кампанії (береться з id потоку, наприклад 500401)',
		'en': 'campaign\'s ID (taken from id of campaign, for example 500401)',
		'de': 'Kampagne ID (es wird aus ID des kampagen genommen, z.B. 500401)',
		'vi': 'ID công ty (được lấy từ luồng id, ví dụ 500401)',
		'th': 'การระบุตัวตนหรือIDของโครงการ(เอามาจากการเรียกดูภาพที่ระบุIDหรือตัวตน ยกตัวอย่างเช่น 500401'
	},
	'имя клиента': {
		'ru': 'имя клиента',
		'uk': 'ім\'я клієнта',
		'en': 'client\'s name',
		'de': 'client Name',
		'vi': 'tên khách hàng',
		'th': 'ชื่อลูกค้า'
	},
	'телефон клиента': {
		'ru': 'телефон клиента',
		'uk': 'телефон клієнта',
		'en': 'client\'s phone',
		'de': 'client Telefonnummer',
		'vi': 'số điện thoại của khách hàng',
		'th': 'เบอร์โทรลูกค้า'
	},
	'дополнительный телефон (опционально)': {
		'ru': 'дополнительный телефон (опционально)',
		'uk': 'додатковий телефон (опционально)',
		'en': 'client\'s additional phone (optional)',
		'de': 'client Zusätzliches Telefon (optional)',
		'vi': 'điện thoại bổ sung của khách hàng (tùy chọn)',
		'th': 'โทรศัพท์เพิ่มเติม (ใส่หรือไม่ใส่ก็ได้)'
	},
	'адрес клиента (опционально)': {
		'ru': 'адрес клиента (опционально)',
		'uk': 'адреса клієнта (опционально)',
		'en': 'client\'s address (optional)',
		'de': 'client adresse (optional)',
		'vi': 'địa chỉ của khách hàng (tùy chọn)',
		'th': 'ที่อยู่ลูกค้า (ใส่หรือไม่ใส่ก็ได้)'
	},
	'еmail клиента (опционально)': {
		'ru': 'еmail клиєнта (опционально)',
		'uk': 'еmail кліента (опционально)',
		'en': 'client\'s email (optional)',
		'de': 'client\'s email (optional)',
		'vi': 'client\'s email (optional)',
		'th': 'client\'s email (optional)'
	},
	'улица (опционально)': {
		'ru': 'улица (опционально)',
		'uk': 'вулиця (опционально)',
		'en': 'street (optional)',
		'de': 'street (optional)',
		'vi': 'street (optional)',
		'th': 'street (optional)',
	},
	'дом (опционально)': {
		'ru': 'дом (опционально)',
		'uk': 'дім (опционально)',
		'en': 'house (optional)',
		'de': 'house (optional)',
		'vi': 'house (optional)',
		'th': 'house (optional)'
	},
	'квартира (опционально)': {
		'ru': 'квартира (опционально)',
		'uk': 'квартира (опционально)',
		'en': 'flat (optional)',
		'de': 'flat (optional)',
		'vi': 'flat (optional)',
		'th': 'flat (optional)'
	},
	'почтовый индекс (опционально)': {
		'ru': 'почтовый индекс (опционально)',
		'uk': 'поштовий индекс (опционально)',
		'en': 'postal code (optional)',
		'de': 'postal code (optional)',
		'vi': 'postal code (optional)',
		'th': 'postal code (optional)'
	},
	'город (опционально)': {
		'ru': 'город (опционально)',
		'uk': 'місто (опционально)',
		'en': 'city (optional)',
		'de': 'city (optional)',
		'vi': 'city (optional)',
		'th': 'city (optional)'
	},
	'комментарий, любая дополнительная текстовая информация (опционально)': {
		'ru': 'комментарий, любая дополнительная текстовая информация (опционально)',
		'uk': 'коментар, будь-яка додаткова текстова інформація (опціонально)',
		'en': 'comment, any additional text information (optional)',
		'de': 'comment, any additional text information (optional)',
		'vi': 'comment, any additional text information (optional)',
		'th': 'comment, any additional text information (optional)'
	},
	'URL, на которую следует перенаправить клиента после приема заказа ...': {
		'ru': 'URL, на которую следует перенаправить клиента после приема заказа (опционально)',
		'uk': 'URL, на яку слід перенаправити клієнта після прийому замовлення (опціонально)',
		'en': 'URL to redirect client to after ordering (optional)',
		'de': 'Auf diese URL werden Kunden nach der Bestellung weitergeleitet (optional)',
		'vi': 'URL nơi mà khách hàng nên được chuyển hướng sau khi nhận đơn hàng (tùy chọn)',
		'th': 'URLซึ่งลูกค้าควรจะถูกตั้งค่าให้เวบไซต์เปลี่ยนหน้าเองอัตโนมัติเมื่อมีการเรียกใช้URLภายหลังการรับคำสั่งซื้อ(ทำหรือไม่ทำก็ได้)'
	},
	'В случае успеха, система ответит кодом': {
		'ru': 'В случае успеха, система ответит кодом',
		'uk': 'У разі успіху система відповість кодом',
		'en': 'If success system will return code',
		'de': 'Im Erfolgsfall antwortet das System mit dem Code',
		'vi': 'Nếu thành công, hệ thống sẽ trả lời bằng mã',
		'th': 'ถ้าสำเร็จ ระบบจะส่งรหัสให้'
	},
	'(в случае редиректа - 302), иначе': {
		'ru': '(в случае редиректа - 302), иначе',
		'uk': '(у разі редиректу - 302), інакше',
		'en': '(in case of redirect - 302), else',
		'de': '(im Falle des „schlechten“ Redirects - 302)',
		'vi': '(trong trường hợp chuyển hướng - 302), nếu không',
		'th': 'หรือ(ในกรณีของการตั้งค่าให้เวบไซต์เปลี่ยนหน้าเองอัตโนมัติ-302)'
	},
	'и в теле ответа будет перечень ошибок валидации.': {
		'ru': 'и в теле ответа будет перечень ошибок валидации.',
		'uk': 'і у тілі відповіді буде перелік помилок валідації.',
		'en': 'and list of validation errors in body.',
		'de': 'und im Körper wird eine Liste von Validierungsfehlern.',
		'vi': 'và trong nội dung phản hồi sẽ có danh sách các lỗi xác nhận.',
		'th': 'และร่างคำตอบจะประกอบไปด้วยรายการความผิดพลาดตามกระบวนการตรวจสอบซอฟแวร์'
	},
	'Также опционально можно передавать до 5-и саб-идентификаторов (sid1, sid2…, sid5).': {
		'ru': 'Также опционально можно передавать до 5-и саб-идентификаторов (sid1, sid2…, sid5).',
		'uk': 'Також опціонально можна передавати до 5 саб-ідентифікаторів (sid1, sid2 ..., sid5).',
		'en': 'Optionally, could be sent up to 5 sub-ids (sid1, sid2…, sid5).',
		'de': 'Optional können Sie auch bis zu 5 Sub-IDs übertragen (sid1, sid2…, sid5).',
		'vi': 'Ngoài ra, có thể truyền tùy chọn lên đến 5 tiểu nhận dạng (sid1, sid2 ..., sid5).',
		'th': 'ยังมีทางเลือกของป้ายหรือเครื่องหมายที่กำหนดให้แทนอุปกรณ์ ตัวแปรหรืออื่นๆในชุดคำสั่งย่อย5แบบ (sid1-sid5)ซึ่งสามารถถูกส่งข้อมูลออกไปได้'
	},
	'Петр': { 'ru': 'Петр', 'uk': 'Петро', en: 'John', de: 'Peter', vi: 'Peter', th: 'ปีเตอร์' },
	'Подключите систему в профиле': {
		'ru': 'Подключите систему в профиле',
		'uk': 'Підключіть систему у профілі',
		'en': 'Add payout system in profile',
		'de': 'Auszahlungssystem zum Profil hinzufügen',
		'vi': 'Kết nối hệ thống trong hồ sơ của bạn',
		'th': 'เชื่อมระบบไปยังประวัติ'
	},
	'Для отправки с веб-страницы (лендинга), опишите форму заказа с помощью HTML ...': {
		'ru': 'Для отправки с веб-страницы (лендинга), опишите форму заказа с помощью HTML, чтобы она содержала все необходимые поля.',
		'uk': 'Для відправки з веб-сторінки (лендингу) опишіть форму замовлення за допомогою HTML, щоб вона містила всі необхідні поля.',
		'en': 'To send from web-page create order form in HTML with all required fields.',
		'de': 'Um aus der Webseite (Landing) zu senden, erstellen Sie ein Bestellformular in HTML mit allen Pflichtfeldern.',
		'vi': 'Để gửi từ trang web (landing), hãy mô tả mẫu đơn đặt hàng nhờ HTML để nó có tất cả các dòng cần thiết.',
		'th': 'สำหรับการส่งจากหน้าเว็บ จงเขียนบรรยายรูปแบบคำสั่งซื้อสินค้าโดยใช้HTMLโดยระบุช้อมูลสำคัญ'
	},
	'Пример:': {
		'ru': 'Пример:',
		'uk': 'Приклад:',
		'en': 'For example:',
		'de': 'Zum Beispiel:',
		'vi': 'Ví dụ:',
		'th': 'ตัวอย่าง'
	},
	January: {
		'ru': 'Январь',
		'uk': 'Січень',
		'en': 'January',
		'de': 'Januar',
		'vi': 'Tháng một',
		'th': 'มกราคม'
	},
	February: {
		'ru': 'Февраль',
		'uk': 'Лютий',
		'en': 'February',
		'de': 'Februar',
		'vi': 'Tháng hai',
		'th': 'กุมภาพันธ์'
	},
	March: {
		'ru': 'Март',
		'uk': 'Березень',
		'en': 'March',
		'de': 'März',
		'vi': 'Tháng ba',
		'th': 'มีนาคม'
	},
	April: {
		'ru': 'Апрель',
		'uk': 'Квітень',
		'en': 'April',
		'de': 'April',
		'vi': 'Tháng tư',
		'th': 'เมษายน'
	},
	May: {
		'ru': 'Май',
		'uk': 'Травень',
		'en': 'May',
		'de': 'Mai',
		'vi': 'Tháng năm',
		'th': 'พฤษภาคม'
	},
	June: {
		'ru': 'Июнь',
		'uk': 'Червень',
		'en': 'June',
		'de': 'Juni',
		'vi': 'Tháng sáu',
		'th': 'มิถุนายน'
	},
	July: {
		'ru': 'Июль',
		'uk': 'Липень',
		'en': 'July',
		'de': 'Juli',
		'vi': 'Tháng bảy',
		'th': 'กรกฏาคม'
	},
	August: {
		'ru': 'Август',
		'uk': 'Серпень',
		'en': 'August',
		'de': 'August',
		'vi': 'Tháng tám',
		'th': 'สิงหาคม'
	},
	September: {
		'ru': 'Сентябрь',
		'uk': 'Вересень',
		'en': 'September',
		'de': 'September',
		'vi': 'Tháng chín',
		'th': 'กันยายน'
	},
	October: {
		'ru': 'Октябрь',
		'uk': 'Жовтень',
		'en': 'October',
		'de': 'Oktober',
		'vi': 'Tháng mười',
		'th': 'ตุลาคม'
	},
	November: {
		'ru': 'Ноябрь',
		'uk': 'Листопад',
		'en': 'November',
		'de': 'November',
		'vi': 'Tháng mười một',
		'th': 'พฤศจิกายน'
	},
	December: {
		'ru': 'Декабрь',
		'uk': 'Грудень',
		'en': 'December',
		'de': 'Dezember',
		'vi': 'Tháng mười hai',
		'th': 'ธันวาคม'
	},
	'Дата рождения': {
		'ru': 'Дата рождения',
		'uk': 'Дата рождения',
		'en': 'Date of birth',
		'de': 'Geburtsdatum',
		'vi': 'Ngày sinh',
		'th': 'วันเกิด'
	},
	'День рождения': {
		'ru': 'День рождения',
		'uk': 'День рождения',
		'en': 'Birthday',
		'de': 'Geburtstag',
		'vi': 'Ngày sinh',
		'th': 'วันเกิด'
	},
	'День': { 'ru': 'День', 'uk': 'День', en: 'Day', de: 'Tag', vi: 'Ngày', th: 'วัน' },
	'Месяц': {
		'ru': 'Месяц',
		'uk': 'Місяць',
		'en': 'Month',
		'de': 'Monat',
		'vi': 'Tháng',
		'th': 'เดือน'
	},
	'Год': { 'ru': 'Год', 'uk': 'Рік', en: 'Year', de: 'Jahr', vi: 'Năm', th: 'ปี' },
	'List of affiliates': {
		'ru': 'К списку вебмастеров',
		'uk': 'До списку вебмайстрів',
		'en': 'To the list of webmasters',
		'de': 'Zur Liste der Webmaster',
		'vi': 'Chuyển đến danh sách thợ web',
		'th': 'ถึงรายชื่อผู้ที่มีหน้าที่รับผิดชอบดูแลเวบไซต์'
	},
	'Affiliate profile': {
		'ru': 'В карточку партнера',
		'uk': 'У картку партнера',
		'en': 'To the affiliate profile',
		'de': 'Zum Affiliate-Profil',
		'vi': 'Tới thẻ đối tác',
		'th': 'ถึงบัตรของหุ้นส่วน'
	},
	'Affiliate ticket': {
		'ru': 'К тикету партнера',
		'uk': 'До тікета партнера',
		'en': 'To the affiliate ticket',
		'de': 'Zum Affiliate-Ticket',
		'vi': 'Tới ticket của đối tác',
		'th': 'ถึงหมายเลขของหุ้นส่วน'
	},
	'Оставить отзыв': {
		'ru': 'Оставить отзыв',
		'uk': 'Залишити відгук',
		'en': 'Send feedback',
		'de': 'Feedback senden',
		'vi': 'Để lại nhận xét',
		'th': 'ให้คำตอบรับ'
	},
	'Ваш отзыв': {
		'ru': 'Ваш отзыв',
		'uk': 'Ваш відгук',
		'en': 'Your feedback',
		'de': 'Ihr Feedback',
		'vi': 'Nhận xét của bạn',
		'th': 'คำตอบรับของคุณ'
	},
	'Отправить': {
		'ru': 'Отправить',
		'uk': 'Надіслати',
		'en': 'Submit',
		'de': 'Senden',
		'vi': 'Gửi',
		'th': 'ส่ง'
	},
	'Довольны ли Вы работой службы поддержки?': {
		'ru': 'Довольны ли Вы работой службы поддержки?',
		'uk': 'Чи задоволені Ви роботою служби підтримки?',
		'en': 'Are you satisfied with the support service?',
		'de': 'Sind Sie mit dem Support-Service zufrieden?',
		'vi': 'Bạn có hài lòng với dịch vụ hỗ trợ không?',
		'th': 'คุณพอใจกับบริการให้ความช่วยเหลือหรือไม่'
	},
	Nickname: {
		'ru': 'Никнейм',
		'uk': 'Никнейм',
		'en': 'Nickname',
		'de': 'Nickname',
		'vi': 'Tên nick',
		'th': 'ชื่อเล่น'
	},
	'Промокод': {
		'ru': 'Промокод',
		'uk': 'Промокод',
		'en': 'Promocode',
		'de': 'Aktionscode',
		'vi': 'Mã khuyến mại',
		'th': 'รหัสโปรโมชัน'
	},
	'Промокод ': {
		'ru': 'Промокод',
		'uk': 'Промокод',
		'en': 'Promocode',
		'de': 'Promocode',
		'vi': 'Promocode',
		'th': 'Promocode'
	},
	'Действует до': {
		'ru': 'Действует до',
		'uk': 'Дійсне до',
		'en': 'Valid until',
		'de': 'Valid until',
		'vi': 'Valid until',
		'th': 'Valid until'
	},
	'Реф ссылка ': {
		'ru': 'Реф ссылка ',
		'uk': 'Реф посилання ',
		'en': 'Ref. link ',
		'de': 'Ref. link ',
		'vi': 'Ref. link ',
		'th': 'Ref. link '
	},
	'Активировать':{
		'ru': 'Активировать',
		'uk': 'Активувати',
		'en': 'Activate',
		'de': 'Aktivieren',
		'vi': 'Kích hoạt',
		'th': 'กระตุ้น'
	},
	'Запрос по промокоду отправлен!':{
		'ru': 'Запрос по промокоду отправлен!',
		'uk': 'Запит на промокод відправлений!',
		'en': 'Promocode request sent!',
		'de': 'Anfrage für Aktionscode gesendet!',
		'vi': 'Yêu cầu mã khuyến mại được gửi!',
		'th': 'ส่งคำขอรหัสส่งเสริมการขายแล้ว!'
	},
	'Активация промокода':{
		'ru': 'Активация промокода',
		'uk': 'Активація промокоду',
		'en': 'Activation of the promo code',
		'de': 'Aktivierung des aktionscodes',
		'vi': 'Kích hoạt mã khuyến mại',
		'th': 'การเปิดใช้งานรหัสโปรโมชัน!'
	},
	'Should not be empty':{
		'ru': 'Не должно быть пустым',
		'uk': 'Не повинно бути порожнім',
		'en': 'Should not be empty',
		'de': 'Sollte nicht leer sein',
		'vi': 'Không được để trống',
		'th': 'ไม่ควรว่างเปล่า'
	},
	'Promo code request can\'t be sent twice':{
		'ru': 'Промо-код не может быть отправлен дважды',
		'uk': 'Промо-код не може бути відправлен двічі',
		'en': 'Promo code request can\'t be sent twice',
		'de': 'Promo-Code-Anfrage kann nicht zweimal gesendet werden',
		'vi': 'Không thể gửi yêu cầu mã khuyến mại hai lần',
		'th': 'คำขอรหัสโปรโมชันไม่สามารถส่งได้สองครั้ง'
	},
	'should pass "existingAffiliatesThreads" keyword validation':{
		'ru': 'Промо-код не может быть отправлен дважды',
		'uk': 'Промо-код не може бути відправлен двічі',
		'en': 'Promo code request can\'t be sent twice',
		'de': 'Promo-Code-Anfrage kann nicht zweimal gesendet werden',
		'vi': 'Không thể gửi yêu cầu mã khuyến mại hai lần',
		'th': 'คำขอรหัสโปรโมชันไม่สามารถส่งได้สองครั้ง'
	},
	"should pass \"existingPromocode\" keyword validation":{
		'ru': 'Промокод не существует или просрочен',
		'uk': 'Промокод не існує або прострочений',
		'en': 'Promotional code does not exist or expired',
		'de': 'Aktionscode existiert nicht oder ist nicht abgelaufen',
		'vi': 'Mã khuyến mại không tồn tại hoặc đã hết hạn',
		'th': 'รหัสส่งเสริมการขายไม่มีอยู่หรือหมดอายุแล้ว'
	},
	"should pass \"existingPromoCode\" keyword validation":{
		'ru': 'Промо-код не существует',
		'uk': 'Промо-код не існує',
		'en': 'Promotional code does not exist',
		'de': 'Promotional code does not exist',
		'vi': 'Promotional code does not exist',
		'th': 'Promotional code does not exist'
	},
	'Ввести промокод':{
		'ru': 'Ввести промокод',
		'uk': 'Ввести промокод',
		'en': 'Enter promocode',
		'de': 'Gutscheincode eingeben',
		'vi': 'Nhập mã khuyến mại',
		'th': 'ป้อนรหัสส่งเสริมการขาย'
	},
	'Ваш менеджер:':{
		'ru': 'Ваш менеджер:',
		'uk': 'Ваш менеджер:',
		'en': 'Your manager:',
		'de': 'Dein Manager:',
		'vi': 'Quản lý của bạn:',
		'th': 'ผู้จัดการของคุณ:'
	},
	'Бета версия перевода, сообщайте баги в тикеты': {
		'ru': 'Бета версия перевода, сообщайте баги в тикеты',
		'uk': 'Бета версія перекладу, повідомляйте баги в тікеті',
		'en': 'Beta version of the translation, report bugs in tickets',
		'de': 'Beta-Version der Übersetzung, melden Bugs in Tickets',
		'vi': 'Phiên bản bản dịch Beta, hãy thông báo lỗi trong ticket',
		'th': 'รูปแบบซอฟแวร์ที่อยู่ในช่วงการตรวจสอบความผิดพลาดต่างๆ รายงานปัญหาที่เกิดขึ้นกับโปรแกรมในหมายเลขที่ให้มา'
	},
	'Уточнение перевода для': {
		'ru': 'Уточнение перевода для',
		'uk': 'Уточнення перекладу для',
		'en': 'Improve translation for',
		'de': 'Übersetzung verbessern für',
		'vi': 'điều chỉnh bản dịch cho',
		'th': 'การตรวจสอบคำแปลแปลสำหรับ'
	},
	'NEW!': { 'ru': 'NEW!', 'uk': 'NEW!', en: 'NEW!', de: 'NEU!', vi: 'MỚI!', th: 'ใหม่!' },
	'new': {
		'ru': 'Новая',
		'uk': 'Нова',
		'en': 'New',
		'de': 'Neu',
		'vi': 'Mới',
		'th': 'ใหม่'
	},
	'Устанавливайте наше приложение Everad': {
		'ru': 'Устанавливайте наше приложение Everad',
		'uk': 'Встановлюйте наш додаток Everad',
		'en': 'Install our Everad application',
		'de': 'Installieren sie unsere Everad anwendung',
		'vi': 'Cài đặt ứng dụng Everad của chúng tôi',
		'th': 'ติดตั้งโปรแกรม Everad ของเรา'
	},
	'Все права защищены': {
		'ru': 'Все права защищены',
		'uk': 'Усі права захищені',
		'en': 'All rights reserved',
		'de': 'Alle rechte vorbehalten',
		'vi': 'Tất cả các quyền được bảo lưu.',
		'th': 'สงวนลิขสิทธิ์'
	},
	'О компании': {
		'ru': 'О компании',
		'uk': 'Про компанію',
		'en': 'About company',
		'de': 'Über das unternehmen',
		'vi': 'Giới thiệu về chúng tôi',
		'th': 'เกี่ยวกับเรา'
	},
	'Политика конфиденциальности': {
		'ru': 'Политика конфиденциальности',
		'uk': 'Політика конфіденційності',
		'en': 'Privacy policy',
		'de': 'Datenschutzerklärung',
		'vi': 'Chính sách Bảo mật',
		'th': 'นโยบายส่วนบุคคล'
	},
	'Правовая информация': {
		'ru': 'Правовая информация',
		'uk': 'Правова інформація',
		'en': 'Legal information',
		'de': 'Rechtliche Informationen',
		'vi': 'Thông tin pháp lý',
		'th': 'ข้อมูลทางกฎหมาย'
	},
	'Модель продаж': {
		'ru': 'Модель продаж',
		'uk': 'Модель продажу',
		'en': 'Sale model',
		'de': 'Verkaufsmodell',
		'vi': 'Mô hình bán hàng',
		'th': 'รูปแบบการขาย'
	},
	'Выберите язык': {
		'ru': 'Выберите язык',
		'uk': 'Оберіть мову',
		'en': 'Choose language',
		'de': 'Wählen sie ihre sprache',
		'vi': 'Chọn ngôn ngữ của bạn',
		'th': 'เลือกภาษาของคุณ'
	},
	'Выберите валюту': {
		'ru': 'Выберите валюту',
		'uk': 'Оберіть валюту',
		'en': 'Select currency',
		'de': 'Währung auswählen',
		'vi': 'Chọn đơn vị tiền tệ',
		'th': 'เลือกสกุลเงิน'
	},
	'Выберите дату': {
		'ru': 'Выберите дату',
		'uk': 'Оберіть дату',
		'en': 'Select a date',
		'de': 'Wählen sie ein Datum',
		'vi': 'Chọn một ngày',
		'th': 'เลือกวันที่'
	},
	'moved hold to balance': {
		'ru': 'перевод баланса в холд',
		'uk': 'переказ балансу на холд',
		'en': 'moved hold to balance',
		'de': 'Balance Transfer zum Halten',
		'vi': 'cân bằng chuyển giao để giữ',
		'th': 'ย้ายไปให้สมดุล'
	},
	'moved balance to hold': {
		'ru': 'перевод холда в баланс',
		'uk': 'переказ холда на баланс',
		'en': 'moved balance to hold',
		'de': 'Übertragung des Hold auf die Balance',
		'vi': 'chuyển khoản Giữ sang số dư',
		'th': 'ย้ายยอดคงเหลือไว้'
	},
	SubID: null,
	'SID 1': null,
	SID1: null,
	'SID 2': null,
	SID2: null,
	'SID 3': null,
	SID3: null,
	'SID 4': null,
	SID4: null,
	'SID 5': null,
	SID5: null,
	crl: null,
	SID: null,
	Email: null,
	Skype: null,
	Telegram: null,
	id: null,
	'Аналитика': {
		'ru': 'Аналитика',
		'uk': 'Аналітика',
		'en': 'Analitycs',
		'de': 'Analytik',
		'vi': 'Phân tích',
		'th': 'การวิเคราะห์'
	},
	'Предварительных заказов': {
		'ru': 'Предварительных заказов',
		'uk': 'Попередніх замовлень',
		'en': 'Preliminary orders',
		'de': 'Vorläufige Bestellungen',
		'vi': 'Đơn đặt hàng sơ bộ',
		'th': 'คำสั่งเบื้องต้น'
	},
	'Подтвержденных заказов': {
		'ru': 'Подтвержденных заказов',
		'uk': 'Підтверджених замовлень',
		'en': 'Confirmed orders',
		'de': 'Bestätigte Bestellungen',
		'vi': 'Xác nhận đơn đặt hàng',
		'th': 'ยืนยันคำสั่งซื้อ'
	},
	'Заказов в обработке': {
		'ru': 'Заказов в обработке',
		'uk': 'Замовлень у обробці',
		'en': 'Pending orders',
		'de': 'Bestellungen in Bearbeitung',
		'vi': 'Đơn hàng đang xử lý',
		'th': 'คำสั่งซื้อในการดำเนินการ'
	},
	'По моему аккаунту': {
		'ru': 'По моему аккаунту',
		'uk': 'По моєму акаунту',
		'en': 'On my account',
		'de': 'Auf meinem Konto',
		'vi': 'Trên tài khoản của tôi',
		'th': 'ในบัญชีของฉัน'
	},
	'Общая по системе': {
		'ru': 'Общая по системе',
		'uk': 'Загальна по системі',
		'en': 'General by system',
		'de': 'System gemeinsam',
		'vi': 'Hệ thống chung',
		'th': 'ระบบทั่วไป'
	},
	'Отмененных заказов': {
		'ru': 'Отмененных заказов',
		'uk': 'Скасованих замовлень',
		'en': 'Canceled orders',
		'de': 'Stornierte Bestellungen',
		'vi': 'Đơn đặt hàng đã hủy',
		'th': 'ใบสั่งซื้อที่ถูกยกเลิก'
	},
	'Мужчин': {
		'ru': 'Мужчин',
		'uk': 'Чоловіків',
		'en': 'Men',
		'de': 'Männer',
		'vi': 'Đàn ông',
		'th': 'ผู้ชาย'
	},
	'Женщин': {
		'ru': 'Женщин',
		'uk': 'Жінок',
		'en': 'Women',
		'de': 'Frauen',
		'vi': 'Phụ nữ',
		'th': 'ผู้หญิง'
	},
	'Возраст': { 'ru': 'Возраст', 'uk': 'Вік', en: 'Age', de: 'Alter', vi: 'Tuổi', th: 'อายุ' },
	'До 20': {
		'ru': 'До 20',
		'uk': 'До 20',
		'en': 'Up to 20',
		'de': 'Bis zu 20',
		'vi': 'Lên đến 20',
		'th': 'ได้ถึง 20'
	},
	'От 82': {
		'ru': 'От 82',
		'uk': 'Від 82',
		'en': 'From 82',
		'de': 'Ab 82',
		'vi': 'Từ 82',
		'th': 'จาก 82'
	},
	'Нет данных': {
		'ru': 'Нет данных',
		'uk': 'Немає даних',
		'en': 'No data',
		'de': 'Keine Information',
		'vi': 'Không có thông tin',
		'th': 'ไม่มีข้อมูล'
	},
	'К офферу %s добавлены новые промо': {
		'ru': 'К офферу %s добавлены новые промо',
		'uk': 'До оффера %s додані нові промо.',
		'en': 'Added new promo to offer %s',
		'de': 'Neue Werbebroschüre für %s hinzugefügt',
		'vi': 'Đăng quảng cáo mới lên %s',
		'th': 'เพิ่มโปรโมชันใหม่ไปที่% s'
	},
	'Включить сплит-тест на моих потоках': {
		'ru': 'Включить сплит-тест на моих потоках',
		'uk': 'Увімкнути спліт-тест на моїх потоках',
		'en': 'Enable spit test on my campaigns',
		'de': 'Split-test für meine Kampagnen aktivieren',
		'vi': 'Bật thử nghiệm chia nhỏ trên chủ đề của tôi',
		'th': 'เปิดใช้งานการทดสอบแยกในเธรดของฉัน'
	},
	'На всех ваших компаниях по этому офферу активируется сплит-тест с использованием нового промо': {
		'ru': 'На всех ваших компаниях по этому офферу активируется сплит-тест с использованием нового промо',
		'uk': 'На всіх ваших компаніях за цим оффером буде активовано спліт-тест із використанням нового промо.',
		'en': 'Split test will be activated on all your active campaigns with this offer',
		'de': 'Split-Test wird auf alle aktiven Kampagnen mit diesem Angebot werden aktiviert',
		'vi': 'Tại tất cả các công ty của bạn, thử nghiệm chia nhỏ được kích hoạt trên phiếu mua hàng này bằng cách sử dụng một quảng cáo mới',
		'th': 'ในทุก บริษัท ของคุณการทดสอบแยกจะเปิดใช้งานในข้อเสนอพิเศษนี้โดยใช้โปรโมชันใหม่'
	},
	'Выберите таймзону': {
		'ru': 'Выберите таймзону',
		'uk': 'Оберіть таймзону',
		'en': 'Select timezone',
		'de': 'Zeitzone auswählen',
		'vi': 'Chọn múi giờ',
		'th': 'เลือกเขตเวลา'
	},
	'Скачать все одним архивом': {
		'ru': 'Скачать все одним архивом',
		'uk': 'Завантажити усе одним архівом',
		'en': 'Download all in one archive',
		'de': 'Laden sie alle dateien herunter',
		'vi': 'Tải xuống tất cả trong một kho lưu trữ',
		'th': 'ดาวน์โหลดทั้งหมดในที่เก็บเดียว'
	},
	'Скачать архивом': {
		'ru': 'Скачать архивом',
		'uk': 'Завантажити архівом',
		'en': 'Download archive',
		'de': 'Archiv herunterladen',
		'vi': 'Tải xuống kho lưu trữ',
		'th': 'ดาวน์โหลดไฟล์เก็บถาวร'
	},
	'Выберите модель продаж': {
		'ru': 'Выберите модель продаж',
		'uk': 'Оберіть модель продажу',
		'en': 'Select sale model',
		'de': 'Wählen Sie einen Verkaufsmodell aus',
		'vi': 'Chọn một mô hình bán hàng',
		'th': 'เลือกรูปแบบการขาย'
	},
	'Итого за выбранный период': {
		'ru': 'Итого за выбранный период',
		'uk': 'Разом за обраний період',
		'en': 'Total for the selected period',
		'de': 'Summe für den ausgewählten Zeitraum',
		'vi': 'Tổng cho khoảng thời gian đã chọn',
		'th': 'ยอดรวมสำหรับช่วงเวลาที่เลือก'
	},
	'Конвертация недоступна': {
		'ru': 'Конвертация недоступна',
		'uk': 'Конвертація недоступна',
		'en': 'Conversion is not available from',
		'de': 'Conversion is not available from',
		'vi': 'Conversion is not available from',
		'th': 'Conversion is not available from'
	},
	'Конвертация недоступна с X:00 до Y:00 (MCК)': {
		'ru': 'Конвертация недоступна с X:00 до Y:00 (MCК)',
		'uk': 'Конвертація недоступна з X:00 до Y:00 (МСK).',
		'en': 'Exchange is not available from X:00 to Y:00 (MSK)',
		'de': 'Exchange is not available from X:00 to Y:00 (MSK)',
		'vi': 'Exchange is not available from X:00 to Y:00 (MSK)',
		'th': 'Exchange is not available from X:00 to Y:00 (MSK)'
	},
	'На холде всего': {
		'ru': 'На холде всего',
		'uk': 'На холді всього',
		'en': 'On hold',
		'de': 'Auf hold',
		'vi': 'Tổng số Hold\'em',
		'th': 'ยอดรวมโฮลด์'
	},
	'Бонусные программы': {
		'ru': 'Предложения от партнеров',
		'uk': 'Пропозиції від партнерів',
		'en': 'Partners discounts',
		'de': 'Partners discounts',
		'vi': 'Partners discounts',
		'th': 'Partners discounts'
	},
	'ЛОВИ ПРИЯТНЫЕ УСЛОВИЯ ИСПОЛЬЗОВАНИЯ ПОЛЕЗНЫХ СЕРВИСОВ': {
		'ru': 'ЛОВИ ПРИЯТНЫЕ УСЛОВИЯ ИСПОЛЬЗОВАНИЯ ПОЛЕЗНЫХ СЕРВИСОВ',
		'uk': 'ЛОВИ ПРИЄМНІ УМОВИ ВИКОРИСТАННЯ КОРИСНИХ СЕРВІСІВ',
		'en': 'GRAB THE BEST CONDITIONS OF USEFUL PROGRAMS',
		'de': 'GRAB THE BEST CONDITIONS OF USEFUL PROGRAMS',
		'vi': 'GRAB THE BEST CONDITIONS OF USEFUL PROGRAMS',
		'th': 'GRAB THE BEST CONDITIONS OF USEFUL PROGRAMS'
	},
	'Заработано': {
		'ru': 'Заработано',
		'uk': 'Зароблено',
		'en': 'Earned',
		'de': 'Verdient',
		'vi': 'Kiếm được',
		'th': 'ที่ได้รับ'
	},
	'Отменено': {
		'ru': 'Отменено',
		'uk': 'Скасовано',
		'en': 'Canceled',
		'de': 'Abgesagt',
		'vi': 'Đã hủy',
		'th': 'ยกเลิก'
	},
	'Начислено': {
		'ru': 'Начислено',
		'uk': 'Нараховано',
		'en': 'Accrued',
		'de': 'Aufgelaufenen',
		'vi': 'Tính phí',
		'th': 'ให้เครดิตกับ'
	},
	'Списано': {
		'ru': 'Списано',
		'uk': 'Списано',
		'en': 'Withdrawed',
		'de': 'Withdrawed',
		'vi': 'Withdrawed',
		'th': 'Withdrawed'
	},
	'Выплачено': {
		'ru': 'Выплачено',
		'uk': 'Виплачено',
		'en': 'Paid',
		'de': 'Bezahlt',
		'vi': 'Trả tiền',
		'th': 'ต้องจ่าย'
	},
	'Все категории': {
		'ru': 'Все категории',
		'uk': 'Усі категорії',
		'en': 'All categories',
		'de': 'Alle Kategorien',
		'vi': 'Tất cả các loại',
		'th': 'ทุกประเภท'
	},
	'Создание выплаты': {
		'ru': 'Создание выплаты',
		'uk': 'Створення виплати',
		'en': 'Making a payment',
		'de': 'Eine zahlung leisten',
		'vi': 'Thanh toán',
		'th': 'การชำระเงิน'
	},
	'Аппрув конверсий': {
		'ru': 'Аппрув конверсий',
		'uk': 'Аппрув конверсій',
		'en': 'Conversion approve',
		'de': 'Umwandlung bestätigt',
		'vi': 'Tỷ lệ chuyển đổi',
		'th': 'อัตรา Conversion'
	},
	'Перевод с холда на баланс': {
		'ru': 'Перевод с холда на баланс',
		'uk': 'Переказ з холда на баланс',
		'en': 'Transfer from hold to balance',
		'de': 'Übertragen aus der Warteschleife zu balancieren',
		'vi': 'Dịch từ Giữ đến Số dư',
		'th': 'คำแปลจากถือเพื่อความสมดุล'
	},
	'Перевод с баланса на холд': {
		'ru': 'Перевод с баланса на холд',
		'uk': 'Переказ із балансу на холд',
		'en': 'Transfer from balance to hold',
		'de': 'Übersetzung aus dem Gleichgewicht zu halten',
		'vi': 'Dịch từ số dư sang giữ',
		'th': 'การแปลจากยอดคงค้าง'
	},
	'Отмена выплаты': {
		'ru': 'Отмена выплаты',
		'uk': 'Скасування виплати',
		'en': 'Payout rejection',
		'de': 'Auszahlung ablehnen',
		'vi': 'Từ chối thanh toán',
		'th': 'การยกเลิกการชำระเงิน'
	},
	'Возраст / пол': {
		'ru': 'Возраст / пол',
		'uk': 'Вік / стать',
		'en': 'Age / Gender',
		'de': 'Alter / Geschlecht',
		'vi': 'Tuổi / giới tính',
		'th': 'อายุ / เพศ'
	},
	'Ой': { 'ru': 'Ой', 'uk': 'Ой', en: 'Oh', de: 'Oh', vi: 'Oh', th: 'โอ้' },
	'Оставить тестовую конверсию': {
		'ru': 'Оставить тестовую конверсию',
		'uk': 'Залишити тестову конверсію',
		'en': 'Send test conversion',
		'de': 'Testumsetzung senden',
		'vi': 'Gửi chuyển đổi thử nghiệm',
		'th': 'ปล่อยให้ การแปลง ทดสอบ'
	},
	'Тестовая конверсия успешно отправлена': {
		'ru': 'Тестовая конверсия успешно отправлена',
		'uk': 'Тестова конверсія успішно відправлена',
		'en': 'Test conversion sent successfully',
		'de': 'Testkonvertierung erfolgreich gesendet',
		'vi': 'Đã chuyển thành thử nghiệm thành công',
		'th': 'ทดสอบ การแปลง สำเร็จแล้ว'
	},
	'На 7 дней или на первых 500 подтвержденных лидов': {
		'ru': 'На 7 дней или на первых 500 подтвержденных лидов',
		'uk': 'На 7 днів або на перших 500 підтверджених лідів',
		'en': 'For 7 days or first 500 approved leads',
		'de': 'Für 7 Tage oder für die ersten 500 anfälligen Ableitungen',
		'vi': 'Trong 7 ngày hoặc đối với 500 đầu tiên dễ dẫn',
		'th': 'เป็นเวลา 7 วันหรือสำหรับลูกค้าที่ยืนยันยอด 500 รายแรก'
	},
	'Все языки': {
		'ru': 'Все языки',
		'uk': 'Усі мови',
		'en': 'All languages',
		'de': 'Alle sprachen',
		'vi': 'Tất cả các ngôn ngữ',
		'th': 'ทุกภาษา'
	},
	'Спец. условия': {
		'ru': 'Спец. условия',
		'uk': 'Спец. умови',
		'en': 'Special conditions',
		'de': 'Besondere Bedingungen',
		'vi': 'Điều kiện đặc biệt',
		'th': 'สเป็ค เงื่อนไข'
	},
	'Моя': { 'ru': 'Моя', 'uk': 'Моя', en: 'My', de: 'Meine', vi: 'Của Tôi', th: 'ของฉัน' },
	'Мои': { 'ru': 'Мои', 'uk': 'Мої', en: 'My', de: 'Meine', vi: 'Của Tôi', th: 'ของฉัน' },
	'Вебмастеров': {
		'uk': 'Вебмайстрів',
		'ru': 'Вебмайстрів',
		'en': 'Affiliates',
		'de': 'Affiliate',
		'vi': 'Quản trị Website',
		'th': 'เว็บมาสเตอร์'
	},
	'Вебмастера': {
		'ru': 'Вебмастера',
		'uk': 'Вебмайстри',
		'en': 'Affiliates',
		'de': 'Affiliates',
		'vi': 'Quản lý Website',
		'th': 'เว็บมาสเตอร์'
	},
	'Вебмастер': {
		'ru': 'Вебмастер',
		'uk': 'Вебмайстр',
		'en': 'Affiliate',
		'de': 'Affiliate',
		'vi': 'Quản lý Website',
		'th': 'เว็บมาสเตอร์'
	},
	'Выберите вебмастера': {
		'ru': 'Выберите вебмастера',
		'uk': 'Оберіть вебмайстра',
		'en': 'Select an affiliate',
		'de': 'Wählen affiliate',
		'vi': 'Chọn người quản lý Web',
		'th': 'เลือกเว็บมาสเตอร์'
	},
	'Бонус': { 'ru': 'Бонус', 'uk': 'Бонус', en: 'Bonus', de: 'Bonus', vi: 'Thêm', th: 'โบนัส' },
	'Добавить вебмастера': {
		'ru': 'Добавить вебмайстра',
		'uk': 'Додати вебмайстра',
		'en': 'Add an affiliate',
		'de': 'Hinzufügen affiliate',
		'vi': 'Thêm người quản lý Web',
		'th': 'เพิ่มเว็บมาสเตอร์'
	},
	'Ваш буст': {
		'ru': 'Ваш буст',
		'uk': 'Ваш буст',
		'en': 'Your boost',
		'de': 'Ihre Schub',
		'vi': 'Tăng cường của bạn',
		'th': 'หน้าอกของคุณ'
	},
	'Буст вебмастера': {
		'ru': 'Буст вебмастера',
		'uk': 'Буст вебмайстра',
		'en': 'Affiliate\'s boost',
		'de': 'Affiliates Schub',
		'vi': 'Tăng liên kết',
		'th': 'เว็บมาสเตอร์ของบล็อก'
	},
	'Доп.телефон': {
		'ru': 'Доп.телефон',
		'uk': 'Дод.телефон',
		'en': 'Additional phone',
		'de': 'Zusätzliches Telefon',
		'vi': 'Điện thoại bổ sung',
		'th': 'โทรศัพท์เพิ่มเติม',
	},
	'Для получения возможности выплат, обратитесь в службу поддержки ДА через чат или почту для подключения вашего аккаута к агентскому кабинету Everad': {
		'ru': 'Для получения возможности выплат, обратитесь в службу поддержки ДА через чат или почту для подключения вашего аккаута к агентскому кабинету Everad',
		'uk': 'Для отримання можливості виплат, зверніться до служби підтримки ДА через чат або пошту для підключення вашого облікового запису до агентського кабінету Everad',
		'en': 'To be able to receive payouts, contact DA support through chat or mail to connect your account to Everad agent cabinet',
		'de': 'Um Auszahlungen erhalten zu können, kontaktieren Sie den DA Support per Chat oder E-Mail, um Ihr Konto mit dem Everad-Agenten zu verbinden',
		'vi': 'Để có thể nhận được khoản thanh toán, hãy liên hệ với hỗ trợ DA thông qua trò chuyện hoặc thư để kết nối tài khoản của bạn với đại lý Everad',
		'th': 'หากต้องการรับตัวเลือกการชำระเงินให้ติดต่อฝ่ายสนับสนุน YES ผ่านการแชทหรืออีเมลเพื่อเชื่อมต่อบัญชีของคุณกับสำนักงานตัวแทน Everad'
	},
	'Для получения возможности выплат вы должны быть зарегистрированы в MGID по реферальной ссылке Everad': {
		'ru': 'Для получения возможности выплат вы должны быть зарегистрированы в MGID по реферальной ссылке Everad',
		'uk': 'Для отримання можливості виплат ви повинні бути зареєстровані в MGID за посиланням Everad',
		'en': 'To be able to receive payouts, you should be registered in MGID by Everad referal link',
		'de': 'Um Auszahlungen erhalten zu können, sollten Sie in MGID von Everard Verweislink registriert sein',
		'vi': 'Để có thể nhận được khoản thanh toán, bạn phải đăng ký theo MGID bởi liên kết giới thiệu của Everard',
		'th': 'คุณจะต้องลงทะเบียนกับ MGID ที่ Everad'
	},
	general: {
		'ru': 'общий',
		'uk': 'загальний',
		'en': 'general',
		'de': 'generell',
		'vi': 'chung',
		'th': 'ทั่วไป'
	},
	novostnik: {
		'ru': 'с новостника',
		'uk': 'з новинника',
		'en': 'news feed',
		'de': 'newsletter',
		'vi': 'nguồn cấp dữ liệu tin tức',
		'th': 'novostnik'
	},
	parked_novostnik: {
		'ru': 'с паркованного новостника',
		'uk': 'з паркованого новинника',
		'en': 'parked news feed',
		'de': 'geparkter newsletter',
		'vi': 'nguồn cấp tin tức chưa sử dụng',
		'th': 'parked_novostnik'
	},
	'Активируй опцию ': {
		'ru': 'Активируй опцию ',
		'uk': 'Активуй опцію ',
		'en': 'Get max profit from your campaigns with 7 days ',
		'de': 'Aktiviere die Option ',
		'vi': 'Nhận được lợi nhuận tối đa từ chiến dịch của bạn với tính năng ',
		'th': 'เปิดใช้งานตัวเลือก'
	},
	' на 7 дней и выжми максимум профита!': {
		'ru': ' на 7 дней и выжми максимум профита!',
		'uk': ' на 7 днів і вичавлюй максимум профіту! ',
		'en': ' feature!',
		'de': ' auf 7 Tage und bekomm mehr Vorteile!',
		'vi': ' 7 ngày!',
		'th': ' เป็นเวลา 7 วันและบีบกำไรสูงสุด!'
	},
	'к базовой ставке': {
		'ru': 'к базовой ставке',
		'uk': 'до базової ставки',
		'en': 'to default payout',
		'de': 'zum Grundtarif',
		'vi': 'để mặc định thanh toán',
		'th': 'เป็นอัตราฐาน'
	},
	[
		'Опция Boost может быть активирована только при условии базовой выплаты на оффере/гео.' +
		' Если с менеджером согласован индивидуальный размер выплаты, то опция недоступна.'
	]: {
		'ru': 'Опция Boost может быть активирована только при условии базовой выплаты на оффере/гео.' +
			' Если с менеджером согласован индивидуальный размер выплаты, то опция недоступна.',
		'uk': 'Опція Boost може бути активована лише за умови базової виплати на оффер/гео.' +
			' Якщо з менеджером узгоджено індивідуальний розмір виплати, то опція недоступна.',
		'en': 'Boost option can be activated only in terms of default payout. If affiliate already agreed individual ' +
					`payout, boost option isn't available for selected offer/geo.`,
		'de': 'Die Option "Boost" kann nur vorbehaltlich der grundlegenden Auszahlung nach dem Angebot oder der ' +
					`Geoortung aktiviert sein. ` +
					'Wenn mit dem Manager die individuelle Auszahlung vereinbart ist, so ist die Option unzugänglich.',
		'vi': 'Tùy chọn Boost có thể được kích hoạt chỉ về thanh toán mặc định. Nếu liên kết đã đồng ý thanh' +
					'toán cá nhân, tùy chọn tăng không có sẵn cho phiếu mua hàng / địa lý được chọn.',
		'th': 'ตัวเลือก Boost สามารถใช้ได้เฉพาะเมื่อมีการจ่ายเงินขั้นพื้นฐานอยู่ในบัญชี / geo หากขนาดการจ่ายเงินของแต่ละบุคคลตกลงกับผู้จัดการแล้วตัวเลือกนี้จะใช้ไม่ได้'
	},
	'Поиск': {
		'ru': 'Поиск',
		'uk': 'Пошук',
		'en': 'Search',
		'de': 'Suchen',
		'vi': 'Tìm',
		'th': 'ค้นหา'
	},

	'Вы уверены, что хотите скопировать свои ставки этому вебмастеру по всем офферам? Его текущие ставки сбросятся.': {
		'ru':
			'Вы уверены, что хотите скопировать свои ставки этому вебмастеру по всем офферам? Его текущие ставки сбросятся.',
		'uk':
			'Ви впевнені, що хочете скопіювати свої ставки цьому вебмайстру за всіма офферами? Його поточні ставки скинуться.',
		'en': 'Are you sure you want to copy your payout terms to this affiliate for all offers?' +
			' His current payouts will be reset.',
		'de': 'Möchten Sie Ihre Auszahlungsbedingungen wirklich für alle Angebote an diesen Partner kopieren?' +
		' Seine aktuellen Auszahlungen werden zurückgesetzt.',
		'vi': 'Bạn có chắc chắn muốn sao chép các điều khoản thanh toán của mình cho' +
		' liên kết này cho tất cả các phiếu mua hàng không?' +
		' Khoản thanh toán hiện tại của anh ta sẽ được đặt lại.',
		'th': 'คุณแน่ใจหรือไม่ว่าคุณต้องการคัดลอกเดิมพันของคุณไปยังเว็บมาสเตอร์นี้ทั้งหมด เดิมพันปัจจุบันของเขาจะถูกรีเซ็ต'
	},
	'Вы уверены, что хотите скопировать свои ставки этому вебмастеру по офферу %s? Его текущие ставки сбросятся.': {
		'ru': 'Вы уверены, что хотите скопировать свои ставки этому вебмастеру по офферу %s? Его текущие ставки сбросятся.',
		'uk': 'Ви впевнені, що хочете скопіювати свої ставки цьому вебмайстру за оффером %s? Його поточні ставки скинуться.',
		'en': 'Are you sure you want to copy your payout terms to this affiliate for offer %s?' +
		' His current payouts will be reset.',
		'de': 'Möchten Sie Ihre Auszahlungsbedingungen wirklich an diesen Partner für das Angebot %s kopieren?' +
		' Seine aktuellen Auszahlungen werden zurückgesetzt.',
		'vi': 'Bạn có chắc chắn muốn sao chép các điều khoản thanh toán của mình cho liên kết này để cung cấp %s không?' +
		' Khoản thanh toán hiện tại của anh ta sẽ được đặt lại.',
		'th': 'คุณแน่ใจหรือไม่ว่าต้องการคัดลอกราคาเสนอไปยังเว็บมาสเตอร์นี้สำหรับ %s? เดิมพันปัจจุบันของเขาจะถูกรีเซ็ต'
	},
	'не может быть больше чем у мастера': {
		'ru': 'не может быть больше чем у мастера',
		'uk': 'не може бути більше ніж у майстра',
		'en': `can't be bigger than master payout`,
		'de': `solche Abzüge zu etablieren ist unmöglich`,
		'vi': `không thể thiết lập các khoản thanh toán này`,
		'th': 'ไม่สามารถมีได้มากกว่านาย'
	},
	'должно быть >= 0.01': {
		'ru': 'должно быть >= 0.01',
		'uk': 'має бути >= 0.01',
		'en': 'should be >= 0.01',
		'de': 'sollte >= 0.01 sein',
		'vi': 'nên được >= 0.01',
		'th': 'ควร> 0.01'
	},
	'должно быть числом': {
		'ru': 'должно быть числом',
		'uk': 'має бути числом',
		'en': 'must be a number',
		'de': 'muss eine Nummer sein',
		'vi': 'phải là một số',
		'th': 'ต้องเป็นตัวเลข'
	},
	'Пароли не совпадают': {
		'ru': 'Пароли не совпадают',
		'uk': 'Паролі не співпадають',
		'en': 'Passwords do not match',
		'de': 'Passwörter stimmen nicht überein',
		'vi': 'Mật khẩu không khớp',
		'th': 'รหัสผ่านไม่ตรงกัน'
	},
	'Активировать boost%s': {
		'ru': 'Активировать boost%s',
		'uk': 'Активувати boost%s',
		'en': 'Activate boost%s',
		'de': 'Aktiviere boost%s',
		'vi': 'Kích hoạt tăng%s',
		'th': 'เปิดใช้งาน boost%s'
	},
	'Комиссия': {
		'ru': 'Комиссия',
		'uk': 'Комісія',
		'en': 'Commission',
		'de': 'Kommission',
		'vi': 'hoa hồng',
		'th': 'เปอร์เซ็นต์'
	},
	'комиссия': {
		'ru': 'комиссия',
		'uk': 'комісія',
		'en': 'сommission',
		'de': 'Kommission',
		'vi': 'hoa hồng',
		'th': 'เปอร์เซ็นต์'
	},
	'В старый интерфейс': {
		'ru': 'В старый интерфейс',
		'uk': 'У старий інтерфейс',
		'en': 'To old dashboard',
		'de': 'Zum alten Dashboard',
		'vi': 'Tới bảng điều khiển cũ',
		'th': 'ไปที่แดชบอร์ดเก่า'
	},
	'Бонус': {
		'ru': 'Бонус',
		'uk': 'Бонус',
		'en': 'Bonus',
		'de': 'Bonus',
		'vi': 'thưởng',
		'th': 'โบนัส'
	},
	'бонус': {
		'ru': 'бонус',
		'uk': 'бонус',
		'en': 'bonus',
		'de': 'Bonus',
		'vi': 'Thưởng',
		'th': 'โบนัส'
	},
	'Вы подтверждаете включение опции Boost для оффера %s по гео %s': {
		'ru': 'Вы подтверждаете включение опции Boost для оффера %s по гео %s.',
		'uk': 'Ви підтверджуєте включення опції Boost для оффера %s з гео %s.',
		'en': 'Please confirm Boost option activation for %s on geo %s.',
		'de': 'Bitte bestätigen Sie die Aktivierung der Boost-Option für %s auf geo %s.',
		'vi': 'Vui lòng xác nhận kích hoạt tùy chọn Boost cho %s trên địa lý %s.',
		'th': 'โปรดยืนยันการเปิดใช้งานตัวเลือก Boost สำหรับ %s ใน geo %s'
	},
	'Подтвердить': {
		'ru': 'Подтвердить',
		'uk': 'Підтвердити',
		'en': 'Approve',
		'de': 'Bestätigung',
		'vi': 'Xác nhận',
		'th': 'อนุมัติ'
	},
	'Ограничение по ГЕО': {
		'ru': 'Ограничение по ГЕО',
		'uk': 'Обмеження за ГЕО',
		'en': 'Restriction on GEO',
		'de': 'Beschränkung auf GEO',
		'vi': 'Hạn chế về GEO',
		'th': 'ข้อ จำกัด ของ GEO'
	},
	'Заявки не принимаются из следующих регионов': {
		'ru': 'Заявки не принимаются из следующих регионов',
		'uk': 'Заявки не приймаються з наступних регіонів',
		'en': 'Leads are not accepted from the following regions',
		'de': 'Anwendungen werden aus den folgenden Regionen nicht akzeptiert',
		'vi': 'Các ứng dụng không được chấp nhận từ các khu vực sau',
		'th': 'ไม่ยอมรับการสมัครจากภูมิภาคต่อไปนี้'
	},
	'Дополнительно': {
		'ru': 'Дополнительно',
		'uk': 'Додатково',
		'en': 'Advanced',
		'de': 'Fortgeschritten',
		'vi': 'Nâng cao',
		'th': 'นอกจากนี้'
	},
	'Попап \"количество заказчиков\"': {
		'ru': 'Попап "количество заказчиков"',
		'uk': 'Попап "кількість замовників"',
		'en': 'Popup "customers"',
		'de': 'Popup "Kunden"',
		'vi': 'Popup "của khách hàng"',
		'th': 'Popup "จำนวนลูกค้า"'
	},
	'Попап \"коллбэк\"': {
		'ru': 'Попап "коллбэк"',
		'uk': 'Попап "коллбек"',
		'en': 'Popup "callback"',
		'de': 'Popup "Rückruf"',
		'vi': 'Popup "gọi lại"',
		'th': 'Popup "โทรกลับ"'
	},
	'Попап при уводе мышки за экран': {
		'ru': 'Попап при уводе мышки за экран',
		'uk': 'Попап при відведенні мишки за екран',
		'en': 'Popup on mouseout',
		'de': 'Popup auf der Maus',
		'vi': 'bật lên bằng cách kéo chuột qua màn hình',
		'th': 'ป๊อปอัปโดยการลากเมาส์ไปบนหน้าจอ'
	},
	'Вы точно хотите заказать сумму %d %s на %s?': {
		'ru': 'Вы точно хотите заказать сумму %d %s на %s?',
		'uk': 'Ви точно хочете замовити суму %d %s на %s?',
		'en': 'Please confirm payout for %d %s via %s.',
		'de': 'Please confirm payout for %d %s via %s.',
		'vi': 'Please confirm payout for %d %s via %s.',
		'th': 'Please confirm payout for %d %s via %s.'
	},
	'Token is not valid': {
		'ru': 'Токен не действительный',
		'uk': 'Токен не дійсний',
		'en': 'Token is not valid',
		'de': 'Token ist nicht gültig',
		'vi': 'Mã thông báo không hợp lệ',
		'th': 'โทเคนไม่ถูกต้อง'
	},
	'Двухфакторная аутентификация': {
		'ru': 'Двухфакторная аутентификация',
		'uk': 'Двухфакторна аутентификація',
		'en': 'Two-factor authentication',
		'de': 'Zwei-Faktor-Authentifizierung',
		'vi': 'Xác thực hai yếu tố',
		'th': 'การตรวจสอบสิทธิ์แบบสองปัจจัย'
	},
	'Обезопасьте свой аккаунт с двухфакторной аутентификацией': {
		'ru': 'Обезопасьте свой аккаунт с двухфакторной аутентификацией',
		'uk': 'Забезпечте свій акаунт із двофакторною автентифікацією',
		'en': 'Secure your account with two-factor authentication',
		'de': 'Sichern Sie Ihr Konto mit Zwei-Faktor-Authentifizierung',
		'vi': 'Bảo vệ tài khoản của bạn bằng xác thực hai yếu tố',
		'th': 'รักษาความปลอดภัยบัญชีของคุณด้วยการตรวจสอบสิทธิ์แบบสองปัจจัย'
	},
	'Каждый раз, когда вы входите в свою учетную запись, вам нужен ваш пароль и код подтверждения.': {
		'ru': 'Каждый раз, когда вы входите в свою учетную запись, вам нужен ваш пароль и код подтверждения.',
		'uk': 'Щоразу, коли ви входите до свого облікового запису, вам потрібен ваш пароль та код підтвердження.',
		'en': 'Every time you log in to your account, you need your password and confirmation code.',
		'de': 'Jedes Mal, wenn Sie sich bei Ihrem Konto anmelden, benötigen Sie Ihr Passwort und Ihren Bestätigungscode.',
		'vi': 'Mỗi khi bạn đăng nhập vào tài khoản của mình, bạn cần mật khẩu và mã xác nhận.',
		'th': 'ทุกครั้งที่คุณลงชื่อเข้าใช้บัญชีของคุณคุณต้องใช้รหัสผ่านและรหัสยืนยัน'
	},
	'Начать установку': {
		'ru': 'Начать установку',
		'uk': 'Почати встановлення',
		'en': 'Start installation',
		'de': 'Starten Sie die Installation',
		'vi': 'Bắt đầu cài đặt',
		'th': 'เริ่มการติดตั้ง'
	},
	'Скачайте приложение на телефон Google Authenticator из ': {
		'ru': 'Скачайте приложение на телефон Google Authenticator из ',
		'uk': 'Завантажте додаток на телефон Google Authenticator або ',
		'en': 'Download the application to your Google Authenticator phone from ',
		'de': 'Laden Sie die Anwendung von Ihrem Google Authenticator-Telefon herunter ',
		'vi': 'Tải ứng dụng xuống điện thoại Google Authenticator của bạn từ ',
		'th': 'ดาวน์โหลดแอปพลิเคชันไปยังโทรศัพท์ Google Authenticator จาก '
	},
	' или ': {
		'ru': ' или ',
		'uk': ' або ',
		'en': ' or ',
		'de': ' oder ',
		'vi': ' hoặc ',
		'th': ' หรือ '
	},
	'В приложении выберите "Добавить Аккаунт"': {
		'ru': 'В приложении выберите "Добавить Аккаунт"',
		'uk': 'У додатку оберіть "Додати Акаунт"',
		'en': 'In the application, select "Add Account"',
		'de': 'Wählen Sie in der Anwendung "Konto hinzufügen"',
		'vi': 'Trong ứng dụng, chọn "Thêm tài khoản"',
		'th': 'ในแอปพลิเคชันเลือก "เพิ่มบัญชี"'
	},
	'Выберите "Сканировать QR код"': {
		'ru': 'Выберите "Сканировать QR код"',
		'uk': 'Виберіть "Сканувати QR код"',
		'en': 'Select "Scan QR Code"',
		'de': 'Wählen Sie "QR-Code scannen"',
		'vi': 'Chọn "Quét mã QR"',
		'th': 'เลือก "สแกน QR Code"'
	},
	'или введите секретное значение вручную:': {
		'ru': 'или введите секретное значение вручную:',
		'uk': 'або введіть секретне значення вручну:',
		'en': 'or enter a secret value manually:',
		'de': 'oder geben Sie einen geheimen Wert manuell ein:',
		'vi': 'hoặc nhập giá trị bí mật theo cách thủ công:',
		'th': 'หรือป้อนค่าลับด้วยตนเอง:'
	},
	'Введите код с приложения': {
		'ru': 'Введите код с приложения',
		'uk': 'Введіть код з додатку',
		'en': 'Enter the code from the application',
		'de': 'Geben Sie den Code aus der Anwendung ein',
		'vi': 'Nhập mã từ ứng dụng',
		'th': 'ป้อนรหัสจากแอพพลิเคชัน'
	},
	'Код подтверждения': {
		'ru': 'Код подтверждения',
		'uk': 'Код підтвердження',
		'en': 'confirmation code',
		'de': 'Geben Sie den Code aus der Anwendung ein',
		'vi': 'Nhập mã từ ứng dụng',
		'th': 'ป้อนรหัสจากแอพพลิเคชัน'
	},
	'Включить': {
		'ru': 'Включить',
		'uk': 'Увімкнути',
		'en': 'Enable',
		'de': 'Aktivieren',
		'vi': 'Bật',
		'th': 'ทำให้สามารถ'
	},
	'Двухфакторная аутентификация активирована. Сохраните коды восстановления на случай утери доступу к аутентификатору и используйте их вместо токена.': {
		'ru': 'Двухфакторная аутентификация активирована. Сохраните коды восстановления на случай утери доступу к аутентификатору и используйте их вместо токена.',
		'uk': 'Двофакторна аутентифікація активована. Збережіть коди відновлення на випадок втрати доступу до аутентифікатора та використовуйте їх замість токена.',
		'en': 'Two-factor authentication is activated. Save the recovery codes in case you lose access to the authenticator and use them instead of the token.',
		'de': 'Die Zwei-Faktor-Authentifizierung ist aktiviert. Speichern Sie die Wiederherstellungscodes, falls Sie den Zugriff auf den Authentifikator verlieren und diese anstelle des Tokens verwenden.',
		'vi': 'Xác thực hai yếu tố được kích hoạt. Lưu mã khôi phục trong trường hợp bạn mất quyền truy cập vào trình xác thực và sử dụng mã thay vì mã thông báo.',
		'th': 'มีการเปิดใช้การตรวจสอบสิทธิ์แบบสองปัจจัย บันทึกรหัสกู้คืนในกรณีที่คุณสูญเสียการเข้าถึงตัวตรวจสอบและใช้แทนโทเค็น'
	},
	'Завершить': {
		'ru': 'Завершить',
		'uk': 'Завершити',
		'en': 'Complete',
		'de': 'Fertig',
		'vi': 'Kết thúc',
		'th': 'สมบูรณ์'
	},
	'Двухфакторная аутентификация активна': {
		'ru': 'Двухфакторная аутентификация активна',
		'uk': 'Двофакторна аутентифікація активна',
		'en': 'Two-factor authentication is active',
		'de': 'Die Zwei-Faktor-Authentifizierung ist aktiv',
		'vi': 'Xác thực hai yếu tố đang hoạt động',
		'th': 'การตรวจสอบสิทธิ์แบบสองปัจจัยมีการใช้งานอยู่'
	},
	'Если на форме логина нет поля для ввода токена то пароль нужно будет вводить в формате "XXYY", где XX - ваш обычный пароль и YY - динамический токен с аутентификатора': {
		'ru': 'Если на форме логина нет поля для ввода токена то пароль нужно будет вводить в формате "XXYY", где XX - ваш обычный пароль и YY - динамический токен с аутентификатора',
		'uk': 'Якщо на формі входу немає поля для введення токена, пароль потрібно буде вводити у форматі "XXYY", де XX — ваш звичайний пароль, а YY — динамічний токен з аутентифікатора.',
		'en': 'If there is no field to enter the token on the login form, the password will need to be entered in the format "XXYY", where XX is your regular password and YY is the dynamic token from the authenticator',
		'de': 'Wenn kein Feld für die Eingabe des Tokens auf dem Login-Formular vorhanden ist, muss das Passwort im Format "XXYY" eingegeben werden, wobei XX das reguläre Passwort und YY das dynamische Token des Authentifikators ist',
		'vi': 'Nếu không có trường nào để nhập mã thông báo trên biểu mẫu đăng nhập, mật khẩu sẽ cần phải được nhập theo định dạng "XXYY", trong đó XX là mật khẩu thông thường của bạn và YY là mã thông báo động từ trình xác thực',
		'th': 'หากไม่มีฟิลด์ที่ต้องใส่โทเค็นในแบบฟอร์มการเข้าสู่ระบบรหัสผ่านจะต้องถูกป้อนในรูปแบบ "XXYY" โดยที่ XX เป็นรหัสผ่านปกติของคุณและ YY เป็นโทเค็นแบบไดนามิกจากผู้ตรวจสอบความถูกต้อง'
	},
	'Выключить': {
		'ru': 'Выключить',
		'uk': 'Вимкнути',
		'en': 'Switch off',
		'de': 'Deaktivieren',
		'vi': 'Tắt',
		'th': 'ปิด'
	},
	'Вы действительно хотите отключить двухфактурную аутентификацию?': {
		'ru': 'Вы действительно хотите отключить двухфактурную аутентификацию?',
		'uk': 'Ви дійсно хочете відключити двофакторну аутентифікацію?',
		'en': 'Are you sure you want to disable two-factor authentication?',
		'de': 'Möchten Sie die Zwei-Faktor-Authentifizierung wirklich deaktivieren?',
		'vi': 'Bạn có chắc chắn muốn tắt xác thực hai yếu tố không?',
		'th': 'คุณแน่ใจหรือไม่ว่าต้องการปิดใช้งานการตรวจสอบสิทธิ์แบบสองปัจจัย'
	},
	'Скачать': {
		'ru': 'Скачать',
		'uk': 'Завантажити',
		'en': 'Download',
		'de': 'Herunterladen',
		'vi': 'Tải về',
		'th': 'ดาวน์โหลด'
	},
	'Сохраните поток и вам отобразиться линка, на которую лить трафик': {
		'ru': 'Сохраните поток и вам отобразиться линка, на которую лить трафик',
		'uk': 'Збережіть потік, і вам відобразиться посилання, на яке потрібно направляти трафік.',
		'en': 'Save the stream and you\'ll see a link to pour traffic',
		'de': 'Speichern Sie den Stream, und Sie sehen einen Link, um den Verkehr zu verstärken',
		'vi': 'Lưu luồng và bạn sẽ thấy một liên kết để đổ lưu lượng truy cập',
		'th': 'บันทึกสตรีมและคุณจะเห็นลิงก์เพื่อเทปริมาณการเข้าชม'
	},
	'Ваша ссылка:': {
		'ru': 'Ваша ссылка:',
		'uk': 'Ваше посилання:',
		'en': 'Your link:',
		'de': 'Ihr Link:',
		'vi': 'Liên kết của bạn:',
		'th': 'ลิงก์ของคุณ:'
	},
	'Подсистема': {
		'ru': 'Подсистема',
		'uk': 'Підсистема',
		'en': 'Subsystem',
		'de': 'Teilsystem',
		'vi': 'Hệ thống con',
		'th': 'ระบบย่อย'
	},
	'по': {
		'ru': 'по',
		'uk': 'по',
		'en': 'to',
		'de': 'to',
		'vi': 'to',
		'th': 'to'
	},
	'по запросу': {
		'ru': 'по запросу',
		'uk': 'за запитом',
		'en': 'upon request',
		'de': 'auf Anfrage',
		'vi': 'theo yêu cầu',
		'th': 'ตามคำขอ'
	},
	'Индонезию': {
		'ru': 'Индонезию',
		'uk': 'Индонезію',
		'en': 'Indonesia',
		'de': 'Indonesien',
		'vi': 'Indonesia',
		'th': 'ตามคำขอ'
	},
	'Запускайте трафик на Индонезию': {
		'ru': 'Запускайте трафик на Индонезию',
		'uk': 'Запускайте трафік на Індонезію.',
		'en': 'Drive traffic to Indonesia',
		'de': 'Fahren Sie den Verkehr nach Indonesien',
		'vi': 'Tăng lưu lượng truy cập đến Indonesia',
		'th': 'ขับเคลื่อนการจราจรไปยังอินโดนีเซีย'
	},
	'Запрашивайте перевод креативов у вашего персонального менеджера': {
		'ru': 'Запрашивайте перевод креативов у вашего персонального менеджера',
		'uk': 'Запитуйте переклад креативів у вашого особистого менеджера.',
		'en': 'Request translation of creatives from your personal manager',
		'de': 'Fordern Sie bei Ihrem persönlichen Manager die Übersetzung von Motiven an',
		'vi': 'Yêu cầu bản dịch các quảng cáo từ người quản lý cá nhân của bạn',
		'th': 'ขอคำแปลโฆษณาจากผู้จัดการส่วนตัวของคุณ'
	},
	'Запросить перевод': {
		'ru': 'Запросить перевод',
		'uk': 'Запит на переклад',
		'en': 'Request a translation',
		'de': 'Fordern Sie eine Übersetzung an',
		'vi': 'Yêu cầu bản dịch',
		'th': 'ขอคำแปล'
	},
	'Для данного оффера доступен перевод ваших креативов на': {
		'ru': 'Для данного оффера доступен перевод ваших креативов на',
		'uk': 'Для цього оффера доступний переклад ваших креативів на',
		'en': 'For this offer, translation of your creatives into',
		'de': 'Für dieses Angebot Übersetzung Ihrer Motive in',
		'vi': 'Đối với ưu đãi này, hãy dịch các quảng cáo của bạn sang',
		'th': 'สำหรับข้อเสนอนี้การแปลโฆษณาของคุณเป็น'
	},
	'Не должно превышать': {
		'ru': 'Не должно превышать',
		'uk': 'Не повинно перевищувати',
		'en': 'Should not exceed',
		'de': 'Sollte nicht überschreiten',
		'vi': 'Không nên vượt quá',
		'th': 'ไม่ควรเกิน'
	},
	'Курс': {
		'ru': 'Курс',
		'uk': 'Курс',
		'en': 'Rate',
		'de': 'Rate',
		'vi': 'Rate',
		'th': 'Rate'
	},
	'Курс еще не установлен': {
		'ru': 'Курс еще не установлен',
		'uk': 'Курс ще не встановлено',
		'en': 'Exchange rate not set yet',
		'de': 'Wechselkurs noch nicht festgelegt',
		'vi': 'Tỷ giá hối đoái chưa được đặt',
		'th': 'ยังไม่ได้กำหนดอัตราแลกเปลี่ยน'
	},
	'мы покрываем комиссию': {
	'ru': 'Мы покрываем комиссию',
	'uk': 'Ми покриваємо комісію',
	'en': 'We cover the commission',
	'de': 'We cover the commission',
	'vi': 'We cover the commission',
	'th': 'We cover the commission'
},
	'Получено': {
		'ru': 'Получено',
		'uk': 'Отримано',
		'en': 'Received',
		'de': 'Received',
		'vi': 'Received',
		'th': 'Received'
	},
	'Новые промоматериалы в офферах': {
		'ru': 'Новые промоматериалы в офферах',
		'uk': 'Нові промоматеріали в офферах',
		'en': 'New promotional materials in offers',
		'de': 'New promotional materials in offers',
		'vi': 'New promotional materials in offers',
		'th': 'New promotional materials in offers'
	},
	'В ряде потоков были обновлены страницы в связи с потерей актуальности предыдущих!': {
		'ru': 'В ряде потоков были обновлены страницы в связи с потерей актуальности предыдущих!',
		'uk': 'У ряді потоків були оновлені сторінки у зв\'язку з втратою актуальності попередніх!',
		'en': 'In the number of campaigns, landings and transite pages were updated due to the loss of relevance!',
		'de': 'In the number of campaigns, landings and transite pages were updated due to the loss of relevance!',
		'vi': 'In the number of campaigns, landings and transite pages were updated due to the loss of relevance!',
		'th': 'In the number of campaigns, landings and transite pages were updated due to the loss of relevance!'
	},
	'Удаленный': {
		'ru': 'Удаленный',
		'uk': 'Видалений',
		'en': 'Deleted',
		'de': 'Deleted',
		'vi': 'Deleted',
		'th': 'Deleted'
	},
	'Устаревший': {
		'ru': 'Устаревший',
		'uk': 'Застарілий',
		'en': 'Outdated',
		'de': 'Outdated',
		'vi': 'Outdated',
		'th': 'Outdated'
	},
	'Перенаправлен': {
		'ru': 'Перенаправлен',
		'uk': 'Перенаправлений',
		'en': 'Redirected',
		'de': 'Redirected',
		'vi': 'Redirected',
		'th': 'Redirected'
	},
	'Обновленный': {
		'ru': 'Обновленный',
		'uk': 'Оновлений',
		'en': 'Updated',
		'de': 'Updated',
		'vi': 'Updated',
		'th': 'Updated'
	},
	'Добро пожаловать в Everad!': {
		'ru': 'Добро пожаловать в Everad!',
		'uk': 'Ласкаво просимо в Everad!',
		'en': 'Welcome to Everad!',
		'de':  'Welcome to Everad!',
		'vi':  'Welcome to Everad!',
		'th':  'Welcome to Everad!'
	},
	'Активируйте вашу учетную запись!': {
		'ru': 'Активируйте вашу учетную запись!',
		'uk': 'Активуйте вашу облікову запис!',
		'en': 'Activate your account!',
		'de':  'Activate your account!',
		'vi':  'Activate your account!',
		'th':  'Activate your account!'
	},
	'Перед тем как успешно начать работать и активировать аккаунт - заполните, пожалуйста, анкету, которая поможет подобрать наилучшие офферы именно для Вас': {
		'ru': 'Перед тем как успешно начать работать и активировать аккаунт - заполните, пожалуйста, анкету, которая поможет подобрать наилучшие офферы именно для Вас',
		'uk': 'Перед тим як успішно розпочати роботу та активувати аккаунт, будь ласка, заповніть анкету, яка допоможе підібрати найкращі оффери саме для вас.',
		'en': 'Before you start working successfully and activate your account, please fill out the form that will help us choose the best offers just for you.',
		'de':  'Before you start working successfully and activate your account, please fill out the form that will help us choose the best offers just for you.',
		'vi':  'Before you start working successfully and activate your account, please fill out the form that will help us choose the best offers just for you.',
		'th':  'Before you start working successfully and activate your account, please fill out the form that will help us choose the best offers just for you.'
	},
	'Укажите нишу': {
		'ru': 'Укажите нишу',
		'uk': 'Вкажіть нішу.',
		'en': 'Specify a niche',
		'de': 'Specify a niche',
		'vi': 'Specify a niche',
		'th': 'Specify a niche'
	},
	'Укажите источник трафика': {
		'ru': 'Укажите источник трафика',
		'uk': 'Вкажіть джерело трафіку.',
		'en': 'Specify a traffic source',
		'de': 'Specify a traffic source',
		'vi': 'Specify a traffic source',
		'th': 'Specify a traffic source'
	},
	'С какими ГЕО Вы хотите работать?': {
		'ru': 'С какими ГЕО Вы хотите работать?',
		'uk': 'З якими GEO ви хочете працювати?',
		'en': 'Which GEO do you want to work with?',
		'de': 'Which GEO do you want to work with?',
		'vi': 'Which GEO do you want to work with?',
		'th': 'Which GEO do you want to work with?'
	},
	'С какими источниками трафика Вы работаете?': {
		'ru': 'С какими источниками трафика Вы работаете?',
		'uk': 'З якими джерелами трафіку ви працюєте?',
		'en': 'Which traffic sources do you work with?',
		'de': 'Which traffic sources do you work with?',
		'vi': 'Which traffic sources do you work with?',
		'th': 'Which traffic sources do you work with?'
	},
	'С какими нишами Вы бы хотели работать?': {
		'ru': 'С какими нишами Вы бы хотели работать?',
		'uk': 'З якими нішами ви хотіли б працювати?',
		'en': 'Which niches would you like to work with?',
		'de': 'Which niches would you like to work with?',
		'vi': 'Which niches would you like to work with?',
		'th': 'Which niches would you like to work with?'
	},
	'Ваш опыт работы с трафиком?': {
		'ru': 'Ваш опыт работы с трафиком?',
		'uk': 'Ваш досвід роботи з трафіком?',
		'en': 'What is your experience with traffic?',
		'de': 'What is your experience with traffic?',
		'vi': 'What is your experience with traffic?',
		'th': 'What is your experience with traffic?'
	},
	'Только начинаю': {
		'ru': 'Только начинаю',
		'uk': 'Тільки починаю',
		'en': 'Just starting',
		'de': 'Just starting',
		'vi': 'Just starting',
		'th': 'Just starting'
	},
	'Только начинаю': {
		'ru': 'Только начинаю',
		'uk': 'Тільки починаю',
		'en': 'Just starting',
		'de': 'Just starting',
		'vi': 'Just starting',
		'th': 'Just starting'
	},
	'Меньше года': {
		'ru': 'Меньше года',
		'uk': 'Меньше року',
		'en': 'Less than a year',
		'de': 'Less than a year',
		'vi': 'Less than a year',
		'th': 'Less than a year'
	},
	'1-2 года': {
		'ru': '1-2 года',
		'uk': '1-2 годи',
		'en': '1-2 years',
		'de': '1-2 years',
		'vi': '1-2 years',
		'th': '1-2 years'
	},
	'3-4 года': {
		'ru': '3-4 года',
		'uk': '3-4 роки',
		'en': '3-4 years',
		'de': '3-4 years',
		'vi': '3-4 years',
		'th': '3-4 years'
	},
	'5+ лет': {
		'ru': '5+ лет',
		'uk': '5+ років',
		'en': '5+ years',
		'de': '5+ years',
		'vi': '5+ years',
		'th': '5+ years'
	},
	'Регистрация успешна!': {
		'ru': 'Регистрация успешна!',
		'uk': 'Реєстрація успішна!',
		'en': 'You are registered!',
		'de': 'You are registered!',
		'vi': 'You are registered!',
		'th': 'You are registered!'
	},
	'Для активации аккаунта свяжитесь с вашим менеджером в Telegram или WhatsApp.': {
		'ru': 'Для активации аккаунта свяжитесь с вашим менеджером в Telegram или WhatsApp.',
		'uk': 'Для активації аккаунта зв\'яжіться з вашим менеджером у Telegram або WhatsApp.',
		'en': 'To activate your account contact the manager in Telegram or WhatsApp.',
		'de': 'To activate your account contact the manager in Telegram or WhatsApp.',
		'vi': 'To activate your account contact the manager in Telegram or WhatsApp.',
		'th': 'To activate your account contact the manager in Telegram or WhatsApp.'
	},
	'Для активации аккаунта свяжитесь с вашим менеджером в Telegram.': {
		'ru': 'Для активации аккаунта свяжитесь с вашим менеджером в Telegram.',
		'uk': 'Для активації аккаунта зв\'яжіться з вашим менеджером у Telegram.',
		'en': 'To activate your account contact the manager in Telegram.',
		'de': 'To activate your account contact the manager in Telegram',
		'vi': 'To activate your account contact the manager in Telegram.',
		'th': 'To activate your account contact the manager in Telegram.'
	},
	'Активировать в': {
		'ru': 'Активировать в',
		'uk': 'Активувати в',
		'en': 'Activate in',
		'de': 'Activate in',
		'vi': 'Activate in',
		'th': 'Activate in'
	},
	'Ваш персональный менеджер': {
		'ru': 'Ваш персональный менеджер',
		'uk': 'Ваш особистий менеджер',
		'en': 'Your personal manager',
		'de': 'Your personal manager',
		'vi': 'Your personal manager',
		'th': 'Your personal manager'
	},
	'Подтвержденная отмена': {
		'ru': 'Подтвержденная отмена',
		'uk': 'Підтверджене скасування',
		'en': 'Approved cancellation',
		'de': 'Approved cancellation',
		'vi': 'Approved cancellation',
		'th': 'Approved cancellation'
	},
	'Потоки без конверсий': {
		'ru': 'Потоки без конверсий',
		'uk': 'Потоки без конверсій',
		'en': 'Campaigns without conversions',
		'de': 'Campaigns without conversions',
		'vi': 'Campaigns without conversions',
		'th': 'Campaigns without conversions'
	},
	'%d мес.': {
		'ru': '%d мес.',
		'uk': '%d міс.',
		'en': '%d months',
		'de': '%d months',
		'vi': '%d months',
		'th': '%d months'
	},
	'Поток будет заархивирован через %d д. (нет конверсий %d мес.)': {
		'ru': 'Поток будет заархивирован через %d д. (нет конверсий %d мес.)',
		'uk': 'Потік буде заархівований через %d д. (немає конверсій %d міс.)',
		'en': 'Campaign will be archived in %d day(s) (no conversions for %d month(s))',
		'de': 'Campaign will be archived in %d day(s) (no conversions for %d month(s))',
		'vi': 'Campaign will be archived in %d day(s) (no conversions for %d month(s))',
		'th': 'Campaign will be archived in %d day(s) (no conversions for %d month(s))'
	},
	'По указанным потокам не было лидов': {
		'ru': 'По указанным потокам не было лидов от 3 до 8 месяцев. Обновите, пожалуйста, данные в потоках, либо же архивируйте их в случае ненадобности. Если по потокам все также не будет лидов, они перейдут в архивные на 9-ый месяц.',
		'uk': 'По вказаних потоках не було лідів від 3 до 8 місяців. Оновіть, будь ласка, дані в потоках або архівуйте їх у разі непотрібності. Якщо по потоках і далі не буде лідів, вони перейдуть в архівні на 9-й місяць.',
		'en': 'There were no leads for these campaigns for 3 to 8 months. Please update the data in the campaigns, or archive them if unnecessary. If there are still no leads in the campaigns, they will go to the archived ones on the 9th month.',
		'de': 'There were no leads for these campaigns for 3 to 8 months. Please update the data in the campaigns, or archive them if unnecessary. If there are still no leads in the campaigns, they will go to the archived ones on the 9th month.',
		'vi': 'There were no leads for these campaigns for 3 to 8 months. Please update the data in the campaigns, or archive them if unnecessary. If there are still no leads in the campaigns, they will go to the archived ones on the 9th month.',
		'th': 'There were no leads for these campaigns for 3 to 8 months. Please update the data in the campaigns, or archive them if unnecessary. If there are still no leads in the campaigns, they will go to the archived ones on the 9th month.'
	},
	'Активные': {
		'ru': 'Активные',
		'uk': 'Активі',
		'en': 'Active',
		'de': 'Active',
		'vi': 'Active',
		'th': 'Active'
	},
	'Архив': {
		'ru': 'Архив',
		'uk': 'Архів',
		'en': 'Archive',
		'de': 'Archive',
		'vi': 'Archive',
		'th': 'Archive'
	},
	'Потоки не активны, трафик не принимается': {
		'ru': 'Потоки не активны, трафик не принимается',
		'uk': 'Потоки неактивні, трафік не приймається.',
		'en': 'Campaigns are not active, traffic is not accepted',
		'de': 'Campaigns are not active, traffic is not accepted',
		'vi': 'Campaigns are not active, traffic is not accepted',
		'th': 'Campaigns are not active, traffic is not accepted'
	},
	'Понятно, не показывать': {
		'ru': 'Понятно, не показывать',
		'uk': 'Зрозуміло, не показувати.',
		'en': 'Clear, do not show anymore',
		'de': 'Clear, do not show anymore',
		'vi': 'Clear, do not show anymore',
		'th': 'Clear, do not show anymore'
	},
	'Напомнить позже': {
		'ru': 'Напомнить позже',
		'uk': 'Нагадати пізніше',
		'en': 'Remind me later',
		'de': 'Remind me later',
		'vi': 'Remind me later',
		'th': 'Remind me later'
	},
	'Архивировать потоки': {
		'ru': 'Архивировать потоки',
		'uk': 'Архівувати потоки',
		'en': 'Archive campaigns',
		'de': 'Archive campaigns',
		'vi': 'Archive campaigns',
		'th': 'Archive campaigns'
	},
	'Тип лида': {
		'ru': 'Тип лида',
		'uk': 'Тип ліда',
		'en': 'Lead type',
		'de': 'Lead type',
		'vi': 'Lead type',
		'th': 'Lead type'
	},
	'конкурс продлится с 21 ноября по 21 декабря!': {
		'ru': 'конкурс продлится с 21 ноября по 21 декабря!',
		'uk': 'конкурс триватиме з 21 листопада по 21 грудня!',
		'en': 'the competition will last<br/>from november 21 to december 21!',
		'de': 'the competition will last<br/>from november 21 to december 21!',
		'vi': 'the competition will last<br/>from november 21 to december 21!',
		'th': 'the competition will last<br/>from november 21 to december 21!'
	},
	'успей забрать свой профит!': {
		'ru': 'успей забрать свой профит!',
		'uk': 'встигни забрати свій прибуток!',
		'en': 'get your profit!',
		'de': 'get your profit!',
		'vi': 'get your profit!',
		'th': 'get your profit!'
	},
	'сделано %s / %s апрувов': {
		'ru': 'сделано %s / %s апрувов',
		'uk': 'зроблено %s / %s затверджень',
		'en': 'made %s / %s approval',
		'de': 'made %s / %s approval',
		'vi': 'made %s / %s approval',
		'th': 'made %s / %s approval'
	},
	'Сохраняя поток вы автоматически соглашаетесь с указанными ниже правилами': {
		'ru': 'Сохраняя поток вы автоматически соглашаетесь с указанными ниже правилами',
		'uk': 'Зберігаючи потік, ви автоматично погоджуєтеся з наведеними нижче правилами.',
		'en': 'By saving the stream, you automatically agree to the following rules',
		'de': 'By saving the stream, you automatically agree to the following rules',
		'vi': 'By saving the stream, you automatically agree to the following rules',
		'th': 'By saving the stream, you automatically agree to the following rules'
	},
	'Таргет: от 35+ лет (строго)': {
		'ru': 'Таргет: от 35+ лет (строго)',
		'uk': 'Таргет: від 35 років і старше (суворо).',
		'en': 'Target: 35+ (strictly)',
		'de': 'Target: 35+ (strictly)',
		'vi': 'Target: 35+ (strictly)',
		'th': 'Target: 35+ (strictly)'
	},
	'Подход: медицинское исследование, новостной формат, личная история и решении проблем': {
		'ru': 'Подход: медицинское исследование, новостной формат, личная история и решении проблем',
		'uk': 'Підхід: медичне дослідження, новинний формат, особиста історія та рішення проблем.',
		'en': 'Approach: medical research, news format, personal history, and problem solving',
		'de': 'Approach: medical research, news format, personal history, and problem solving',
		'vi': 'Approach: medical research, news format, personal history, and problem solving',
		'th': 'Approach: medical research, news format, personal history, and problem solving'
	},
	'Придерживание форм-фактора продукта при продвижении РК, в частности на лендинге/прелендинге': {
		'ru': 'Придерживание форм-фактора продукта при продвижении РК, в частности на лендинге/прелендинге',
		'uk': 'Дотримання форм-фактора продукту при просуванні рекламних кампаній, зокрема на лендінгах/прелендінгах.',
		'en': 'Adhering to the form factor of the product when promoting the advertising campaign, in particular on the landing/prelanding',
		'de': 'Adhering to the form factor of the product when promoting the advertising campaign, in particular on the landing/prelanding',
		'vi': 'Adhering to the form factor of the product when promoting the advertising campaign, in particular on the landing/prelanding',
		'th': 'Adhering to the form factor of the product when promoting the advertising campaign, in particular on the landing/prelanding'
	},
	'Соблюдение ценовой политики на промо-материалах, в рамках запусков РК': {
		'ru': 'Соблюдение ценовой политики на промо-материалах, в рамках запусков РК',
		'uk': 'Дотримання цінової політики на промо-матеріалах у рамках запуску РК.',
		'en': 'Compliance with the pricing policy on promotional materials, within the framework of the launches of the Republic of Kazakhstan',
		'de': 'Compliance with the pricing policy on promotional materials, within the framework of the launches of the Republic of Kazakhstan',
		'vi': 'Compliance with the pricing policy on promotional materials, within the framework of the launches of the Republic of Kazakhstan',
		'th': 'Compliance with the pricing policy on promotional materials, within the framework of the launches of the Republic of Kazakhstan'
	},
	'для согласования индивидуальных промоматериалов обратитесь к своему персональному менеджеру': {
		'ru': 'для согласования индивидуальных промоматериалов обратитесь к своему персональному менеджеру',
		'uk': 'Для узгодження індивідуальних промоматеріалів зверніться до свого особистого менеджера.',
		'en': 'in order to coordinate individual promotional materials, please contact your personal manager',
		'de': 'in order to coordinate individual promotional materials, please contact your personal manager',
		'vi': 'in order to coordinate individual promotional materials, please contact your personal manager',
		'th': 'in order to coordinate individual promotional materials, please contact your personal manager'
	},
	'Запрещено': {
		'ru': 'Запрещено',
		'uk': 'Заборонено',
		'en': 'Forbidden',
		'de': 'Forbidden',
		'vi': 'Forbidden',
		'th': 'Forbidden'
	},
	'campaign-rule-id-1': {
		'ru': 'Использование логотипов и упоминания реальных новостных ресурсов, (телевизионные, печатные, интернет) Например: Forbes, CNN, BBC и т.д.',
		'uk': 'Використання логотипів та згадок реальних новинних ресурсів (телевізійних, друкованих, інтернет), наприклад: Forbes, CNN, BBC тощо.',
		'en': 'the use of logos or mentions of real news sources (television, print, Internet). For example: Forbes, CNN, BBC etc;',
		'de': 'the use of logos or mentions of real news sources (television, print, Internet). For example: Forbes, CNN, BBC etc;',
		'vi': 'the use of logos or mentions of real news sources (television, print, Internet). For example: Forbes, CNN, BBC etc;',
		'th': 'the use of logos or mentions of real news sources (television, print, Internet). For example: Forbes, CNN, BBC etc;'
	},
	'campaign-rule-id-2': {
		'ru': 'Использование имен, рекомендаций и консультаций: специалистов общественного здравоохранения/чиновников/религиозных организаций/религиозных лидеров/имена членов королевской семьи, президента, короля, королевы.',
		'uk': 'Використання імен, рекомендацій і консультацій: фахівців громадського здоров\'я/посадовців/релігійних організацій/релігійних лідерів/імен членів королівської родини, президента, короля, королеви.',
		'en': 'the use of names, recommendations or consultations of public health professionals/officials/religious organizations/religious leaders/names of members of the royal family, President, King, Queen.',
		'de': 'the use of names, recommendations or consultations of public health professionals/officials/religious organizations/religious leaders/names of members of the royal family, President, King, Queen.',
		'vi': 'the use of names, recommendations or consultations of public health professionals/officials/religious organizations/religious leaders/names of members of the royal family, President, King, Queen.',
		'th': 'the use of names, recommendations or consultations of public health professionals/officials/religious organizations/religious leaders/names of members of the royal family, President, King, Queen.'
	},
	'campaign-rule-common-1': {
		'ru': 'Использование названия локальных министерств, институтов, ТВ передач, медучреждений, новостей,  местных знаменитостей, журналистов, имена и фото реальных врачей и т.д.',
		'uk': 'Використання назв місцевих міністерств, інститутів, телевізійних передач, медичних установ, новин, місцевих знаменитостей, журналістів, імен і фотографій реальних лікарів тощо.',
		'en': 'Using the names of local ministries, institutes, TV shows, medical institutions, news, local celebrities, journalists, names and photos of real doctors, etc.',
		'de': 'Using the names of local ministries, institutes, TV shows, medical institutions, news, local celebrities, journalists, names and photos of real doctors, etc.',
		'vi': 'Using the names of local ministries, institutes, TV shows, medical institutions, news, local celebrities, journalists, names and photos of real doctors, etc.',
		'th': 'Using the names of local ministries, institutes, TV shows, medical institutions, news, local celebrities, journalists, names and photos of real doctors, etc.'
	},
	'campaign-rule-common-2': {
		'ru': 'В случае выявления нарушений данных политик, мы будем вынуждены заблокировать средства и принимать решение о дальнейшем сотрудничестве.',
		'uk': 'У разі виявлення порушень цих політик, ми будемо змушені заблокувати кошти та приймати рішення щодо подальшої співпраці.',
		'en': 'In case a violation of these policies is detected, we will be forced to block the funds and decide on further cooperation.',
		'de': 'In case a violation of these policies is detected, we will be forced to block the funds and decide on further cooperation.',
		'vi': 'In case a violation of these policies is detected, we will be forced to block the funds and decide on further cooperation.',
		'th': 'In case a violation of these policies is detected, we will be forced to block the funds and decide on further cooperation.'
	},
	'campaign-rule-hu-1': {
		'ru': 'Использование названия венгерских министерств, институтов, передач, медучреждений, новостей и т.д.',
		'uk': 'Використання назв угорських міністерств, інститутів, передач, медичних установ, новин тощо.',
		'en': 'the use of the names of Hungarian ministries, institutes, broadcasts, medical institutions, news etc;',
		'de': 'the use of the names of Hungarian ministries, institutes, broadcasts, medical institutions, news etc;',
		'vi': 'the use of the names of Hungarian ministries, institutes, broadcasts, medical institutions, news etc;',
		'th': 'the use of the names of Hungarian ministries, institutes, broadcasts, medical institutions, news etc;'
	},
	'campaign-rule-hu-2': {
		'ru': 'Использование имена и фото венгров, особенно специалистов из медицинской сферы. Используемые личности должны быть из других стран.',
		'uk': 'Використання імен і фотографій угорців, особливо фахівців з медичної сфери. Використовувані особи повинні бути з інших країн.',
		'en': 'the use of of names and photos of Hungarians, especially specialists from the medical field. The identities used must be from other countries.',
		'de': 'the use of of names and photos of Hungarians, especially specialists from the medical field. The identities used must be from other countries.',
		'vi': 'the use of of names and photos of Hungarians, especially specialists from the medical field. The identities used must be from other countries.',
		'th': 'the use of of names and photos of Hungarians, especially specialists from the medical field. The identities used must be from other countries.'
	},
	'campaign-rule-ro-1': {
		'ru': 'Использование государственной символики государства Румынии;',
		'uk': 'Використання державної символіки Румунії;',
		'en': 'the use of the symbols of the State of Romania;',
		'de': 'the use of the symbols of the State of Romania;',
		'vi': 'the use of the symbols of the State of Romania;',
		'th': 'the use of the symbols of the State of Romania;'
	},
	'campaign-rule-ro-2': {
		'ru': 'Использование фотографий реальных румынских специалистов, врачей;',
		'uk': 'Використання фотографій реальних румунських фахівців, лікарів;',
		'en': 'the use of photos of real Romanian specialists, doctors;',
		'de': 'the use of photos of real Romanian specialists, doctors;',
		'vi': 'the use of photos of real Romanian specialists, doctors;',
		'th': 'the use of photos of real Romanian specialists, doctors;'
	},
	'campaign-rule-ro-3': {
		'ru': 'Использование названий румынских министерств, институтов, передач, медучреждений, новостей и т.д.',
		'uk': 'Використання назв румунських міністерств, інститутів, передач, медичних установ, новин тощо.',
		'en': 'the use of the names of Romanian ministries, institutes, programs, medical institutions, news etc.',
		'de': 'the use of the names of Romanian ministries, institutes, programs, medical institutions, news etc.',
		'vi': 'the use of the names of Romanian ministries, institutes, programs, medical institutions, news etc.',
		'th': 'the use of the names of Romanian ministries, institutes, programs, medical institutions, news etc.'
	},
	'campaign-rule-th-1': {
		'ru': 'Использование логотипов и упоминания реальных новостных ресурсов, (телевизионные, печатные, интернет) Например: Forbes, CNN, BBC и т.д.',
		'uk': 'Використання логотипів і згадки реальних ресурсів новин (телевізійні, друковані, інтернет) Наприклад: Forbes, CNN, BBC і т.д.',
		'en': 'the use of logos and mentions of real news sources (television, print, Internet) For example: Forbes, CNN, BBC etc;',
		'de': 'the use of logos and mentions of real news sources (television, print, Internet) For example: Forbes, CNN, BBC etc;',
		'vi': 'the use of logos and mentions of real news sources (television, print, Internet) For example: Forbes, CNN, BBC etc;',
		'th': 'the use of logos and mentions of real news sources (television, print, Internet) For example: Forbes, CNN, BBC etc;'
	},
	'campaign-rule-th-2': {
		'ru': 'Использование изображений/фотографий представителей королевской семьи, представителей существующих органов/институций, монахов, вооруженных сил;',
		'uk': 'Використання зображень/фотографій представників королівської сім\'ї, представників існуючих органів/інституцій, ченців, збройних сил;',
		'en': 'the use of images/photos of representatives of the royal family, representatives of existing institutions, monarchs, armed forces;',
		'de': 'the use of images/photos of representatives of the royal family, representatives of existing institutions, monarchs, armed forces;',
		'vi': 'the use of images/photos of representatives of the royal family, representatives of existing institutions, monarchs, armed forces;',
		'th': 'the use of images/photos of representatives of the royal family, representatives of existing institutions, monarchs, armed forces;'
	},
	'campaign-rule-th-3': {
		'ru': 'Использование изображений/фотографий врачей и любой врачебной атрибутики и медицинской символики (белые халаты, медицинское оборудование, пиктогамма сосуда Гигеи и тд).',
		'uk': 'Використання зображень/фотографій лікарів та будь-якої лікарської атрибутики та медичної символіки (білі халати, медичне обладнання, піктогама судини Гігеї тощо).',
		'en': 'the use of images/photos of doctors or any medical equipment and medical symbols (white coats, pictogram of the vessel of Gigaea etc.)',
		'de': 'the use of images/photos of doctors or any medical equipment and medical symbols (white coats, pictogram of the vessel of Gigaea etc.)',
		'vi': 'the use of images/photos of doctors or any medical equipment and medical symbols (white coats, pictogram of the vessel of Gigaea etc.)',
		'th': 'the use of images/photos of doctors or any medical equipment and medical symbols (white coats, pictogram of the vessel of Gigaea etc.)'
	},
	'Строго запрещено использовать в промо-материалах:': {
		'ru': 'Строго запрещено использовать в промо-материалах:',
		'uk': 'Суворо заборонено використовувати у промо-матеріалах:',
		'en': 'It is strictly forbidden to use in promo materials:',
		'de': 'It is strictly forbidden to use in promo materials:',
		'vi': 'It is strictly forbidden to use in promo materials:',
		'th': 'It is strictly forbidden to use in promo materials:'
	},
	'Фотографии и надписи, которые могут оскорбить ценности ислама;': {
		'ru': 'Фотографии и надписи, которые могут оскорбить ценности ислама;',
		'uk': 'Фотографії та написи, які можуть образити цінності ісламу;',
		'en': 'Pictures and inscriptions that may offend the values of Islam;',
		'de': 'Pictures and inscriptions that may offend the values of Islam;',
		'vi': 'Pictures and inscriptions that may offend the values of Islam;',
		'th': 'Pictures and inscriptions that may offend the values of Islam;'
	},
	'Упоминания Бога и Аллаха прямо или косвенно, отсылка к Корану;': {
		'ru': 'Упоминания Бога и Аллаха прямо или косвенно, отсылка к Корану;',
		'uk': 'Згадки Бога і Аллаха прямо чи опосередковано, відсилання до Корану;',
		'en': 'References to God and Allah directly or indirectly, reference to the Koran;',
		'de': 'References to God and Allah directly or indirectly, reference to the Koran;',
		'vi': 'References to God and Allah directly or indirectly, reference to the Koran;',
		'th': 'References to God and Allah directly or indirectly, reference to the Koran;'
	},
	'Использование любой религиозной символики;': {
		'ru': 'Использование любой религиозной символики;',
		'uk': 'Використання будь-якої релігійної символіки;',
		'en': 'The use of any religious symbols;',
		'de': 'The use of any religious symbols;',
		'vi': 'The use of any religious symbols;',
		'th': 'The use of any religious symbols;'
	},
	'Любые слова связанные с магией и потусторонними силами;': {
		'ru': 'Любые слова связанные с магией и потусторонними силами. К примеру, «сверхъественный», «творение», «величайший»;',
		'uk': 'Будь-які слова пов\'язані з магією та потойбічними силами. Наприклад, «надзвичайний», «творіння», «найбільший»;',
		'en': 'Any words related to magic and otherworldly powers. For example, "supernatural," "creation," and "greatest;',
		'de': 'Any words related to magic and otherworldly powers. For example, "supernatural," "creation," and "greatest;',
		'vi': 'Any words related to magic and otherworldly powers. For example, "supernatural," "creation," and "greatest;',
		'th': 'Any words related to magic and otherworldly powers. For example, "supernatural," "creation," and "greatest;'
	},
	'Упоминания правящей власти, политический деятелей, элиты и армии;': {
		'ru': 'Упоминания правящей власти, политический деятелей, элиты и армии;',
		'uk': 'Згадки правлячої влади, політичних діячів, еліти та армії;',
		'en': 'References to ruling power, politicians, the elite and the army;',
		'de': 'References to ruling power, politicians, the elite and the army;',
		'vi': 'References to ruling power, politicians, the elite and the army;',
		'th': 'References to ruling power, politicians, the elite and the army;'
	},
	'Упоминания и фото реальных звезд, известных личностей;': {
		'ru': 'Упоминания и фото реальных звезд, известных личностей;',
		'uk': 'Згадки та фото реальних зірок, відомих особистостей;',
		'en': 'Mentions and pictures of real stars and famous personalities;',
		'de': 'Mentions and pictures of real stars and famous personalities;',
		'vi': 'Mentions and pictures of real stars and famous personalities;',
		'th': 'Mentions and pictures of real stars and famous personalities;'
	},
	'Упоминания реальных врачей (их фото, имена), слов «врач», «лечить», «лекарство»;': {
		'ru': 'Упоминания реальных врачей (их фото, имена), слов «врач», «лечить», «лекарство»;',
		'uk': 'Згадки про реальних лікарів (їх фото, імена), слів «лікар», «лікувати», «ліки»;',
		'en': 'Mentions of real doctors (their photos, names), the words "doctor," "cure," and "medicine;',
		'de': 'Mentions of real doctors (their photos, names), the words "doctor," "cure," and "medicine;',
		'vi': 'Mentions of real doctors (their photos, names), the words "doctor," "cure," and "medicine;',
		'th': 'Mentions of real doctors (their photos, names), the words "doctor," "cure," and "medicine;'
	},
	'Информацию о Структуре здравоохранения и любых других Госструктур;': {
		'ru': 'Информацию о Структуре здравоохранения и любых других Госструктур;',
		'uk': 'Інформацію про Структуру охорони здоров\'я та будь-яких інших Держструктур;',
		'en': 'Information about the Health Care Structure and any other government agencies;',
		'de': 'Information about the Health Care Structure and any other government agencies;',
		'vi': 'Information about the Health Care Structure and any other government agencies;',
		'th': 'Information about the Health Care Structure and any other government agencies;'
	},
	'Копирование официальных сайтов известных новостных порталов без изменений;': {
		'ru': 'Копирование официальных сайтов известных новостных порталов без изменений;',
		'uk': 'Копіювання офіційних сайтів відомих порталів новин без змін;',
		'en': 'Copying official websites of well-known news portals without changes;',
		'de': 'Copying official websites of well-known news portals without changes;',
		'vi': 'Copying official websites of well-known news portals without changes;',
		'th': 'Copying official websites of well-known news portals without changes;'
	},
	'Описывать/упоминать свойства, которые не обозначены на упаковке товара;': {
		'ru': 'Описывать/упоминать свойства, которые не обозначены на упаковке товара;',
		'uk': 'Описувати/згадувати властивості, що не позначені на упаковці товару;',
		'en': 'Describing/mentioning properties that are not indicated on the product packaging;',
		'de': 'Describing/mentioning properties that are not indicated on the product packaging;',
		'vi': 'Describing/mentioning properties that are not indicated on the product packaging;',
		'th': 'Describing/mentioning properties that are not indicated on the product packaging;'
	},
	'Использовать фото эротического характера (обнаженные фото, части тела и тд);': {
		'ru': 'Использовать фото эротического характера (обнаженные фото, части тела и тд);',
		'uk': 'Використовувати фото еротичного характеру (оголені фото, частини тіла тощо);',
		'en': 'Use erotic photos (nude photos, body parts, etc.);',
		'de': 'Use erotic photos (nude photos, body parts, etc.);',
		'vi': 'Use erotic photos (nude photos, body parts, etc.);',
		'th': 'Use erotic photos (nude photos, body parts, etc.);'
	},
	'В Иордании строго запрещено упоминание растения «кропива» в изображениях и тексте.': {
		'ru': 'В Иордании строго запрещено упоминание растения «кропива» в изображениях и тексте.',
		'uk': 'У Йорданії суворо заборонено згадування рослини «кропива» у зображеннях та тексті.',
		'en': 'In Jordan, it is strictly forbidden to mention "nettle plant" in images and text.',
		'de': 'In Jordan, it is strictly forbidden to mention "nettle plant" in images and text.',
		'vi': 'In Jordan, it is strictly forbidden to mention "nettle plant" in images and text.',
		'th': 'In Jordan, it is strictly forbidden to mention "nettle plant" in images and text.'
	},
	'Нарушение любого из пунктов ...': {
		'ru': 'Нарушение <b>любого</b> из пунктов ведет за собой блокирование средств на счете и деактивацию аккаунта!',
		'uk': 'Порушення <b>будь-якого</b> з пунктів веде за собою блокування коштів на рахунку та деактивацію облікового запису!',
		'en': 'Violation of <b>any</b> of the points leads to the blocking of funds in the account and deactivation of the account!',
		'de': 'Violation of <b>any</b> of the points leads to the blocking of funds in the account and deactivation of the account!',
		'vi': 'Violation of <b>any</b> of the points leads to the blocking of funds in the account and deactivation of the account!',
		'th': 'Violation of <b>any</b> of the points leads to the blocking of funds in the account and deactivation of the account!'
	},
	'Поиск по id конверсии': {
		'ru': 'Поиск по id конверсии',
		'uk': 'Пошук по id конверсії',
		'en': 'Search by conversion id',
		'de': 'Search by conversion id',
		'vi': 'Search by conversion id',
		'th': 'Search by conversion id'
	},
	'лидов ты сделал за год': {
		'ru': 'лидов ты сделал за год',
		'uk': 'лідів ти зробив за рік',
		'en': 'leads you made in a year',
		'de': 'leads you made in a year',
		'vi': 'leads you made in a year',
		'th': 'leads you made in a year'
	},
	'Это на %s%% больше, чем в 2022 году': {
		'ru': 'Это на %s%% больше, чем в 2022 году',
		'uk': 'Це на %s%% більше, ніж у 2022 році',
		'en': 'that\'s %s%% more than in 2022',
		'de': 'that\'s %s%% more than in 2022',
		'vi': 'that\'s %s%% more than in 2022',
		'th': 'that\'s %s%% more than in 2022'
	},
	'денег ты заработал': {
		'ru': 'денег ты заработал',
		'uk': 'грошей ти заробив',
		'en': 'Money you\'ve earned',
		'de': 'Money you\'ve earned',
		'vi': 'Money you\'ve earned',
		'th': 'Money you\'ve earned'
	},
	'Уже придумал, на что потратишь?': {
		'ru': 'Уже придумал, на что потратишь?',
		'uk': 'Вже вигадав, на що витратиш?',
		'en': 'Have you figured out what you\'re going to spend it on?',
		'de': 'Have you figured out what you\'re going to spend it on?',
		'vi': 'Have you figured out what you\'re going to spend it on?',
		'th': 'Have you figured out what you\'re going to spend it on?'
	},
	'quid заработал': {
		'ru': 'quid заработал',
		'uk': 'quid заробив',
		'en': 'QUID you\'ve earned',
		'de': 'QUID you\'ve earned',
		'vi': 'QUID you\'ve earned',
		'th': 'QUID you\'ve earned'
	},
	'А это между прочим': {
		'ru': 'А это между прочим',
		'uk': 'А це між іншим',
		'en': 'And that\'s',
		'de': 'And that\'s',
		'vi': 'And that\'s',
		'th': 'And that\'s'
	},
	'доллар': {
		'ru': 'доллар',
		'uk': 'долар',
		'en': 'dollars',
		'de': 'dollars',
		'vi': 'dollars',
		'th': 'dollars'
	},
	'доллара': {
		'ru': 'доллара',
		'uk': 'долара',
		'en': 'dollars',
		'de': 'dollars',
		'vi': 'dollars',
		'th': 'dollars'
	},
	'долларов': {
		'ru': 'долларов',
		'uk': 'доларів',
		'en': 'dollars',
		'de': 'dollars',
		'vi': 'dollars',
		'th': 'dollars'
	},
	'Ты крут! Продолжай в том же духе!': {
		'ru': 'Ты крут! Продолжай в том же духе!',
		'uk': 'Ти крутий! Продовжуй у тому ж дусі!',
		'en': 'You\'re awesome! Keep it up!',
		'de': 'You\'re awesome! Keep it up!',
		'vi': 'You\'re awesome! Keep it up!',
		'th': 'You\'re awesome! Keep it up!'
	},
	'Хотел бы отправиться туда в новое путешествие?': {
		'ru': 'Хотел бы отправиться туда в новое путешествие?',
		'uk': 'Чи хотів би вирушити туди в нову подорож?',
		'en': 'Would you like to take a new trip there?',
		'de': 'Would you like to take a new trip there?',
		'vi': 'Would you like to take a new trip there?',
		'th': 'Would you like to take a new trip there?'
	},
	'Надеюсь, ты в таком оффере не нуждаешься!': {
		'ru': 'Надеюсь, ты в таком оффере не нуждаешься!',
		'uk': 'Сподіваюся, ти такого офери не потребуєш!',
		'en': 'I hope you don\'t need such an offer!',
		'de': 'I hope you don\'t need such an offer!',
		'vi': 'I hope you don\'t need such an offer!',
		'th': 'I hope you don\'t need such an offer!'
	},
	'Поделиться с друзьями': {
		'ru': 'Поделиться с друзьями',
		'uk': 'Поділитися з друзями',
		'en': 'Share with friends',
		'de': 'Share with friends',
		'vi': 'Share with friends',
		'th': 'Share with friends'
	},
	'Загрузка': {
		'ru': 'Загрузка',
		'uk': 'Завантаження',
		'en': 'Loading',
		'de': 'Loading',
		'vi': 'Loading',
		'th': 'Loading'
	},
	'Настройка постбека': {
		'ru': 'Настройка постбека',
		'uk': 'Налаштування постбеку',
		'en': 'Postback setup',
		'de': 'Postback setup',
		'vi': 'Postback setup',
		'th': 'Postback setup'
	},
	'Интеграция с Keitaro': {
		'ru': 'Интеграция с Keitaro',
		'uk': 'Інтеграція з Keitaro',
		'en': 'Integration with Keitaro',
		'de': 'Integration with Keitaro',
		'vi': 'Integration with Keitaro',
		'th': 'Integration with Keitaro'
	}
};



// WEBPACK FOOTER //
// ./frontend/cabinets/config/translation.js